/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Item Details page component. The component displays the Item Details page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 08/29/2020 
 */

import React, { Component } from 'react';
import Image from 'react-image-resizer';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import * as MenuAction from '../actions/MenuAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';

//WW - 1216 Precart - Yuvarani K
import * as SupplierSuggestionAction from '../actions/SupplierSuggestionAction';
import SupplierSuggestionStore from '../stores/SupplierSuggestionStore';
import * as CookieService from '../CookieService';
import * as App from '../App';
import SDIConstants from '../SDIConstants';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import NonCatalogStore from '../stores/NonCatalogStore';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import { ItemDetailAction } from '../actions/ProductReplenAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';

import swal from 'sweetalert';
//WW - 1216 Precart - Yuvarani K
import Rating from 'material-ui-rating'
import Switch from '@material-ui/core/Switch';
import Autocomplete from 'react-autocomplete';
//[09/29/22, WAL-780_PC_IDSC_01, Dhevanesam R]
import Carousel from 'better-react-carousel';
import ImageGallery from 'react-image-gallery';



//WW - 1216 Precart - Yuvarani K
let parts = [];

let TabclickTitle = "";
let SearchKeyWord = "";
let ItemImageValue = ""
let vendorId = "";
let QTYAvail = "";
let slideIndex = 1;
let rmvAttachindex = -1;
let EnersysItems = "";
let FormItems = "";
let FormFilePath = "";
let FromPageName = "";
let SearchKey = "";
let FormDataProps = [];
let FormOptionsDataProps = [];
//WW - 1216 Precart - Yuvarani K
let ImageURL = "";
let ImageFilePath = "";
let WorkOrder = "";
//WW - 1216 Precart - Yuvarani K
let ItemArray = [];
let ItemDetailsValue = [];
let pickUp = false;
let itemDetailPickup = false;
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
let mixcartfunction = false;
let fromCarthasQuoteItem = [];
const icircleItemDet = {
    width: "32px",
    top: "-1px",
    verticalAlign: "text-bottom",
    //marginBottom: "1rem!important",
    marginTop: "1rem!important",
    backgroundColor: "#f44336",
    color: "white",
    borderRadius: "50%",
    padding: "0px 7px 0px",
    fontSize: "23px",
    marginLeft: "2%",
    //paddingBottom: "6px",
}
const icircleItemTruck = {
    width: "23px",
    position: "relative",
    top: "-1px",
    marginBottom: "1rem!important",
    marginTop: "1rem!important",
    backgroundColor: "green",
    color: "white",
    borderRadius: "50%",
    padding: "4px 8px",
    fontSize: "12px",
    marginLeft: "4px",
}
//[2/16/22], WW-330, Dhevanesam R
const icircleItemBen = {
    width: "32px",
    top: "-1px",
    verticalAlign: "text-bottom",
    marginTop: "1rem!important",
    backgroundColor: "blue",
    color: "white",
    borderRadius: "50%",
    padding: "3px  8px",
    fontSize: "23px",
    marginLeft: "2%",
    paddingBottom: "3px",
}
const style = {
    image: {
        position: 'sticky !important',
        display: 'block',
        left: '0px !important',
        top: '0px !important',
        marginLeft: '40px'
    },
}
const styleE = {
    image: {
        position: 'sticky !important',
        display: 'block',
        left: '0px !important',
        top: '0px !important',
        marginLeft: '40px',
        width: '100%',
        height: '100%'

    },
}
const hei = {
    height: '290px',
    overflowY: 'auto'
}
class ItemDetailNew extends Component {
    constructor(props) {
        super(props);
        this.AddToCartResponse = this.AddToCartResponse.bind(this)
        this.FavSuccess = this.FavSuccess.bind(this)
        //[2/22/2023, Bug - 3127, Dhevanesam R]
        this.keyPressQTY = this.keyPressQTY.bind(this);
        this.imageGalleryRef = React.createRef();
        this.onImageClick = this.onImageClick.bind(this);
        this.zoomClick = this.zoomClick.bind(this);
        this.BindTabOne = this.BindTabOne.bind(this)
        this.formcheck = this.formcheck.bind(this)
        this.TradeServiceAddClick = this.TradeServiceAddClick.bind(this)
        this.EditImageResponse = this.EditImageResponse.bind(this)
        this.dynamicFormReponse = this.dynamicFormReponse.bind(this)
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this)
        const queryparam = new URLSearchParams(window.location.search)
        mixcartfunction = false;
        //const orgin = queryparam.get('Orgin')
        let orgin = this.props.location.state.Orgin
        this.state = {
            Quantityvalue: "",
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            ItemId: "-",//Item Id -- H B
            ItemNoun: "-",// Item Noun -- H
            AttributeName: "-",// Attribute name -- B
            ItemfeatureDesc: "-",// Item Feature Description -- B
            ItemClientPartNum: "-",// Item Client Part Number -- Hidden field Data
            ItemManufacturerName: "-",// Item Manufacture Name -- H B

            ItemDescription: "-",//Item Description -- H B
            ItemClient: "-",// Item Client Description -- H
            ItemGroup: "-",// Item Group -- H
            ItemCatalogPath: "-",//Item catalog Path -- H
            ItemUOM: "-",// Item unit of measure -- H
            ItemCategory: "-",// Item Category -- H
            ItemModifiers: "-",// Item Modifier -- H
            ItemMFGPartNumber: "-",// Item Manufacture Part Number -- H B
            ItemUNSPSC: "-",//Item UNSPC -- H
            ItemType: "-",// Item Type -- H
            ItemQuantityAvail: "-",//Quantity availableon hand -- B
            ItemImage: [],// Item Image -- H
            AttributeValue: "-",// Attribute Value  -- B
            ItemCurrencyCOde: "-",// Item Currency Code
            ItemSDICatagory: "",
            ExtentDescription: "-",
            shipmentmethoderrorid: "",
            ItemPrice: "-",
            ShowExtentDespPopUp: 0,
            ItemSupplierName: CookieService.getLocalStorageValues("Search_supplierName"),
            DetailreaderState: [],
            IssueChargeCode: "",
            FirstChargeCode: "",
            HazardCode: "",
            InspectionRequired: "",
            EquipmentTag: "",
            Regrind: "",
            PurchasingDept: "",
            MachineControl: "",
            DrawingCode: "",
            MachineNum: "",
            StandardLaedTime: "",
            CriticalSpare: "",
            BUItemsState: [],
            CurrentYearState: [],
            PreviousYearState: [],
            IssueState: [],
            LocDataSetState: [],
            MultiSiteDisplayState: [],
            TransTableState: [],
            StoreRoomState: [],
            PurchaseState: [],
            StoreRoomTitle: "Store Room",
            StoreRoomDespTitle: "Store Room Description",
            CriticalSpareDV: "",
            MachineNumberDV: "",
            FavItem: false,
            ItemTypeFav: "",
            FavItemIdPopUp: "",
            FavSDICatgPopUp: "-",
            FavItemDescripPopUp: "",
            FavMFGPopUp: "",
            FavMFGPartNUMPopUp: "",
            FavSupplierPopUp: "",
            txtUOMHidePopUp: "",
            txtMfgItemidHidePopUp: "",
            txtItemidHidePopUp: "",
            txtMFGHidePopUp: "",
            FavitemImage: "",
            VendorId: "",
            VendorItemid: "",
            ImageURL: "",
            ShipWIthin: "",
            PackageQuantity: "-",
            FavItemKitComponent: "",
            FavKit_Components: "",
            KIT_Components: "",
            KIT_Details: "",
            IsKit: false,
            ISCoreCharge: false,
            SAP_Article_Number: "-",
            WorkOrderNo: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "", carticonFlag: true,
            actual_qty: "",
            qtyavailable: CookieService.getLocalStorageValues("ItemDetail_QTY"),
            mfgpartstdboolean: false, mfg_part_std: "", DescriptionType: (CookieService.getLocalStorageValues("Search_Descriptiontype") != null ? CookieService.getLocalStorageValues("Search_Descriptiontype") : 1),
            //[12/22/21], PC_ID_09, WW-286, Dhevanesam R
            CheaperItem: {}, CheaperItemQty: "", ItemDetail: {}, Item_cat: "", MIN_ORD_QTY: "", CORE_CHARGE: "",
            CheapItemMinQty: "", CheapItemMaxQty: "", coreChargeBol: false, AddtocartCH: false,
            /*[01/30/22, PC_EF_04, Priyanka.D]*/
            EnersysFormVaue: "", EnersysForm: false, EnersysEmp: "", QtyDisable: false, AddtoCartBO: {},
            DueDate: "",
            //[2/28/22], PC_IC_01, WW-316, Dhevanesam R
            ImgResponseVal: [], ImgCssVal: "",
            //[09/29/22, WAL-780_PC_IDSC_01, Dhevanesam R]
            HideCarouseArrow: false,
            ColumnsCarousel: 5,
            spec_sheet: "-", doc_data_sheet: "-", doc_install_operator: "-", msds_sds: "-", doc_parts: "-", cad_drawing: "-", IsDotClick: false,
            IsFromCart: false,
            Description: "Long description", Short_desc: "", Long_Desc: "", IsDotClick: false, FavoritesSubMenu: [], SelectedValueImg: "",
            FavSubCategory: "", subCategoryResults: [], subCategory: [], SubCategoryErr: false, CategoryErr: false, autocompleteData: [], autocompleteDataRstl: [], attachmentPathArr: [], isFullScreen: false,
            imagearray: [], currentImageIndex: 0, showIndex: false,
            IsFromFav: false, attachmentErrormsg: "", attachmentPathArrImg: [], IsShopCartFav: false, AlternateParts: [], equParts: []  // ' PC_WW-641_03-Priyanka  D
            , alsoFits: [],//'[03/07/2023-PC_WW-643_14,Priyanka]
            isNonCatSearch: false, Itemdetail: [], FormData: [], FormOptionsData: [],
            EnersysFormVaue: "", EnersysForm: true, EnersysEmp: "", pickUp: false, deliveryShipTo: true, shipmentpickup: localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false,
            //WW - 1216 Precart - Yuvarani K
            IsRatingPopup: false,
            IsRateNow: true,
            StarRating: 0,
            RatingCount: 0,
            Review: "",
            ItemDetails: [],
            FiltItemValue: {}, FiltItemIndex: 0, FormData: "", FormOptionsData: "", ReasonType: "", Comments: "", AddIndex: 0, AddValue: [], cart_bypass: "", ProductRating: "", RatingCount: "",
            EnersysFormVaue: "", EnersysForm: true, EnersysEmp: "", pickUp: false, deliveryShipTo: true, shipmentpickup: localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false,
            cartConfirmationPopupTxt: "" //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        }
        cartDelete = false;

        //WW - 1216 Precart - Yuvarani K
        pickUp = localStorage.getItem("pickupcheck") == "true" ? true : false
    }

    componentDidMount() {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let value = []
        SearchKeyWord = CookieService.getLocalStorageValues("SearchKeyWord")

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        let ItemArray = "";
        //[2/28/22], PC_IC_09, WW-316, Dhevanesam R
        //[1/10/23], WW-542_PC_13, Dhevanesam R
        //[1/19/23, WW-587_PC_4, Dhevanesam R]
        //' PC_WW-641_04-Priyanka  D
        let or = this.state.isNonCatSearch

        //WW-1221
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            fromCarthasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        }

        if (this.props.location.state.Suggesstions == true) {

            //WW-522_PC_09 (12/15/2022)-Aparna
            this.laodImageItemDetails("", value, false);
        }
        else {
            if (this.props.location.state.origin == 'shoppingcart') {
                this.setState({ Quantity: this.props.location.state.QtyAdj, IsFromCart: true, IsShopCartFav: this.props.location.state.IsFav })
            }
            //else if (this.props.location.state.origin == 'favitem' || (this.props.location.state.origin == 'menu' && this.props.location.state.favType == 'menuFavItem')) {
            //    this.setState({ IsFromFav: true, FavItem: true })
            //} 
            if (this.props.location.state) {
                const queryParams = new URLSearchParams(window.location.search)

                if (this.props.location.state.IsAltPart) {
                    CookieService.updateLocalStorageValues("ItemDetail_ItemId", (this.props.location.state.Page == "TsSupplierSugg" ? this.props.location.state.ItemData.clientPartNumber : this.props.location.state.ItemId));
                    CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", (this.props.location.state.Page == "TsSupplierSugg" ? this.props.location.state.ItemData.manfPartNumber : this.props.location.state.ManufacturePartNumber));
                    CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", (this.props.location.state.Page == "TsSupplierSugg" ? this.props.location.state.ItemData.manufacturer : this.props.location.state.ManufactureName));
                    CookieService.updateLocalStorageValues("ItemDetail_SupplierID", (this.props.location.state.Page == "TsSupplierSugg" ? this.props.location.state.ItemData.vendor_id : queryParams.get('SupplierID')));
                    this.laodItemDetails(true);
                } else {
                    this.laodItemDetails();
                }
            }
        }

        //this.laodItemDetails()
        //[2/28/22], PC_IC_02, WW-316, Dhevanesam R
        this.PageItemSuggestionLoad("", value);
        // console.log("Search_VendorId",CookieService.getLocalStorageValues("Search_VendorId"))
        ItemDetailNewStore.on("TabOneResp", this.BindTabOne);
        ItemDetailNewStore.on("addToCart", this.AddToCartResponse);
        ItemDetailNewStore.on("TabClick", this.TabResponse.bind(this));
        ItemDetailNewStore.on('FavitemAdd', this.FavSuccess.bind(this));
        ItemDetailNewStore.on('CheaperItem', this.CheaperItemCheckResposne.bind(this));
        ItemDetailNewStore.on('GetRecommendedItems', this.GetRecommendedItemsResposne.bind(this));
        /*[04/18/22,PC_WW-386_07], Priyanka D */
        ItemDetailNewStore.on('NONCAT_UploadAttachments', this.loadAttachments);
        /*[04/18/22,PC_WW-386_07], Priyanka D */
        ItemDetailNewStore.on('EditResponse', this.EditImageResponse);
        /*[04/18/22,PC_WW-386_11], Priyanka D */
        //WW - 1216 Precart - Yuvarani K
        ItemDetailNewStore.on('ItemDetail_ByPass', this.CoreChargeResponseClick.bind(this));
        ItemDetailNewStore.on('EditImgSubmit', this.EditImgSubmit.bind(this));
        ItemDetailNewStore.on('DeleteItem', this.DelFavItem.bind(this));
        NonCatalogStore.on('attachmentResponse', this.FavItemloadAttachments);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        //WW - 1216 Precart - Yuvarani K
        ItemDetailNewStore.on('ItemDetail_DynamicForm', this.dynamicFormReponse);
        ItemDetailNewStore.on('RatingResponse', this.RatingResponse);
        SearchResultsStore.on('Status', this.AddToCartResponse);
        window.scrollTo(0, 0)
    }

    componentWillUnmount() {
        SearchKeyWord = ""
        CookieService.updateLocalStorageValues("ItemDetMfgPartNo", this.state.ItemMFGPartNumber);
        CookieService.updateLocalStorageValues("ItemDetMfgPartName", this.state.ItemManufacturerName);
        CookieService.updateLocalStorageValues("ItemDetVendId", this.state.ItemManufacturerName);
        CookieService.updateLocalStorageValues("ItemDetItemdata", this.props.location.state.ItemData);
        CookieService.updateLocalStorageValues("ItemDetAltData", this.state.AlternateParts);
        ItemDetailNewStore.removeListener('TabOneResp', this.BindTabOne);
        //WW - 1216 Precart - Yuvarani K
        ItemDetailNewStore.removeListener('RatingResponse', this.RatingResponse);
        SearchResultsStore.removeListener('Status', this.AddToCartResponse);
        ItemDetailNewStore.removeListener('EditResponse', this.EditImageResponse);
        ItemDetailNewStore.removeListener("addToCart", this.AddToCartResponse);
        ItemDetailNewStore.removeListener('TabClick', this.TabResponse);
        ItemDetailNewStore.removeListener('FavitemAdd', this.FavSuccess);
        ItemDetailNewStore.removeListener('CheaperItem', this.CheaperItemCheckResposne); //ISS_PC_01 (1/4/2022)- Aparna
        ItemDetailNewStore.removeListener('GetRecommendedItems', this.GetRecommendedItemsResposne);
        ItemDetailNewStore.removeListener('NONCAT_UploadAttachments', this.loadAttachments);
        ItemDetailNewStore.removeListener('EditImgSubmit', this.EditImgSubmit);
        //WW - 1216 Precart - Yuvarani K
        ItemDetailNewStore.removeListener('ItemDetail_ByPass', this.CoreChargeResponseClick);
        ItemDetailNewStore.removeListener('DeleteItem', this.DelFavItem);
        // NonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        NonCatalogStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        NonCatalogStore.removeListener('attachmentResponse', this.FavItemloadAttachments);
        //WW - 1216 Precart - Yuvarani K
        ItemDetailNewStore.removeListener('ItemDetail_DynamicForm', this.dynamicFormReponse);
    }
    dynamicFormReponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        debugger
        //WW - 1216 Precart - Yuvarani K
        let DynamicFormResData = JSON.parse(ItemDetailNewStore.ItemDetail_DynamicForm);
        let FormDataDtArr = []
        let OptionsDataDtArr = []
        if (DynamicFormResData.ErrorMessageDT != null && DynamicFormResData.ErrorMessageDT != undefined) {

            if (DynamicFormResData.ErrorMessageDT.length > 0) {

                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: DynamicFormResData.ErrorMessageDT[0].ErrorMessage
                });
                return;
            }
        }
        else {
            if (DynamicFormResData.FormDataDt != null && DynamicFormResData.FormDataDt != undefined) {
                if (DynamicFormResData.FormDataDt.length > 0) {
                    FormDataDtArr = DynamicFormResData.FormDataDt
                }
            }
            if (DynamicFormResData.OptionsDataDt != null && DynamicFormResData.OptionsDataDt != undefined) {
                if (DynamicFormResData.OptionsDataDt.length > 0) {
                    OptionsDataDtArr = DynamicFormResData.OptionsDataDt
                }
            }
        }
        FormDataProps = FormDataDtArr
        FormOptionsDataProps = OptionsDataDtArr
        this.setState({ FormData: FormDataDtArr, FormOptionsData: OptionsDataDtArr });
        let AddValue = CookieService.getLocalStorageValues("AddValue");
        let AddIndex = CookieService.getLocalStorageValues("AddIndex");
        this.AddTocart(this.state.AddValue, this.state.AddIndex, false);
    }
    //[2/28/22], PC_IC_02, WW-316, Dhevanesam R
    PageItemSuggestionLoad = (PageName, value) => {

        window.scrollTo(0, 0)
        var imgBO = {}
        console.log("d", imgBO)
        if ((this.props.location.state.Suggesstions == true && PageName == "") || this.props.location.state.IsAltPart) {

            imgBO[this.props.location.state.ItemId] = this.props.location.state.SupplierID
        }
        else if (PageName == "ItemDetails") {

            imgBO[value.ItemID] = value.VendorID
        }
        else {
            imgBO[this.props.location.state.ItemData.clientPartNumber] = this.props.location.state.ItemData.vendor_id
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        ItemDetailNewAction.GetRecommendedItems(imgBO);

    }

    //WW - 1216 Precart - Yuvarani K

    AddToCartOrFavClick = (CartOrFav, value, index, popup, Reasontype, Comments) => {
        $('#Delivery_MethodItemDetail').modal('hide');
        ItemArray = value
        //[12/15/22], PC_WW-552_FE_4, Dhevanesam R
        CookieService.updateLocalStorageValues("AddIndex", index);
        CookieService.updateLocalStorageValues("AddValue", value);
        console.error("DivisTestAddValue", CookieService.getLocalStorageValues("AddValue"))
        console.error("DivisTestOnlyValue", value)
        this.setState({ AddIndex: index, AddValue: value });

        //debugger
        let formName = "";
        if (value.AttributeName != undefined && value.AttributeName != null && value.AttributeName != "" && value.AttributeName.includes('FORM')) {
            formName = value.form.trim()
        }

        if (CartOrFav == "Add To Cart") {
            if (value.AttributeName.includes('FORM')) {
                //if (formName.toLowerCase().includes("battery") || formName.toLowerCase().includes("charger")) {
                //    FormDataProps = []
                //    FormOptionsDataProps = []
                //    this.AddToCart(value, index, false);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
                //}
                // else {
                //else {
                let dynamicFormBO = {
                    formName: formName
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ItemDetailNewAction.ItemDetail_dynamicFormData(dynamicFormBO);
            }
            //}
            else {
                FormDataProps = []
                FormOptionsDataProps = []
                this.AddTocart(ItemArray, index, popup, Reasontype, Comments)
                //WW -694_PC_04(to make sure not from core charge popup) - Aparna
            }
        }
        else {
            FormDataProps = []
            FormOptionsDataProps = []
            this.AddTocart(ItemArray, index, popup, Reasontype, Comments);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
        }
    }

    //WW - 1216 Precart - Yuvarani K

    AddTocart = (value, index, fromCorePopup, ReasonType, Comments) => {
        debugger
        const {t} = this.props
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        let hasEquipmentItem = [];
        let hasQuoteItem = [];
        mixcartfunction = true;
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        }
        //WW-694_PC_02 -Aparna
        if (value != undefined && value != null) {
            this.setState({ AddIndex: index, AddValue: value })
        } else {
            value = this.state.AddValue
            index = this.state.AddIndex
        }
        // Equipment item add to cart issue fixing - Nandhini L
        let AdjQtySupplierArray = value;
        let form = "";
        let actualQty = "";
        if (AdjQtySupplierArray.actual_qty != null && AdjQtySupplierArray.actual_qty != undefined) {
            let QuantityOnhandL = AdjQtySupplierArray.actual_qty;
            actualQty = QuantityOnhandL.split('^');
        }



        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        else if (AdjQtySupplierArray.QuantityOrdered > AdjQtySupplierArray.actual_qty && AdjQtySupplierArray.vendor_id == "W999999999") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity is Greater than the Available Quantity ')
            });
            return;
        }
        else if (AdjQtySupplierArray.QuantityOrdered == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Should Not Be Empty')
            });
            return;
        }
        else if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
            // alert('Quantity Entered Is Below The Minimum Order Quantity');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Entered Is Below The Minimum Order Quantity')
            });
            return;
        }
        else if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity Does Not Match the Minimum Order Quantity Sequence')
            });
            // alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
            return;
        }

        else if (value.AttributeValue.indexOf("BATTERY") > -1 || value.AttributeValue.indexOf("CHARGER") > -1) {
            //let EnersysFormVaue = value.AttributeValue;
            let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));

            let EnersysItem = []
            EnersysItem = CartStorage.filter((item, index) => item.Itemid == value.clientPartNumber);

            if (EnersysItem.length > 0 && EnersysItem != undefined && EnersysItem != null && EnersysItem != []) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("This")+" "+ value.form.trim() + t(" Item is already added in the cart ")
                });
                return;
            }
        }
        if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
            $('#ItemDetailMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, index: index, fromCorePopup: fromCorePopup, ReasonType: ReasonType, Comments: Comments, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            $('#ItemDetailMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, index: index, fromCorePopup: fromCorePopup, ReasonType: ReasonType, Comments: Comments, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        //WW-694_PC_02(if the method is called from core charge popup then it should not display) -Aparna
        if (value.hasCoreCharge == true && fromCorePopup == false) {
            $('#CoreChargePopUp').modal('show');
            return;
        }
        //[12/15/22], PC_WW-552_FE_10, Dhevanesam R
        else if (FormDataProps.length > 0 && FormDataProps != "" && FormDataProps != undefined && FormDataProps != []) {
            if (value.AttributeName.includes('FORM')) {
                this.CheckFormExistsInCart(value);
                let AddToCartBO = this.FormCartBO(index, ItemArray);

                //[1/11/23, WW-552, Dhevanesam R]

                // this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + EnersysFormVaue.toLowerCase() });
                // CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                //CookieService.updateLocalStorageValues("EnersysForm", true)
                //if (CookieService.getLocalStorageValues("EnersysForm") == true) {
                //    if (EnersysItems != undefined) {
                //        if ((EnersysItems.indexOf(value.clientPartNumber) == -1)) {
                //            $('#EnersysEmployee').modal('show');
                //            return;

                //        }

                //    }
                //    else {
                //        $('#EnersysEmployee').modal('show');
                //        return;
                //    }
                //}
                // }
                //else {
                //[1/20/23, PC_WW-552_FE_41, Dhevanesam R]
                if (FormItems != undefined && FormItems != null && FormFilePath != undefined && FormFilePath != null && value.form != undefined && value.form != null) {

                    if (value.form.trim() == "KENSTAN-KEY" && FormFilePath.includes("KENSTAN-KEY")) {
                        //debugger
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity"
                        });
                        FormItems = "";
                        FormFilePath = "";
                        return;
                    }
                    else {
                        let CartStorage = JSON.parse(localStorage.getItem("CartStorage")) || [];
                        let itemInCart = CartStorage.filter(item => item.Itemid === this.state.ItemId && item.SupplierPartNumber === this.state.supplier_part_number && item.Manufacturerpartnumber === this.state.ItemMFGPartNumber && item.Manufacturer === this.state.ItemManufacturerName);
                        if (itemInCart.length == 0) {
                            FormItems = "";
                            FormFilePath = "";

                            //WW-1378_WW-1382- Update item detail url to local storage - Nandhini L
                            let itemDetailUrl = window.location.href
                            CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);

                            this.props.history.push({
                                pathname: "/forms",
                                state: {
                                    item: AddToCartBO, qty: AddToCartBO.qty, WO: this.state.WorkOrderNo, pagename: 'ItemDetail', searchKey: "", form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim()
                                }
                            });
                        }
                        else if (itemInCart.length > 0 && itemInCart[0].FilePath && itemInCart[0].FilePath.length == 10) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: t('This item is already in the cart and has reached the maximum number of 10 forms')
                            });
                            return true;
                        }
                        else {
                            let AddToCartBO = this.FormCartBO(index);
                            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                            this.setState({ FiltItemValue: value });
                            ItemDetailNewAction.ItemDetail_ByPass(AddToCartBO);
                            $(`#${SDIConstants.SDILoader}`).removeClass('hide')
                        }
                    }

                } else {
                    if (FormDataProps != "" || FormDataProps != undefined || FormDataProps != []) {

                        //WW-1378_WW-1382- Update item detail url to local storage - Nandhini L
                        let itemDetailUrl = window.location.href
                        CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);

                        this.props.history.push({
                            pathname: "/forms",
                            state: { item: AddToCartBO, qty: AddToCartBO.qty, WO: this.state.WorkOrderNo, pagename: 'ItemDetail', searchKey: "", form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim() }
                        });
                    }
                    else {
                        let AddToCartBO = this.FormCartBO(index);
                        CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                        this.setState({ FiltItemValue: value });
                        ItemDetailNewAction.ItemDetail_ByPass(AddToCartBO);
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide')
                    }
                }



                // }

            }
            else {

                let AddToCartBO = this.FormCartBO(index);
                CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                this.setState({ FiltItemValue: value });
                ItemDetailNewAction.ItemDetail_ByPass(AddToCartBO);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
        }
        else {

            let AddToCartBO = this.FormCartBO(index);
            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
            this.setState({ FiltItemValue: value });
            ItemDetailNewAction.ItemDetail_ByPass(AddToCartBO);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }

    };
    handleSlide = index => {
        this.setState({ currentImageIndex: index });
    };
    renderCustomControls() {
        return (
            <button className="image-gallery-fullscreen-button" onClick={() => this.setState({ showThumbnail: true })}>
                Fullscreen
    </button>
        );
    }
    onImageClick = (imgarray) => {

        if (!this.state.isFullScreen) {
            let showIndex = false;
            if (imgarray.length > 1) {
                showIndex = true
                this.setState({ showIndex: true })
            }
            $('#image_modal').modal('show');
        }
    }


    //WW - 1216 Precart - Yuvarani K
    Rating = (value) => {
        this.setState({ StarRating: value })
        //$('#RatingPopup').modal('hide');
    }

    //WW - 1216 Precart - Yuvarani K
    HandleReview = (e) => {
        let value = e.target.value
        //value = value.replace(/[^a-zA-Z0-9\s]/g, '');
        this.setState({ Review: value })

    }

    //WW - 1216 Precart - Yuvarani K
    RatingResponse = () => {
        const { t}=this.props
        // window.location.reload()
        //console.log(this.state.StarRating)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let response = ItemDetailNewStore.RatingSubmissionresponse
        if (response != undefined && response != null) {
            if (response == "Inserted Successfully") {
                this.props.toastSuccessMessage("Thank you for your response")
            }

            else {
                if (response == "Not Inserted") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Error in inserting the rating. Please contact SDI")
                    });
                }

            }
        }

        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Error in inserting the rating. Please contact SDI")
            });

        }
        $('#RatingPopup').modal('hide');

    }
    FavItemloadAttachments = () => {


        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            /*[03/23/22,PC_32,WAL-511], Priyanka D */
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                //swal({
                //    allowOutsideClick: false,
                //    closeOnClickOutside: false,
                //    text: "You can choose only the Image files!!"
                //});


                return;
            }
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    //[2/28/22], PC_IC_06, WW-316, Dhevanesam R
    GetRecommendedItemsResposne = () => {
        //[09/29/22, WAL-780_PC_IDSC_02, Dhevanesam R]
        let ImgCss = "row";
        let HideCarouseArrowVal = false;
        let ColumnsCarouselVal = 5;
        let Imgresponse = JSON.parse(ItemDetailNewStore.GetRecommendedItems);
        if (Imgresponse != undefined && Imgresponse != null) {
            let Imgres = Imgresponse.filter((ele, ind) => ind === Imgresponse.findIndex(elem => elem.ItemID === ele.ItemID))
            console.log("ImgresVal", Imgres)
            if (Imgres.length <= 3) {
                HideCarouseArrowVal = true;
            }
            Imgres.forEach((val, index) => {
                if (val.ImgURL == "\\N") {
                    val.ImgURL = "Images/noimage_new.png"
                }
                else {

                }
            });
            if (window.innerWidth == 768 && window.innerHeight == 1024) {
                ColumnsCarouselVal = 2;
                HideCarouseArrowVal = false;
            }
            this.setState({ ImgResponseVal: Imgres, ImgCssVal: ImgCss, HideCarouseArrow: HideCarouseArrowVal, ColumnsCarousel: ColumnsCarouselVal });
        }
        else {
            this.setState({ ImgResponseVal: [], ImgCssVal: "", HideCarouseArrow: HideCarouseArrowVal, ColumnsCarousel: ColumnsCarouselVal });
        }

    }
    //[2/28/22], PC_IC_09, WW-316, Dhevanesam R
    laodImageItemDetails = (PageName, value, AlternatePartImageClick, previtemid, prevvendor) => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        const queryParams = new URLSearchParams(window.location.search)
        //const QS_src = queryParams.get('ItemId');
        //const ManuPnum = queryParams.get('ManufacturePartNumber');
        //const Mfgname = queryParams.get('ManufactureName');
        //const SupplierID = queryParams.get('SupplierID');
        //const AvailQty = queryParams.get('QTY');
        let QS_src
        let ManuPnum
        let Mfgname
        let SupplierID
        let AvailQty
        let LAST_ITEM_VENDOR_ID
        let LAST_ITEM_VENDOR_ITEM_ID

        if (PageName == "ItemDetails") {
            QS_src = value.ItemID
            ManuPnum = value.MfgPartNum
            Mfgname = value.MfgName
            SupplierID = value.VendorID
            AvailQty = "1"
            LAST_ITEM_VENDOR_ID = previtemid
            LAST_ITEM_VENDOR_ITEM_ID = prevvendor
        }
        else {
            QS_src = this.props.location.state.ItemId
            ManuPnum = this.props.location.state.ManufacturePartNumber
            Mfgname = this.props.location.state.ManufactureName
            SupplierID = this.props.location.state.SupplierID
            AvailQty = this.props.location.state.QTY
            LAST_ITEM_VENDOR_ID = this.props.location.state.LAST_ITEM_VENDOR_ID
            LAST_ITEM_VENDOR_ITEM_ID = this.props.location.state.LAST_ITEM_VENDOR_ITEM_ID
        }

        QTYAvail = AvailQty
        vendorId = SupplierID
        console.log(ManuPnum)
        console.log(QS_src)
        let Iconflag = true
        if (SupplierID == "W999999999") {
            if (this.state.WorkOrderNo == "") {
                Iconflag = false
            }
        }

        //this.setState({ ItemId: QS_src, VendorId: this.props.location.search.SupplierID, carticonFlag: Iconflag })
        let ItemType = CookieService.getLocalStorageValues("Session_Noncat")
        if (ItemType != "NONCAT") {
            if (this.props.location.state.origin == 'shoppingcart') {
                this.setState({ Quantity: this.props.location.state.QtyAdj, IsFromCart: true, IsShopCartFav: this.props.location.state.IsFav })
            }

            let ItemDetailNewBO = {
                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                ItemID: QS_src,
                Manufacture_Part: ManuPnum,
                Session_SITELANG: CookieService.getLocalStorageValues("Session_SITELANG"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_Noncat: CookieService.getLocalStorageValues("Session_Noncat"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Query_ItemAttributeId: "",//CookieService.getLocalStorageValues("Search_ItemAttributeId"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Manufacture_Name: Mfgname,
                Supplier_id: SupplierID,
                Ship_To: CookieService.getLocalStorageValues("HOME_STORE"),//Pass the value of Home store to Shipto 
                Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_06 (4/20/2022)-Aparna
                LAST_ITEM_VENDOR_ID: LAST_ITEM_VENDOR_ID,//WW-390_PC_06 (4/20/2022)-Aparna
                LAST_ITEM_VENDOR_ITEM_ID: LAST_ITEM_VENDOR_ITEM_ID,//WW-390_PC_06 (4/20/2022)-Aparna
                SOURCE: "WEB",
                IsSupplierSearch: true,
                AlternatePartDetail: AlternatePartImageClick,
                Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            }

            console.log("ItemDetailNewBO", ItemDetailNewBO)
            ItemDetailNewAction.pageLoad(ItemDetailNewBO)


        }
        else {
            document.getElementById('item-details-tab').hidden = true
            document.getElementById('usage-tab').hidden = true
            document.getElementById('issues-tab').hidden = true
            document.getElementById('bin-location-tab').hidden = true
            document.getElementById('search-sites-tab').hidden = true
            document.getElementById('purchase-history-tab').hidden = true
            document.getElementById('transactions-tab').hidden = true
            let SuppllierName = CookieService.getLocalStorageValues("Search_supplierName");
            let ImageData = CookieService.getLocalStorageValues("Search_ThumbnailImage");
            let FirstImage = CookieService.getLocalStorageValues("Search_ThumbnailImage");
            let imagePath = "";
            if (FirstImage) {
                FirstImage = FirstImage.replace('\\', '/');
                if (FirstImage.toLowerCase().indexOf("http") >= 0) {
                    imagePath = FirstImage;
                } else {
                    imagePath = FirstImage.lastIndexOf(`/`) >= 0 ? FirstImage.substring(FirstImage.lastIndexOf("/") + 1, FirstImage.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            ItemImageValue = imagePath
            this.setState({
                ItemTypeFav: "NONCAT",
                ItemId: CookieService.getLocalStorageValues("Search_lblproductidtext"),
                ItemManufacturerName: CookieService.getLocalStorageValues("Search_lblManufacturerName"),
                ItemfeatureDesc: CookieService.getLocalStorageValues("Search_lblFeaturestext"),
                ItemClientPartNum: CookieService.getLocalStorageValues("Search_txtClientPartNumber"),
                ItemDescription: CookieService.getLocalStorageValues("Search_lblDescriptionText"),
                AttributeName: CookieService.getLocalStorageValues("Search_AttributeName"),
                AttributeValue: CookieService.getLocalStorageValues("Search_AttributeValue"),
                ItemClient: CookieService.getLocalStorageValues("Search_lblClientDesc"),
                FavitemImage: imagePath,
                ItemGroup: "-",
                ItemCatalogPath: "-",
                ItemUOM: CookieService.getLocalStorageValues("Search_lblUOM"),
                ItemCategory: CookieService.getLocalStorageValues("Search_lblCategory"),
                ItemModifiers: "-",
                ItemMFGPartNumber: CookieService.getLocalStorageValues("Search_lblManufacturerPartNumber"),
                ItemUNSPSC: CookieService.getLocalStorageValues("Search_UNSPSC"),
                ItemSDICatagory: CookieService.getLocalStorageValues("Search_lblCategory"),
                ItemType: "-",
                ItemQuantityAvail: "0",
                ItemImage: imagePath,
                ItemCurrencyCOde: CookieService.getLocalStorageValues("Search_lblCurrencyCode"),
                ExtentDescription: CookieService.getLocalStorageValues("Search_btnShowExtndOraDesc"),
                ItemPrice: CookieService.getLocalStorageValues("Search_lblpricetext"),
                FavItem: CookieService.getLocalStorageValues("Search_ItemFav"),
                VendorId: CookieService.getLocalStorageValues("Search_VendorId"),
                VendorItemid: CookieService.getLocalStorageValues("Search_Supplieritemid"),
                ImageURL: CookieService.getLocalStorageValues("Search_ThumbnailImage"),
            })
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }
    DelFavItem = () => {
        const { t} = this.props
        let PageLoadResponse = JSON.parse(ItemDetailNewStore.DeleteDet);
        // alert("Favorite item removed sucessfully")
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: t('Favorite item removed sucessfully')
        });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        MenuAction.refreshMasterData()
        let favsub = PageLoadResponse.FavSubMenu
        CookieService.updateLocalStorageValues("SuggFavItem", favsub);
        //WW-522
        CookieService.updateLocalStorageValues("Fav_Item", favsub);

        // console.log("CookieService.getLocalStorageValues", CookieService.getLocalStorageValues("Fav_Item_Cat"));
        this.setState({ FavoritesSubMenu: favsub, FavItem: false });
        console.log("Fav_Item", CookieService.getLocalStorageValues("Fav_Item"));
    }
    //WW-522_PC_02 (12/14/2022)
    AlternatePartDetail = (Data) => {
        if (Data != null && Data != undefined && Data != "NA" && Data != "" && Data != "\N" && Data != "\\N") {
            let locAlternateParts = [];
            let ItemsAlternatePart = [];
            let BO = [];
            ItemsAlternatePart = Data.split("|")
            //console.log("locAlternateParts", locAlternateParts)
            if (ItemsAlternatePart.length > 0) {

                ItemsAlternatePart.forEach((x, index) => {
                    let ItemAlternatePartDetail = ItemsAlternatePart[index].split(",")
                    //ItemAlternatePartDetail.forEach((x, index) => {
                    BO = {
                        VendorID: ItemAlternatePartDetail[0],
                        ItemID: ItemAlternatePartDetail[1],
                        MfgName: ItemAlternatePartDetail[2],
                        MfgPartNum: ItemAlternatePartDetail[3],
                        ImgURL: ItemAlternatePartDetail[4],
                    }
                    locAlternateParts.push(BO)
                    console.log("BO", BO)
                    // })
                })
                console.log("locAlternateParts", locAlternateParts)
                this.setState({ AlternateParts: locAlternateParts })
            }
        }
    }
    AssignItemDetails = (ItemArray) => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let ItemDetails = ItemArray;
        /*[02/09/22,WW-318], Priyanka D*///Disabling QTY for Enersys product 
        if (ItemDetails != undefined && ItemDetails.AttributeValue != undefined) {
            if (ItemDetails.AttributeValue != null) {
                if (ItemDetails.AttributeValue.trim() == "BATTERY" || ItemDetails.AttributeValue.trim() == "CHARGER") {
                    this.setState({ QtyDisable: true });
                }
            }

        }
        let ExtendDescLink = 0;
        if (ItemDetails != undefined && ItemDetails != null) {
            let ExtendDesc = ItemDetails.ExtndDesc;
            ExtendDescLink = 0;
            if (ExtendDesc != undefined) {
                if (ExtendDesc.length > 0 && ExtendDesc != "None") {
                    ExtendDescLink = 1
                }
            }
        }

        if (ItemDetails != null && ItemDetails != "") {
            let ImageData = ItemDetails.Image;
            let FirstImage = ImageData[0];
            let imagePath = "";
            if (ItemDetails.Image) {
                ItemDetails.Image = ItemDetails.Image.replace('\\', '/');
                if (ItemDetails.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = ItemDetails.Image;
                }
                else if (ItemDetails.Image == "/N") {
                    imagePath = `/Images/noimage_new.png`;
                }
                else {
                    imagePath = ItemDetails.Image.lastIndexOf(`/`) >= 0 ? ItemDetails.Image.substring(ItemDetails.Image.lastIndexOf("/") + 1, ItemDetails.Image.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }

            ItemImageValue = imagePath

            let message = this.calcWorkingDays(ItemDetails.ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            let ShipByind = message.Sampletest.toString().indexOf("by");
            let ShipByDate = message.Sampletest.toString().substring(ShipByind + 2, message.Sampletest.length) + "";
            let Iconflag = true

            //WW-522_PC_04 (12/14/2022)-Aparna
            if (ItemDetails.alt_part_number != null && ItemDetails.alt_part_number != undefined && ItemDetails.alt_part_number != "NA" && ItemDetails.alt_part_number != "" && ItemDetails.alt_part_number != "\N") {
                this.AlternatePartDetail(ItemDetails.alt_part_number)
            }
            this.setState({
                ItemTypeFav: "CAT",
                ImageURL: ItemDetails.Image != null && ItemDetails.Image != "" && ItemDetails.Image != undefined ? ItemDetails.Image : "-",
                ItemId: ItemDetails.customerPartnumber_CatalogZero != null && ItemDetails.customerPartnumber_CatalogZero != "" && ItemDetails.customerPartnumber_CatalogZero != undefined ? ItemDetails.customerPartnumber_CatalogZero : "-",
                ItemNoun: "-", ItemDetail: ItemDetails,
                PackageQuantity: ItemDetails.package_qty != null && ItemDetails.package_qty != "" && ItemDetails.package_qty != undefined ? ItemDetails.package_qty : "-",
                ShipWIthin: message.Sampletest != "" && message.Sampletest != null && message.Sampletest != undefined ? message.Sampletest : "",
                ItemManufacturerName: ItemDetails.manufacturer != null && ItemDetails.manufacturer != "" && ItemDetails.manufacturer != undefined ? ItemDetails.manufacturer : "-",
                ItemfeatureDesc: ItemDetails.Description != null && ItemDetails.Description != "" && ItemDetails.Description != undefined ? ItemDetails.Description : "-",
                ItemClientPartNum: ItemDetails.clientPartNumber != null && ItemDetails.clientPartNumber != "" && ItemDetails.clientPartNumber != undefined ? ItemDetails.clientPartNumber : "-",
                ItemDescription: ItemDetails.longdescriptionone != null && ItemDetails.longdescriptionone != "" && ItemDetails.longdescriptionone != undefined && ItemDetails.longdescriptionone != "\N" ? ItemDetails.longdescriptionone : "-",
                spec_sheet: ItemDetails.spec_sheet.includes("http") ? ItemDetails.spec_sheet : "-",
                doc_data_sheet: ItemDetails.doc_data_sheet.includes("http") ? ItemDetails.doc_data_sheet : "-",
                doc_install_operator: ItemDetails.doc_install_operator.includes("http") ? ItemDetails.doc_install_operator : "-",
                msds_sds: ItemDetails.msds_sds.includes("http") ? ItemDetails.msds_sds : "-",
                doc_parts: ItemDetails.doc_parts.includes("http") ? ItemDetails.doc_parts : "-",
                cad_drawing: ItemDetails.cad_drawing.includes("http") ? ItemDetails.cad_drawing : "-",
                AttributeName: ItemDetails.AttributeName != null && ItemDetails.AttributeName != "" && ItemDetails.AttributeName != undefined ? ItemDetails.AttributeName : null,
                AttributeValue: ItemDetails.AttributeValue != null && ItemDetails.AttributeValue != "" && ItemDetails.AttributeValue != undefined ? ItemDetails.AttributeValue : null,
                ItemClient: ItemDetails.clientDesc != null && ItemDetails.clientDesc != "" && ItemDetails.clientDesc != undefined ? ItemDetails.clientDesc : "-",
                ItemGroup: "-",
                ItemCatalogPath: "-",
                ItemUOM: ItemDetails.UOM != null && ItemDetails.UOM != "" && ItemDetails.UOM != undefined ? ItemDetails.UOM : "-",
                ItemCategory: "-",
                ItemModifiers: "-",
                ItemMFGPartNumber: ItemDetails.manfPartNumber != null && ItemDetails.manfPartNumber != "" && ItemDetails.manfPartNumber != undefined ? ItemDetails.manfPartNumber : "-",
                ItemUNSPSC: ItemDetails.UNSPSC != null && ItemDetails.UNSPSC != "" && ItemDetails.UNSPSC != undefined ? ItemDetails.UNSPSC : "-",
                ItemSDICatagory: ItemDetails.UNSPSCCategory != null && ItemDetails.UNSPSCCategory != "" && ItemDetails.UNSPSCCategory != undefined ? ItemDetails.UNSPSCCategory : "-",
                ItemType: "-",
                ItemQuantityAvail: "",
                ItemImage: imagePath,
                ItemCurrencyCOde: CookieService.getLocalStorageValues("Search_lblCurrencyCode"),
                ExtentDescription: ItemDetails.ExtndDesc != null && ItemDetails.ExtndDesc != "" && ItemDetails.ExtndDesc != undefined && ItemDetails.ExtndDesc != "\N" ? ItemDetails.ExtndDesc : "-",
                ShowExtentDespPopUp: ExtendDescLink,
                ItemSupplierName: ItemDetails.supplierName != null && ItemDetails.supplierName != "" && ItemDetails.supplierName != undefined ? ItemDetails.supplierName : "-",
                FavItem: CookieService.getLocalStorageValues("Search_ItemFav"),
                SAP_Article_Number: ItemDetails.customer_part_number_woprefix != null && ItemDetails.customer_part_number_woprefix != "" && ItemDetails.customer_part_number_woprefix != undefined && ItemDetails.customer_part_number_woprefix != " " ? ItemDetails.customer_part_number_woprefix : "-",
                actual_qty: ItemDetails.actual_qty != null && ItemDetails.actual_qty != undefined ? ItemDetails.actual_qty : "", carticonFlag: Iconflag, mfg_part_std: ItemDetails.mfg_part_std,
                Item_cat: ItemDetails.UNSPSC != null && ItemDetails.UNSPSC != "" && ItemDetails.UNSPSC != undefined ? ItemDetails.UNSPSC : "-",
                MIN_ORD_QTY: ItemDetails.min_order_qty != null && ItemDetails.min_order_qty != "" && ItemDetails.min_order_qty != undefined ? ItemDetails.min_order_qty : "-",
                Quantityvalue: ItemDetails.min_order_qty != null && ItemDetails.min_order_qty != "" && ItemDetails.min_order_qty != undefined ? ItemDetails.min_order_qty : "-",
                //[12/22/21], PC_ID_09, WW-286, Dhevanesam R
                CORE_CHARGE: ItemDetails.core_charges != null && ItemDetails.core_charges != "" && ItemDetails.core_charges != undefined ? ItemDetails.core_charges : "",
                DueDate: ShipByDate,
                //[2/16/22], WW-330, Dhevanesam R
                BenItemIcon: ItemDetails.hasBenItemVal != null && ItemDetails.hasBenItemVal != "" && ItemDetails.hasBenItemVal != undefined ? ItemDetails.hasBenItemVal : "",
                Short_desc: ItemDetails.short_desc != null && ItemDetails.short_desc != "" && ItemDetails.short_desc != undefined && ItemDetails.short_desc != "\N" ? ItemDetails.short_desc : "-",
                Long_Desc: ItemDetails.longdescriptionone != null && ItemDetails.longdescriptionone != "" && ItemDetails.longdescriptionone != undefined & ItemDetails.longdescriptionone != "\N" ? ItemDetails.longdescriptionone : "-",
                VendorId: ItemDetails.vendor_id
            });
            //WW-522
            let subcatsuggestion = CookieService.getLocalStorageValues("Fav_Item")
            console.log("subcatsuggestion", subcatsuggestion)
            let favitem = false
            if (subcatsuggestion != undefined) {
                if (subcatsuggestion.length > 0) {
                    subcatsuggestion.forEach((x) => {
                        if (x.MANUFACTURER != null && x.CLIENT_MFG_PART != null && x.ISA_CP_ITEM_ID != null && x.SUPPLIER_ID != null) {

                            if (x.MANUFACTURER.toUpperCase() == ItemDetails.manufacturer.toUpperCase() && x.CLIENT_MFG_PART.toUpperCase() == ItemDetails.manfPartNumber.toUpperCase() && x.ISA_CP_ITEM_ID.toUpperCase() == ItemDetails.customerPartnumber_CatalogZero.toUpperCase() && x.SUPPLIER_ID == ItemDetails.vendor_id) {
                                favitem = true
                                this.setState({ FavItem: favitem })
                            }
                        }

                    })

                }
            }
        }
    }
    laodItemDetails = (IsAltpart) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        const queryParams = new URLSearchParams(window.location.search)
        //const QS_src = queryParams.get('ItemId');
        //const ManuPnum = queryParams.get('ManufacturePartNumber');
        //const Mfgname = queryParams.get('ManufactureName');
        //const SupplierID = queryParams.get('SupplierID');
        //const AvailQty = queryParams.get('QTY');
        let QS_src = CookieService.getLocalStorageValues("ItemDetail_ItemId")
        let ManuPnum = CookieService.getLocalStorageValues("ItemDetail_ManufacturePartNumber")
        let Mfgname = CookieService.getLocalStorageValues("ItemDetail_ManufactureName")
        let SupplierID = CookieService.getLocalStorageValues("ItemDetail_SupplierID")
        let AvailQty = CookieService.getLocalStorageValues("ItemDetail_QTY")

        QTYAvail = AvailQty
        vendorId = SupplierID
        console.log(ManuPnum)
        console.log(QS_src)
        let Iconflag = true
        if (SupplierID == "W999999999") {
            if (this.state.WorkOrderNo == "") {
                Iconflag = false
            }
        }

        //this.setState({ ItemId: QS_src, VendorId: vendorId, carticonFlag: Iconflag })
        let ItemType = CookieService.getLocalStorageValues("Session_Noncat")
        if (ItemType != "NONCAT") {

            let ItemDetailNewBO = {
                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                ItemID: QS_src,
                Manufacture_Part: ManuPnum,
                Session_SITELANG: CookieService.getLocalStorageValues("Session_SITELANG"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_Noncat: CookieService.getLocalStorageValues("Session_Noncat"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Query_ItemAttributeId: "",//CookieService.getLocalStorageValues("Search_ItemAttributeId"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Manufacture_Name: Mfgname,
                Supplier_id: SupplierID,
                Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_06 (4/20/2022)-Aparna
                Ship_To: CookieService.getLocalStorageValues("HOME_STORE"),//Pass the value of Home store to Shipto 
                //[1/18/23, WW-542_PC_18, Dhevanesam R]
                SOURCE: "WEB",
                IsSupplierSearch: true,
                AlternatePartDetail: IsAltpart,
                //[1/10/23, WW-542_PC_14, Dhevanesam R]
                Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            }
            ItemDetailNewAction.pageLoad(ItemDetailNewBO)

        }
        else {
            document.getElementById('item-details-tab').hidden = true
            document.getElementById('usage-tab').hidden = true
            document.getElementById('issues-tab').hidden = true
            document.getElementById('bin-location-tab').hidden = true
            document.getElementById('search-sites-tab').hidden = true
            document.getElementById('purchase-history-tab').hidden = true
            document.getElementById('transactions-tab').hidden = true
            let SuppllierName = CookieService.getLocalStorageValues("Search_supplierName");
            let ImageData = CookieService.getLocalStorageValues("Search_ThumbnailImage");
            let FirstImage = CookieService.getLocalStorageValues("Search_ThumbnailImage");
            let imagePath = "";
            if (FirstImage) {
                FirstImage = FirstImage.replace('\\', '/');
                if (FirstImage.toLowerCase().indexOf("http") >= 0) {
                    imagePath = FirstImage;
                } else {
                    imagePath = FirstImage.lastIndexOf(`/`) >= 0 ? FirstImage.substring(FirstImage.lastIndexOf("/") + 1, FirstImage.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            ItemImageValue = imagePath
            this.setState({
                ItemTypeFav: "NONCAT",
                ItemId: CookieService.getLocalStorageValues("Search_lblproductidtext"),
                ItemManufacturerName: CookieService.getLocalStorageValues("Search_lblManufacturerName"),
                ItemfeatureDesc: CookieService.getLocalStorageValues("Search_lblFeaturestext"),
                ItemClientPartNum: CookieService.getLocalStorageValues("Search_txtClientPartNumber"),
                ItemDescription: CookieService.getLocalStorageValues("Search_lblDescriptionText"),
                AttributeName: CookieService.getLocalStorageValues("Search_AttributeName"),
                AttributeValue: CookieService.getLocalStorageValues("Search_AttributeValue"),
                ItemClient: CookieService.getLocalStorageValues("Search_lblClientDesc"),
                FavitemImage: imagePath,
                ItemGroup: "-",
                ItemCatalogPath: "-",
                ItemUOM: CookieService.getLocalStorageValues("Search_lblUOM"),
                ItemCategory: CookieService.getLocalStorageValues("Search_lblCategory"),
                ItemModifiers: "-",
                ItemMFGPartNumber: CookieService.getLocalStorageValues("Search_lblManufacturerPartNumber"),
                ItemUNSPSC: CookieService.getLocalStorageValues("Search_UNSPSC"),
                ItemSDICatagory: CookieService.getLocalStorageValues("Search_lblCategory"),
                ItemType: "-",
                ItemQuantityAvail: "0",
                ItemImage: imagePath,
                ItemCurrencyCOde: CookieService.getLocalStorageValues("Search_lblCurrencyCode"),
                ExtentDescription: CookieService.getLocalStorageValues("Search_btnShowExtndOraDesc"),
                ItemPrice: CookieService.getLocalStorageValues("Search_lblpricetext"),
                FavItem: CookieService.getLocalStorageValues("Search_ItemFav"),
                VendorId: CookieService.getLocalStorageValues("Search_VendorId"),
                VendorItemid: CookieService.getLocalStorageValues("Search_Supplieritemid"),
                ImageURL: CookieService.getLocalStorageValues("Search_ThumbnailImage"),
            })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    }
    BindTabOne = () => {

        let PageLoadResponse = JSON.parse(ItemDetailNewStore.TabOneRespList);
        let carouselImgPath = []
        console.log("Result", PageLoadResponse);
        let ItemPrice = PageLoadResponse.ItemPrice;
        let HeaderDetails = PageLoadResponse.HeaderDetails;
        let ItemCatalogPath = PageLoadResponse.ItemCatalogPath;
        let ItemData = PageLoadResponse.ItemData;
        let Update_Session = PageLoadResponse.Update_Session;
        let QuantityAvail = PageLoadResponse.QuantityAvail;
        //[1/10/23, WW-542_PC_15, Dhevanesam R]
        let Error_Message = PageLoadResponse.Error_Message;
        let ExtendDesc = ""
        let ExtendDescLink = 0
        let QtyDisableValue = false
        if (ExtendDesc.length > 0 && ExtendDesc != "None") {
            ExtendDescLink = 1
        }



        const queryparam = new URLSearchParams(window.location.search)
        // const orgin = queryparam.get('Orgin')
        let orgin = this.props.location.state.Orgin
        if (Error_Message != undefined && Error_Message != null && Error_Message.length != 0) {
            if (Error_Message[0].ErrorMessage != null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Error_Message[0].ErrorMessage
                });
                const queryParams = new URLSearchParams(window.location.search)
                const Origin = queryParams.get('origin');
                const searchqueryParams = queryParams.get('searchkey')
                if (Origin == 'search') {
                    ////this.props.location.state.origin = ""
                    //const queryParams = queryParams.get('searchkey')
                    let searchqueryParamsValue = searchqueryParams.replace(/&/g, "%26") //WW-875_PC_01
                    searchqueryParamsValue = searchqueryParamsValue.replace(/#/g, "%23")
                    this.props.history.push({
                        pathname: `\searchresults`,
                        search: `?key=${searchqueryParamsValue.trim()}&Make=&Model=&AssetId=&`,
                        state: { ImageSearch: false, ImageFiles: "", image: "" }
                    }).then(function () {
                        window.location.reload();
                    });



                }
                else if (Origin == 'itemDetail') {
                    // this.laodItemDetails();
                    const queryParams = new URLSearchParams(window.location.search)
                    const previtemid = queryParams.get('LAST_ITEM_VENDOR_ITEM_ID');
                    const prevvendor = queryParams.get('LAST_ITEM_VENDOR_ID');
                    const prevmfgpart = queryParams.get('prevmfgpart');
                    const prevmfg = queryParams.get('prevmfg');
                    let supplierPartNum = queryParams.get('ItemId');

                    let value = {
                        ItemID: previtemid,
                        MfgPartNum: prevmfgpart,
                        MfgName: prevmfg,
                        VendorID: prevvendor,
                    }
                    this.props.history.push({
                        pathname: `/itemdetailnew`,
                        search: `?ItemId=${previtemid}&ManufacturePartNumber=${prevmfgpart}&ManufactureName=${prevmfg}&SupplierID=${prevvendor}&QTY=""&origin=itemDetail&LAST_ITEM_VENDOR_ID=${prevvendor}&LAST_ITEM_VENDOR_ITEM_ID=${previtemid}&prevmfg=${prevmfg}&prevmfgpart=${prevmfgpart}`,
                        state: { WO: JSON.parse(localStorage.getItem("WONum")), origin: 'itemDetail', Suggesstions: false, ItemId: previtemid, ManufacturePartNumber: prevmfgpart, ManufactureName: prevmfg, vendor_id: prevvendor, QTY: "1", LAST_ITEM_VENDOR_ID: prevvendor, LAST_ITEM_VENDOR_ITEM_ID: previtemid, ItemData: value, IsAltPart: true }
                    });
                    console.log("history", this.props.history)
                    // this.laodItemDetails()
                    //document.location.reload()
                    this.laodImageItemDetails("ItemDetails", value, true, previtemid, prevvendor)

                }

                // //[1/19/23, WW-587_PC_6, Dhevanesam R]
                //else if (window.location.pathname.toLowerCase() == "/itemdetailnew" && this.props.location.state.origin != 'menu' && this.props.location.state.origin != 'favitem' && this.props.location.state.origin != 'favorder') {
                //     window.history.go(-1)

                //     debugger
                //     const queryParams = new URLSearchParams(window.location.search)
                //     const QS_src = queryParams.get('ItemId');
                //     const SupplierID = queryParams.get('SupplierID');
                //     let Iconflag = true
                //     if (SupplierID == "W999999999") {
                //         if (this.state.WorkOrderNo == "") {
                //             Iconflag = false
                //         }
                //     }

                //     //this.props.history.push({
                //     //    pathname: window.location.pathname,
                //     //    search: (window.location.search

                //     //});

                //     //this.setState({ ItemId: QS_src, VendorId: SupplierID, carticonFlag: Iconflag })
                //     $(`#${SDIConstants.SDILoader}`).addClass('hide');

                // }
                else {
                    if (this.props.location.state.origin == 'favitem') {
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        this.props.history.push({
                            pathname: `/favorites`,
                        });
                        //this.props.location.state.origin = ""
                    }

                    else if (this.props.location.state.origin == 'favorder') {

                        this.props.history.push({
                            pathname: `/favorder`,
                        });
                        //this.props.location.state.origin = ""
                    }
                    else if (this.props.location.state.origin == 'menu') {
                        this.props.history.push({
                            pathname: `/homepage`,
                        });
                        //this.props.location.state.origin = ""
                    }
                    else {
                        this.props.history.push({
                            pathname: `/homepage`,
                        });
                        //this.props.location.state.origin = ""
                    }
                }

            }

        }
        else {
            //[1/25/23, WW-587_PC_9, Dhevanesam R]
            CookieService.updateLocalStorageValues("SelectedCatIndexFavOrder", "");
            CookieService.updateLocalStorageValues("SelectedCatIndexFavItem", "");
            if (ItemData != undefined && ItemData != null) {
                if (ItemData.length > 0) {
                    if (ItemData[0].AttributeValue != null) {
                        if (ItemData[0].AttributeValue.trim() == "BATTERY" || ItemData[0].AttributeValue.trim() == "CHARGER") {
                            QtyDisableValue = true
                        }
                    }

                    ItemData[0].hasCoreCharge = false;
                    if (ItemData[0].CORE_CHARGE != "\\N" && ItemData[0].CORE_CHARGE != "" && ItemData[0].CORE_CHARGE != undefined && ItemData[0].CORE_CHARGE.length > 0) {
                        ItemData[0].hasCoreCharge = true;
                    }
                    ItemData[0].IsSupplierFav = false;
                    ItemData[0].DeliverDate = "";
                    ItemData[0].DeliverDate = this.calcWorkingDaysNew(ItemData[0].ships_within);
                    if (ItemData[0].actual_qty != undefined && ItemData[0].actual_qty != null && ItemData[0].actual_qty != "") {
                        ItemData[0].hasBenItemVal = ItemData[0].actual_qty.slice(-1);
                    }
                    let ImageData = ItemData[0].ThumbnailImagefile;
                    let imagePath = ""
                    let imgArr = ImageData.split("|")
                    let FirstImage = ImageData[0];
                    ExtendDesc = ItemData[0].ExtndDesc;
                    imgArr.map((val, index) => {
                        let imagePath = "";
                        if (val) {
                            ItemData[0].Image = val.replace('\\', '/');
                            if (ItemData[0].Image.toLowerCase().indexOf("http") >= 0) {
                                imagePath = val;
                            } else {
                                imagePath = ItemData[0].ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? ItemData[0].ThumbnailImagefile.substring(ItemData[0].ThumbnailImagefile.lastIndexOf("/") + 1, ItemData[0].ThumbnailImagefile.length) : "noimage_new.png";
                                if (imagePath) {
                                    imagePath = `/Images/${imagePath}`;
                                }
                            }
                        } else {
                            imagePath = `/Images/noimage_new.png`;
                        }
                        ItemImageValue = imagePath
                        let locArray = {
                            original: imagePath,
                            thumbnail: imagePath
                        }
                        carouselImgPath.push(locArray)
                    })



                    let message = this.calcWorkingDays(ItemData[0].ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)
                    console.log("GetShipwithin", message)
                    let Iconflag = true

                    let qty = ItemData[0].min_order_qty != null && ItemData[0].min_order_qty != "" && ItemData[0].min_order_qty != undefined ? ItemData[0].min_order_qty : "-";
                    if (this.props.location.state.origin != undefined && this.props.location.state.origin != null) {
                        if (this.props.location.state.origin == 'shoppingcart') {
                            qty = this.props.location.state.QtyAdj;
                        }
                    }
                    //let favitem = CookieService.getLocalStorageValues("Search_ItemFav")
                    //if (this.state.IsFromFav) {
                    //    favitem = true
                    //}
                    //if (this.state.IsShopCartFav) {
                    //    favitem = true
                    //}
                    //WW-516 -Deepthi
                    let Bentonville = ItemData[0].actual_qty;
                    let CentralWare = "";
                    if (Bentonville != null && Bentonville != "" && Bentonville != undefined) {
                        CentralWare = Bentonville.slice(-1);
                    }
                    let favitem = false;
                    let SDIFavItems = JSON.parse(localStorage.getItem("SDIFavItems"));
                    if (SDIFavItems != undefined) {
                        let favitemdata = SDIFavItems.FavItemData;

                        if (favitemdata.length > 0) {

                            let favoriteitem = favitemdata.findIndex(x => (x.MANUFACTURER.toUpperCase() == ItemData[0].manufacturer.toUpperCase() && x.CLIENT_MFG_PART.toUpperCase() == ItemData[0].manfPartnumber.toUpperCase() && x.ISA_CP_ITEM_ID.toUpperCase() == ItemData[0].customerPartnumber_CatalogZero.toUpperCase() && x.SUPPLIER_ID == ItemData[0].vendor_id))
                            if (favoriteitem >= 0) {
                                favitem = true
                            }
                            //let imagePath = ""
                            //WW-522
                            //let subcatsuggestion = CookieService.getLocalStorageValues("Fav_Item")
                            //if (subcatsuggestion != undefined) {
                            //    if (subcatsuggestion.length > 0) {
                            //        subcatsuggestion.forEach((x) => {
                            //            if (x.MANUFACTURER != null && x.CLIENT_MFG_PART != null && x.ISA_CP_ITEM_ID != null && x.SUPPLIER_ID != null) {
                            //                if (x.MANUFACTURER.toUpperCase() == ItemData[0].manufacturer.toUpperCase() && x.CLIENT_MFG_PART.toUpperCase() == ItemData[0].manfPartnumber.toUpperCase() && x.ISA_CP_ITEM_ID.toUpperCase() == ItemData[0].customerPartnumber_CatalogZero.toUpperCase() && x.SUPPLIER_ID == ItemData[0].vendor_id) {
                            //                    favitem = true
                            //                }
                            //            }


                            //        })
                        }
                    }
                    //WW-522_PC_04 (12/14/2022)-Aparna
                    if (ItemData[0].alt_part_number != null && ItemData[0].alt_part_number != undefined && ItemData[0].alt_part_number != "NA" && ItemData[0].alt_part_number != "" && ItemData[0].alt_part_number != "\N") {
                        console.log("alt_part_number", ItemData[0].alt_part_number);
                        this.AlternatePartDetail(ItemData[0].alt_part_number)
                    }

                    CookieService.updateLocalStorageValues("itemDetailsItemId", window.location.pathname);
                    //WW - 1216 Precart - Yuvarani K
                    ItemDetailsValue = ItemData[0]

                    //WW-1378_WW-1382- Update item detail ItemDetailsValue to local storage - Nandhini L
                    CookieService.updateLocalStorageValues("ItemData", ItemDetailsValue);

                    this.setState({
                        ItemTypeFav: "CAT",
                        ImageURL: ItemData[0].ThumbnailImagefile != null && ItemData[0].ThumbnailImagefile != "" && ItemData[0].ThumbnailImagefile != undefined ? ItemData[0].ThumbnailImagefile : "-",
                        ItemId: ItemData[0].customerPartnumber_CatalogZero != null && ItemData[0].customerPartnumber_CatalogZero != "" && ItemData[0].customerPartnumber_CatalogZero != undefined ? ItemData[0].customerPartnumber_CatalogZero : "-",

                        ItemNoun: "-", ItemDetail: ItemData[0],
                        //WW - 1216 Precart - Yuvarani K
                        RatingCount: ItemData[0].rating_count != null && ItemData[0].rating_count != "" && ItemData[0].rating_count != undefined ? ItemData[0].rating_count : "-",
                        ProductRating: ItemData[0].product_rating != null && ItemData[0].product_rating != "" && ItemData[0].product_rating != undefined ? ItemData[0].product_rating : "-",
                        cart_bypass: ItemData[0].cart_bypass != null && ItemData[0].cart_bypass != "" && ItemData[0].cart_bypass != undefined ? ItemData[0].cart_bypass : "",
                        PackageQuantity: ItemData[0].package_qty != null && ItemData[0].package_qty != "" && ItemData[0].package_qty != undefined ? ItemData[0].package_qty : "-",
                        ShipWIthin: message.Sampletest != "" && message.Sampletest != null && message.Sampletest != undefined ? message.Sampletest : "",
                        ItemManufacturerName: ItemData[0].manufacturer != null && ItemData[0].manufacturer != "" && ItemData[0].manufacturer != undefined ? ItemData[0].manufacturer : "-",
                        ItemfeatureDesc: ItemData[0].description != null && ItemData[0].description != "" && ItemData[0].description != undefined ? ItemData[0].description : "-",
                        ItemClientPartNum: ItemData[0].clientPartNumber != null && ItemData[0].clientPartNumber != "" && ItemData[0].clientPartNumber != undefined ? ItemData[0].clientPartNumber : "-",
                        ItemDescription: ItemData[0].longdescriptionone != null && ItemData[0].longdescriptionone != "" && ItemData[0].longdescriptionone != undefined && ItemData[0].longdescriptionone != "\N" ? ItemData[0].longdescriptionone : "-",
                        spec_sheet: ItemData[0].spec_sheet != undefined && ItemData[0].spec_sheet != null ? ItemData[0].spec_sheet.includes("http") ? ItemData[0].spec_sheet : "-" : "",
                        doc_data_sheet: ItemData[0].doc_data_sheet != undefined && ItemData[0].doc_data_sheet != null ? ItemData[0].doc_data_sheet.includes("http") ? ItemData[0].doc_data_sheet : "-" : "",
                        doc_install_operator: ItemData[0].doc_install_operator != undefined && ItemData[0].doc_install_operator != null ? ItemData[0].doc_install_operator.includes("http") ? ItemData[0].doc_install_operator : "-" : "",
                        msds_sds: ItemData[0].msds_sds != undefined && ItemData[0].msds_sds != null ? ItemData[0].msds_sds.includes("http") ? ItemData[0].msds_sds : "-" : "",
                        doc_parts: ItemData[0].doc_parts != undefined && ItemData[0].doc_parts != null ? ItemData[0].doc_parts.includes("http") ? ItemData[0].doc_parts : "-" : "",
                        cad_drawing: ItemData[0].cad_drawing != undefined && ItemData[0].cad_drawing != null ? ItemData[0].cad_drawing.includes("http") ? ItemData[0].cad_drawing : "-" : "",
                        AttributeName: ItemData[0].AttributeName != null && ItemData[0].AttributeName != "" && ItemData[0].AttributeName != undefined ? ItemData[0].AttributeName : null,
                        AttributeValue: ItemData[0].AttributeValue != null && ItemData[0].AttributeValue != "" && ItemData[0].AttributeValue != undefined ? ItemData[0].AttributeValue : null,
                        ItemClient: ItemData[0].clientDesc != null && ItemData[0].clientDesc != "" && ItemData[0].clientDesc != undefined ? ItemData[0].clientDesc : "-",
                        ItemGroup: HeaderDetails.length > 0 ? HeaderDetails[0].INV_ITEM_GROUP : "-",
                        ItemCatalogPath: ItemCatalogPath[0].ItemCatalogPath != null && ItemCatalogPath[0].ItemCatalogPath != "" && ItemCatalogPath[0].ItemCatalogPath != undefined ? ItemCatalogPath[0].ItemCatalogPath : "-",
                        ItemUOM: ItemData[0].UOM != null && ItemData[0].UOM != "" && ItemData[0].UOM != undefined ? ItemData[0].UOM : "-",
                        ItemCategory: HeaderDetails.length > 0 ? HeaderDetails[0].CATEGORY_ID : "-",
                        ItemModifiers: HeaderDetails.length > 0 ? HeaderDetails[0].IM_MODIFIER : "-",
                        ItemMFGPartNumber: ItemData[0].manfPartnumber != null && ItemData[0].manfPartnumber != "" && ItemData[0].manfPartnumber != undefined ? ItemData[0].manfPartnumber : "-",
                        ItemUNSPSC: ItemData[0].UNSPSC != null && ItemData[0].UNSPSC != "" && ItemData[0].UNSPSC != undefined ? ItemData[0].UNSPSC : "-",
                        ItemSDICatagory: ItemData[0].UNSPSCCategory != null && ItemData[0].UNSPSCCategory != "" && ItemData[0].UNSPSCCategory != undefined ? ItemData[0].UNSPSCCategory : "-",
                        ItemType: HeaderDetails.length > 0 ? HeaderDetails[0].INV_ITEM_TYPE : "-",
                        ItemQuantityAvail: QuantityAvail[0].QuantityAvail,
                        ItemImage: carouselImgPath,
                        ItemCurrencyCOde: CookieService.getLocalStorageValues("Search_lblCurrencyCode"),
                        ExtentDescription: ItemData[0].ExtndDesc != null && ItemData[0].ExtndDesc != "" && ItemData[0].ExtndDesc != undefined && ItemData[0].ExtndDesc != "\N" ? ItemData[0].ExtndDesc : "-",
                        ShowExtentDespPopUp: ExtendDescLink,
                        ItemSupplierName: ItemData[0].supplierName != null && ItemData[0].supplierName != "" && ItemData[0].supplierName != undefined ? ItemData[0].supplierName : "-",
                        supplier_part_number: ItemData[0].supplier_part_number != null && ItemData[0].supplier_part_number != "" && ItemData[0].supplier_part_number != undefined ? ItemData[0].supplier_part_number : "-",
                        // FavItem: CookieService.getLocalStorageValues("Search_ItemFav"),
                        SAP_Article_Number: ItemData[0].customer_part_number_woprefix != null && ItemData[0].customer_part_number_woprefix != "" && ItemData[0].customer_part_number_woprefix != undefined && ItemData[0].customer_part_number_woprefix != " " ? ItemData[0].customer_part_number_woprefix : "-",
                        actual_qty: ItemData[0].actual_qty != null && ItemData[0].actual_qty != undefined ? ItemData[0].actual_qty : "", carticonFlag: Iconflag, mfg_part_std: ItemData[0].mfg_part_std,
                        MIN_ORD_QTY: ItemData[0].min_order_qty != null && ItemData[0].min_order_qty != "" && ItemData[0].min_order_qty != undefined ? ItemData[0].min_order_qty : "-",
                        Quantityvalue: qty,
                        Short_desc: ItemData[0].short_desc != null && ItemData[0].short_desc != "" && ItemData[0].short_desc != undefined && ItemData[0].short_desc != "\N" ? ItemData[0].short_desc : "-",
                        Long_Desc: ItemData[0].longdescriptionone != null && ItemData[0].longdescriptionone != "" && ItemData[0].longdescriptionone != undefined & ItemData[0].longdescriptionone != "\N" ? ItemData[0].longdescriptionone : "-",
                        FavItem: favitem,
                        BenItemIcon: CentralWare, VendorId: ItemData[0].vendor_id != null && ItemData[0].vendor_id != "" && ItemData[0].vendor_id != undefined ? ItemData[0].vendor_id : "", //WW-522, 
                        QtyDisable: QtyDisableValue,
                        equParts: ItemData[0].alternate_parts && ItemData[0].alternate_parts.trim() != "" && ItemData[0].alternate_parts != [] && ItemData[0].alternate_parts != "[]" ? JSON.parse(ItemData[0].alternate_parts) : [],//' PC_WW-641_05-Priyanka  D
                        equivalentParts: ItemData[0].Equvialent_partno && ItemData[0].Equvialent_partno.trim() != "" && ItemData[0].Equvialent_partno != [] && ItemData[0].Equvialent_partno != "[]" ? JSON.parse(ItemData[0].Equvialent_partno) : [],
                        alsoFits: ItemData[0].alsoFits != null && ItemData[0].alsoFits != "" && ItemData[0].alsoFits != undefined ? JSON.parse(ItemData[0].alsoFits) : [],//' PC_WW-641_05-Priyanka  D
                        ItmPrice: ItemData[0].FilterPrice, Itemdetail: ItemData,
                        KIT_Components: ItemData[0].kit_Items != null && ItemData[0].kit_Items != "" && ItemData[0].kit_Items != "-" && ItemData[0].kit_Items != undefined ? JSON.parse(ItemData[0].kit_Items) : "",
                        IsKit: ItemData[0].IsKit,
                        KIT_Details: ItemData[0].kit_comp != null && ItemData[0].kit_comp != "" && ItemData[0].kit_comp != "-" && ItemData[0].kit_comp != undefined ? ItemData[0].kit_comp : "",
                        ISCoreCharge: ItemData[0].hasCoreCharge,
                        ItemDetails: ItemData
                        // isNonCatSearch: false,
                    })
                    let formName = "";
                    if (ItemData[0].AttributeName.includes('FORM')) {
                        formName = ItemData[0].form.trim()
                    }
                    if (ItemData[0].AttributeName.includes('FORM')) {
                        if (formName != null && formName != "" && formName != undefined) {
                            if (formName.toLowerCase().includes("battery") || formName.toLowerCase().includes("charger")) {
                                FormDataProps = []
                                FormOptionsDataProps = []
                                //this.AddToCart(value, index);
                            }
                            else {
                                let dynamicFormBO = {
                                    formName: formName
                                }
                                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                SupplierSuggestionAction.dynamicFormData(dynamicFormBO);
                            }
                        }

                    }

                }
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    calcWorkingDaysNew = (shipwithin) => {

        let count = 0;
        //[2/10/23, PC_WW-621_APP_01, Dhevanesam R]
        let tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1); // to exclude today's date
        console.log("tomorrow's date", tomorrow)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (tomorrow.getDay() != 0 && tomorrow.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        tomorrow.setDate(tomorrow.getDate() - 1);
        let td = this.handledate(tomorrow);
        let Sampletest = "" + td
        return Sampletest;
    }
    GetShipwithin = (shipwithin) => {

        let day = "5"
        let Sampletest = ""
        if (shipwithin != null && shipwithin != undefined) {
            let symbol1 = shipwithin.match(/[+-<>]/);
            console.log(symbol1)
            let Number = shipwithin.match(/(\d+)/);
            console.log("Number", Number)
            let symbol = "within"
            if (symbol1 && Number) {
                if (Number.length > 0 && symbol1.length > 0) {
                    if (Number[0] != "0") {
                        day = Number[0]
                    }
                    if (symbol1[0] == ">" || symbol1[0] == "+") {
                        symbol = "after"
                    }
                    else if (symbol1[0] == "<" || symbol1[0] == "-") {
                        symbol = "within"
                    }
                    Sampletest = "Usually ships " + symbol + " " + day + " days"
                }
                else {
                    Sampletest = ""
                }
            }
            else {
                Sampletest = ""
            }
        }
        else {
            Sampletest = ""
        }
        return ({ Sampletest })
    };
    /****NEW**(catalog search)WAL-158***/
    calcWorkingDays = (shipwithin) => {
        let count = 0;
        let tomorrow = new Date()
        //[2/10/23, PC_WW-621_APP_01, Dhevanesam R]
        tomorrow.setDate(tomorrow.getDate() + 1); // to exclude today's date
        console.log("tomorrow's date", tomorrow)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (tomorrow.getDay() != 0 && tomorrow.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        tomorrow.setDate(tomorrow.getDate() - 1);
        let td = this.handledate(tomorrow);
        {/*[WW-458]Change Ship within label to Delivers by-Priyanka D*/ }
        let Sampletest = "Delivers By:   " + td
        return ({ Sampletest })
        this.setState({ deliverydate: td })
    }
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    /*******END******/
    BindLink = () => {
        return (
            <div className="col-md-12">
                {this.state.spec_sheet != "-" ?
                    <div><a href={this.state.spec_sheet} target="_blank" >Specifications Link</a></div> : null}

                {this.state.doc_data_sheet != "-" ?
                    <div><a href={this.state.doc_data_sheet} target="_blank" >DataSheet Link</a></div> : null}

                {this.state.doc_install_operator != "-" ?
                    <div><a href={this.state.doc_install_operator} target="_blank" >Installation Instruction Link</a></div> : null}

                {this.state.msds_sds != "-" ?
                    <div><a href={this.state.msds_sds} target="_blank" >MSDS Link</a></div> : null}

                {this.state.doc_parts != "-" ?
                    <div><a href={this.state.doc_parts} target="_blank" >Parts Diagram link </a></div> : null}

                {this.state.cad_drawing != "-" ?
                    <div><a href={this.state.cad_drawing} target="_blank" >CAD Drawing Link</a></div> : null}

            </div>
        )
    }
    BindAttribute = () => {

        let AttributeNameLocal = [];
        let AttributeValueLocal = [];
        AttributeNameLocal = this.state.AttributeName != null ? this.state.AttributeName.split("|") : null;
        AttributeValueLocal = this.state.AttributeValue != null ? this.state.AttributeValue.split("|") : null;
        console.log("Name", AttributeNameLocal)
        console.log("Value", AttributeValueLocal)
        if (AttributeNameLocal && AttributeValueLocal) {
            if ((AttributeNameLocal.length != 0 && AttributeValueLocal.length != 0) && (AttributeNameLocal.length == AttributeValueLocal.length)) {
                return AttributeNameLocal.map((val, index) => {
                    return (
                        <div className="row mb-3" key={index}>
                            <div className="col-md-12 col-lg-2 catalog-label">{val}</div>
                            <div className="col-md-12 col-lg-10 catalog-value">{AttributeValueLocal[index]}</div>
                        </div>)
                });
            }
        }

    }
    /**
     * CIP_PS_01
     * to check whether this mfg has cheaper one
     * */
    CheaperItemCheck = () => {
        //let PageLSearchResults = this.state.PageLoadSearchResults;
        //let val = (parseInt(this.state.QuantityOrdered) / parseInt(PageLSearchResults[Index].min_order_qty));
        if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
            //alert('Quantity Entered Is Below The Minimum Order Quantity');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity Entered Is Below The Minimum Order Quantity'
            });
            return;
        }
        else if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            // alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity Entered Is Below The Minimum Order Quantity'
            });
            return;
        }
        let quantity = 0
        let mfgboolean = false
        quantity = $('#QuantityTxt').val();
        if (vendorId == "W999999999") {
            if (QTYAvail != null) {
                if (parseInt(QTYAvail) < parseInt(quantity)) {
                    let str = 'Available quantity for this item: ' + QTYAvail
                    alert(str);
                    return;
                }
            }
        }
        if (this.state.ItemMFGPartNumber != "" && this.state.ItemMFGPartNumber != null && this.state.ItemMFGPartNumber != undefined) {
            let mfgpart = this.state.ItemMFGPartNumber
            if (this.state.mfg_part_std != "" && this.state.mfg_part_std != null && this.state.mfg_part_std != undefined && this.state.mfg_part_std != "NA") {
                mfgpart = this.state.mfg_part_std
                mfgboolean = true
            }

            let SearchBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                CurrentPage_URL: "/SDIXZEUS/searchResults",
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_SearchQuery: this.state.manfPartNumber,
                Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                SearchValue: mfgpart,//WW-536
                Query_SITE: "",
                Query_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Query_Key: mfgpart, //WW-536
                Query_Opt: "",
                chbCat: true,
                chbNonCat: true,
                Catagorylist: [],//CatagoryList,
                Make: "",
                Model: "",
                AssetId: "",
                SupplierIdList: [],
                ManufacturerList: []
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ItemDetailNewAction.CheaperItemCheckAction(SearchBO)
            this.setState({ mfgpartstboolean: mfgboolean });

        }
    }
    //handleQuantity = (e) => {

    //    this.setState({ Quantityvalue: e.target.value });
    //}
    /*[04/06/22,Bug ID:2029]Restricting the user to add decimal value for thr qty Priyanka D */
    handleQuantity = (e) => {

        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                this.setState({ Quantityvalue: e.target.value });
            }
        }
    }
    CheaperItemCheckResposne = () => {
        let response = JSON.parse(ItemDetailNewStore.FavitemAddList);
        console.log("response", response);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Searchdata = response.SearchItemTable
        let Fav = response.FavSubMenu
        let loccheaperitem = [];
        let localvariable = []
        let locfavitem = false

        //*[12/13/21, PC_IDC_01, WW-275- Added Inc & decr for qty in cheaper item popup, Poornima S]
        let MinOrdQty = "" + Searchdata[0].min_order_qty;
        let MaxOrdQty = "" + (parseInt(Searchdata[0].min_order_qty) + parseInt(Searchdata[0].min_order_qty));

        //[1/3/21], PC_ID_15, WW-286, Dhevanesam R
        let coreCharge = Searchdata[0].core_charges;

        let price = CookieService.getLocalStorageValues("Search_lblpricetext")
        // price = this.state.ItemPrice
        if (Searchdata != null && Searchdata != undefined && Searchdata != "") {
            //Searchdata = Searchdata.filter((x) => x.mfg_part_std == this.state.SelectedItemForCheaper.mfg_part_std)//WAL-536
            if (vendorId == "W999999999") {
                if (this.state.mfgpartstboolean) {
                    //*[12/07/21, PC_ID_01, WW-275- Cheaper item pop up issue, Poornima S]
                    Searchdata = Searchdata = Searchdata.filter((x) => x.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.ItemManufacturerName.toUpperCase()) || this.state.ItemManufacturerName.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.vendor_id == "W999999999")//WW-536

                }
                else {
                    Searchdata = Searchdata = Searchdata.filter((x) => x.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.ItemMFGPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.ItemManufacturerName.toUpperCase()) || this.state.ItemManufacturerName.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.vendor_id == "W999999999")//WW-536

                }
            }
            if (Searchdata.length > 1) {

                if (this.state.mfgpartstboolean) {
                    Searchdata.filter((item) => item.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (item.manufacturer.toUpperCase().includes(this.state.ItemManufacturerName.toUpperCase()) || this.state.ItemManufacturerName.toUpperCase().includes(item.manufacturer.toUpperCase())) && parseFloat(item.ItemPrice) < parseFloat(price))//WW-536
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            localvariable.push(item)
                        );
                }
                else {
                    Searchdata.filter((item) => item.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.ItemMFGPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") && (item.manufacturer.toUpperCase().includes(this.state.ItemManufacturerName.toUpperCase()) || this.state.ItemManufacturerName.toUpperCase().includes(item.manufacturer.toUpperCase())) && parseFloat(item.ItemPrice) < parseFloat(price))//WW-536
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            localvariable.push(item)
                        );
                }

                let imagePath = "";
                if (localvariable.length > 0) {
                    if (localvariable[0].ThumbnailImagefile) {
                        localvariable[0].Image = localvariable[0].ThumbnailImagefile.replace('\\', '/');
                        if (localvariable[0].Image.toLowerCase().indexOf("http") >= 0) {
                            imagePath = localvariable[0].ThumbnailImagefile;
                        } else {
                            imagePath = localvariable[0].ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? localvariable[0].ThumbnailImagefile.substring(localvariable[0].ThumbnailImagefile.lastIndexOf("/") + 1, localvariable[0].ThumbnailImagefile.length) : "noimage_new.png";
                            if (imagePath) {
                                imagePath = `/Images/${imagePath}`;
                            }
                        }
                    } else {
                        imagePath = `/Images/noimage_new.png`;
                    }
                    localvariable[0].ThumbnailImagefile = imagePath
                    loccheaperitem = localvariable[0]
                }
            }



        }

        if (Object.keys(loccheaperitem).length != 0) {
            if (Fav.length > 0) {
                locfavitem = Fav.filter((item, index) => item.CUSTOMERITEMID == loccheaperitem.clientPartNumber || (item.CLIENT_MFG_PART == loccheaperitem.manfPartNumber && item.MANUFACTURER == loccheaperitem.manfPartNumber)).length > 0 ? true : false;

            }
            this.setState({ CheaperItem: loccheaperitem, CheaperFavItem: locfavitem, CheapItemMinQty: MinOrdQty, CheapItemMaxQty: MaxOrdQty, CheaperItemQty: MinOrdQty });
            $('#CheaperItemPopup').modal('show');


        }
        else {

            //[1/3/21], PC_ID_15, WW-286, Dhevanesam R
            if (coreCharge == null || coreCharge == "\N" || coreCharge == "\\N" || coreCharge == "" || coreCharge == undefined) {
                this.AddToCart(false, "", "")
            }
            else {
                $('#CoreChargePopUp').modal('show');
            }

        }
    }
    /**
     * CIP_PS_04
     * */
    /*[04/06/22,Bug ID:2029]Restricting the user to add decimal value for thr qty Priyanka D */
    CheaperItemQtyChange = (e) => {

        const re = SDIConstants.quantityRegEX;

        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                this.setState({ CheaperItemQty: e.target.value })
            }
        }
    }
    //CheaperItemQtyChange = (e) => {
    //    this.setState({ CheaperItemQty: e.target.value })
    //}
    showitemdetails = (e) => {
        e.preventDefault();

        let ItemId = this.state.CheaperItem.customerPartnumber_CatalogZero;
        let quantity = this.state.CheaperItemQty;
        let ItemSupplierName = this.state.CheaperItem.supplierName;
        let ItemClientPartNum = this.state.CheaperItem.clientPartNumber;
        let ItemPrice = this.state.CheaperItem.ItemPrice;
        let ItemDescription = this.state.CheaperItem.longdescriptionone;
        let ItemMFGPartNumber = this.state.CheaperItem.manfPartNumber;
        let ItemManufacturerName = this.state.CheaperItem.manufacturer;
        let ItemUOM = this.state.CheaperItem.UOM;
        let SAP_Article_Number = this.state.CheaperItem.customer_part_number_woprefix == "-" ? " " : this.state.CheaperItem.customer_part_number_woprefix;
        let ItemImage = this.state.CheaperItem.ThumbnailImagefile;
        let vendor = this.state.CheaperItem.vendor_id
        let FavitemImage = this.state.FavitemImage
        let Detail = this.state.CheaperItem


        $('#CheaperItemPopup').modal('hide');
        if (e) {
            e.preventDefault();
        }
        //let qtt = ""
        //if (qt != null) {
        //    if (qt.includes('^')) {
        //        qtt = qt.split('^')[0];
        //    }
        //    else {
        //        qtt = qt;
        //    }
        //}
        //let FilteredSearch = this.state.FilteredSearchResults
        //let SelectedValue = []
        //SelectedValue =
        let Itemtypevalue = this.state.Itemtype == "" || this.state.Itemtype == null ? "CAT" : "NONCAT"
        //let Manufactpartnum = SelectedValue.manfPartNumber
        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);

        //WW-1378_WW-1382- Update item detail url to local storage - Nandhini L
        let itemDetailUrl = window.location.href
        CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);

        if (Itemtypevalue != "NONCAT") {
            CookieService.updateLocalStorageValues("Search_ItemFav", this.state.CheaperFavItem);
            CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
            CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", this.state.CheaperItem.manfPartNumber);
            CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", this.state.CheaperItem.manufacturer);
            CookieService.updateLocalStorageValues("ItemDetail_SupplierID", this.state.CheaperItem.vendor_id);
            CookieService.updateLocalStorageValues("ItemDetail_QTY", this.state.CheaperItem.actual_qty);
            CookieService.updateLocalStorageValues("Search_lblpricetext", this.state.CheaperItem.ItemPrice);
            CookieService.updateLocalStorageValues("Search_Descriptiontype", this.state.DescriptionType);
            console.log("ItemDetail_ItemId", CookieService.getLocalStorageValues("ItemDetail_ItemId"))
            //CookieService.updateLocalStorageValues("", FavItem);
            e.preventDefault();
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${ItemId}&ManufacturePartNumber=${this.state.CheaperItem.manfPartNumber}&ManufactureName=${this.state.CheaperItem.manufacturer}&SupplierID=${this.state.CheaperItem.vendor_id}&QTY=${this.state.CheaperItem.actual_qty}`
            });
            window.location.reload()
        }
        else {
            CookieService.updateLocalStorageValues("Search_ItemFav", this.state.CheaperFavItem);
            CookieService.updateLocalStorageValues("Search_supplierName", this.state.CheaperItem.supplierName);
            CookieService.updateLocalStorageValues("Search_lblproductidtext", this.state.CheaperItem.clientPartNumber);
            CookieService.updateLocalStorageValues("Search_lblManufacturerName", this.state.CheaperItem.manufacturer);
            CookieService.updateLocalStorageValues("Search_lblFeaturestext", this.state.CheaperItem.Description);
            CookieService.updateLocalStorageValues("Search_txtClientPartNumber", this.state.CheaperItem.clientPartNumber);
            CookieService.updateLocalStorageValues("Search_lblDescriptionText", this.state.CheaperItem.longdescriptionone);
            CookieService.updateLocalStorageValues("Search_AttributeName", this.state.CheaperItem.AttributeName);
            CookieService.updateLocalStorageValues("Search_AttributeValue", this.state.CheaperItem.AttributeValue);
            CookieService.updateLocalStorageValues("Search_lblClientDesc", this.state.CheaperItem.clientDesc);
            CookieService.updateLocalStorageValues("Search_lblUOM", this.state.CheaperItem.UOM);
            CookieService.updateLocalStorageValues("Search_lblCategory", this.state.CheaperItem.UNSPSCCategory);
            CookieService.updateLocalStorageValues("Search_lblManufacturerPartNumber", this.state.CheaperItem.manfPartNumber);
            CookieService.updateLocalStorageValues("Search_UNSPSC", this.state.CheaperItem.UNSPSC);
            CookieService.updateLocalStorageValues("Search_ThumbnailImage", this.state.CheaperItem.ThumbnailImagefile);
            CookieService.updateLocalStorageValues("Search_lblCurrencyCode", this.state.CheaperItem.CurrencyCd);
            CookieService.updateLocalStorageValues("Search_btnShowExtndOraDesc", this.state.CheaperItem.ExtndDesc);
            CookieService.updateLocalStorageValues("Search_lblpricetext", this.state.CheaperItem.ItemPrice);
            CookieService.updateLocalStorageValues("Search_VendorId", this.state.CheaperItem.vendor_id);
            CookieService.updateLocalStorageValues("Search_Supplieritemid", this.state.CheaperItem.supplier_part_number);
            CookieService.updateLocalStorageValues("ItemDetail_ItemId", this.state.CheaperItem.ItemId);
            CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", this.state.CheaperItem.Manufactpartnum);
            CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", this.state.CheaperItem.manufacturer);
            CookieService.updateLocalStorageValues("ItemDetail_SupplierID", this.state.CheaperItem.vendor_id);
            CookieService.updateLocalStorageValues("ItemDetail_QTY", this.state.CheaperItem.actual_qty);
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${ItemId}&ManufacturePartNumber=${this.state.CheaperItem.manfPartNumber}&ManufactureName=${this.state.CheaperItem.manufacturer}&SupplierID=${this.state.CheaperItem.vendor_id}&QTY=${this.state.CheaperItem.actual_qty}&origin=itemDetail`
            });
        }
    }

    //[1/3/21], PC_ID_15, WW-286, Dhevanesam R
    AddToCart = (bool, CoreCharge, Addtocart) => {
        const {t}=this.props
        /*[04/06/22,Bug ID:2017]Restricting the user to add the same Door item  to Shopping cart when Item is already available in the cart. Priyanka D */
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        let DoorItem = "";
        let KenstanItem = "";
        /*[05/03/22,PC_A1QA-172 and A1QA-169], Priyanka D */
        let kenstanKey = false;
        /*[04/26/22,PC_A1QA-168_05], Priyanka D */
        let EnersysItem = "";
        CartStorage.forEach((val) => {
            if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath[0] != " ") {
                //[12/21/22, PC_WW-552_FE_29], Dhevanesam R
                if (val.FilePath[0].toUpperCase().includes('ENERSYS')) {
                    EnersysItem = EnersysItem.concat(val.Itemid);
                } else if (val.FilePath != null && val.FilePath[0].toUpperCase().includes('DOORFORM')) {
                    DoorItem = DoorItem.concat(val.Itemid);
                } if (val.FilePath != null && val.FilePath.toUpperCase().includes('KENSTAN')) {
                    KenstanItem = KenstanItem.concat(val.Itemid);
                }
            }
        });


        //Item Details - Invalid Min Order Qty added to cart - Deepthi
        if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
            // alert('Quantity Entered Is Below The Minimum Order Quantity');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity Entered Is Below The Minimum Order Quantity'
            });
            return;
        }
        else if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            // alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Entered Quantity Does Not Match the Minimum Order Quantity Sequence'
            });
            return;
        }
        /*[01/30/22, PC_EF_04, Priyanka.D]*/
        let EnersysFormVaue = ""
        this.state.coreChargeBol = bool;
        if (Addtocart == "Addtocart") {
            this.setState({ AddtocartCH: true });
            $('#CheaperItemPopup').modal('hide');
        }
        if (CoreCharge == "CoreCharge") {

            if (this.state.ItemDetail.core_charges == "\\N" || this.state.ItemDetail.core_charges == "" || this.state.ItemDetail.core_charges == undefined) {
            }
            else {
                $('#CoreChargePopUp').modal('show');
                return;
            }

        }
        console.log("CookieService.getLocalStorageValues", CookieService.getLocalStorageValues("ItemDetail_ItemId"))
        console.log("CookieService.getLocalStorageValues", this.state.ItemId)
        if (this.state.AddtocartCH) {
            this.state.coreChargeBol = true;
        }

        let ItemId = this.state.ItemId;
        let quantity = $('#QuantityTxt').val();;
        let ItemSupplierName = this.state.ItemSupplierName;
        let ItemClientPartNum = this.state.ItemClientPartNum;
        let ItemPrice = this.state.ItemPrice;
        let ItemDescription = this.state.ItemDescription;
        let ItemMFGPartNumber = this.state.ItemMFGPartNumber;
        let ItemManufacturerName = this.state.ItemManufacturerName;
        let ItemUOM = this.state.ItemUOM;
        let SAP_Article_Number = this.state.SAP_Article_Number == "-" ? " " : this.state.SAP_Article_Number;
        let ItemImage = this.state.ItemImage;
        let vendor = vendorId
        let FavitemImage = this.state.FavitemImage

        //[1/3/21], PC_ID_15, WW-286, Dhevanesam R
        if (this.state.coreChargeBol) {
            ItemId = this.state.CheaperItem.customerPartnumber_CatalogZero;
            quantity = this.state.CheaperItemQty;
            ItemSupplierName = this.state.CheaperItem.supplierName;
            ItemClientPartNum = this.state.CheaperItem.clientPartNumber;
            ItemPrice = this.state.CheaperItem.ItemPrice;
            ItemDescription = this.state.CheaperItem.longdescriptionone;
            ItemMFGPartNumber = this.state.CheaperItem.manfPartNumber;
            ItemManufacturerName = this.state.CheaperItem.manufacturer;
            ItemUOM = this.state.CheaperItem.UOM;
            SAP_Article_Number = this.state.CheaperItem.customer_part_number_woprefix == "-" ? " " : this.state.CheaperItem.customer_part_number_woprefix;
            ItemImage = this.state.CheaperItem.ThumbnailImagefile;
            vendor = this.state.CheaperItem.vendor_id;
            FavitemImage = this.state.FavitemImage

        }
        //let quantity = 0
        //quantity = $('#QuantityTxt').val();
        //if (vendorId == "W999999999") {
        //    if (QTYAvail != null) {
        //        if (parseInt(QTYAvail) < parseInt(quantity)) {
        //            let str = 'Available quantity for this item: ' + QTYAvail
        //            alert(str);
        //            return;
        //        }
        //    }
        //}
        let AttributeNameLocal = [];
        let AttributeValueLocal = [];
        AttributeNameLocal = this.state.AttributeName != null ? this.state.AttributeName.split("|") : null;
        AttributeValueLocal = this.state.AttributeValue != null ? this.state.AttributeValue.split("|") : null;
        let quantityValid = quantity % 1
        let Itemid = ItemId != null && ItemId != undefined && ItemId != "" ? ItemId : "P"
        let form = "";
        let DoorFormValue = "";
        /*[05/31/22, PC_WW-401_01]Priyanka D*/
        let OrderNonCatalogItemL = [];
        let ItemDetails = {
            ItemId: Itemid,
            txtSupplier: ItemSupplierName,
            txtSupplierID: this.props.location.state.ItemData.vendor_id,
            txtSuppPartNum: ItemClientPartNum,
            txtEstPrice: this.props.location.state.ItemData.ItemPrice,
            txtDesc: this.props.location.state.ItemData.txtDesc,
            txtMfgPartNum: ItemMFGPartNumber,
            txtMfgName: ItemManufacturerName,
            txtQty: quantity,
            image_url: this.state.ItemImage,
            DropUOM: ItemUOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: "",
            EMPCC: "",
            DUeDate: this.state.DueDate,
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: this.state.SAP_Article_Number,
            ItemCat: this.state.Item_cat,
            MIN_ORD_QTY: this.state.MIN_ORD_QTY,
            //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
            CORE_CHARGE: this.state.ItemDetail.core_charges
        }
        OrderNonCatalogItemL.push(ItemDetails)
        let AddToCartBO = {
            ItemDetails: [],
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: this.state.ItemImage,
            Session_PUNCHIN: "",
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false,
            MobileAPICall: false,
            SESSION_ID: CookieService.getLocalStorageValues("Session_ID"),//Pass the value of session ID
        }

        //let AddToCartBO = {
        //    txtItemID: Itemid,
        //    Quantity: quantity,
        //    txtSupplier: ItemSupplierName,
        //    txtSuppPartNum: ItemClientPartNum,
        //    txtEstPrice: ItemPrice,
        //    txtDesc: ItemDescription,
        //    txtMfgPartNum: ItemMFGPartNumber,
        //    txtMfgName: ItemManufacturerName,
        //    txtQty: quantity,
        //    DropUOM: ItemUOM,
        //    rblcatalogVisible: false,
        //    Image_Url: this.state.ItemImage,
        //    filePath: "",
        //    Session_PUNCHIN: "",
        //    Session_Noncat: CookieService.getLocalStorageValues("Session_Noncat"),
        //    Session_BUSUNIT: this.state.Login_UserBU,
        //    Session_USERID: this.state.Login_UserId,
        //    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
        //    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
        //    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
        //    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
        //    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
        //    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
        //    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
        //    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
        //    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
        //    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
        //    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
        //    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
        //    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
        //    Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
        //    Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
        //    Session_ImageLocPath: this.state.ItemImage,
        //    SAP: SAP_Article_Number,
        //    Supplier_id: vendor,
        //    Item_cat: this.state.Item_cat,
        //    MIN_ORD_QTY: this.state.MIN_ORD_QTY,
        //    /*[12/24/21, PC_SC_11], Priyanka D//Passing the Location value */ 
        //    Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "",
        //    //[12/22/21], PC_ID_09, WW-286, Dhevanesam R
        //    CORE_CHARGE: this.state.ItemDetail.core_charges,
        //    DUeDate: this.state.DueDate,
        //}
        if (AttributeNameLocal != null && AttributeNameLocal != undefined) {
            if (AttributeNameLocal.length > 0) {
                AttributeNameLocal.map((val, index) => {
                    let AttributeName = val.trim()
                    let AttributeValue = AttributeValueLocal[index].replace(/\s/g, "");
                    if (AttributeName.trim() == 'FORM') {
                        if (AttributeValue.indexOf('KENSTAN') > -1) {
                            /*[05/03/22,PC_A1QA-172 and A1QA-169], Priyanka D */
                            form = AttributeValueLocal[index];
                            let KenstanList = CookieService.getLocalStorageValues("KenstanList")
                            if (KenstanList.length > 0) {
                                KenstanList.forEach((val) => {
                                    if (val.includes('KEY')) {
                                        if (AttributeValueLocal[index].includes('KEY')) {
                                            kenstanKey = true

                                        }
                                    }
                                });
                            }

                        }
                        /*[04/01/22,PC_DF_04,WW-371],Priyanka D */
                        else if (AttributeValue.indexOf('DOORS�INTERIOR NON-FIRE RATED ') > -1) {
                            DoorFormValue = AttributeValueLocal[index];
                            this.setState({ DoorFormValue: DoorFormValue, DoorForm: true })
                            CookieService.updateLocalStorageValues("DoorFormValue", DoorFormValue)
                            CookieService.updateLocalStorageValues("DoorForm", true)
                        }
                        else if (AttributeValue.indexOf("BATTERY") > -1 || AttributeValue.indexOf("CHARGER") > -1) {
                            /*[01/30/22, PC_EF_04, Priyanka.D]*/
                            EnersysFormVaue = AttributeValueLocal[index];
                            this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + AttributeValueLocal[index].toLowerCase() })
                            CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                            CookieService.updateLocalStorageValues("EnersysForm", true)
                        }
                    } else {
                        this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
                        CookieService.updateLocalStorageValues("EnersysFormVaue", "")
                        CookieService.updateLocalStorageValues("EnersysForm", false)
                        CookieService.updateLocalStorageValues("DoorFormValue", "")
                        CookieService.updateLocalStorageValues("DoorForm", false)
                    }
                });
            } else {
                this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
                CookieService.updateLocalStorageValues("EnersysFormVaue", "")
                CookieService.updateLocalStorageValues("EnersysForm", false)
                CookieService.updateLocalStorageValues("DoorFormValue", "")
                CookieService.updateLocalStorageValues("DoorForm", false)
            }

        } else {
            this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
            CookieService.updateLocalStorageValues("EnersysFormVaue", "")
            CookieService.updateLocalStorageValues("EnersysForm", false)
            CookieService.updateLocalStorageValues("DoorFormValue", "")
            CookieService.updateLocalStorageValues("DoorForm", false)
        }
        //[1/3/21], PC_ID_15, WW-286, Dhevanesam R  

        /*[05/03/22,PC_A1QA-172 and A1QA-169], Priyanka D */
        let test = CookieService.getLocalStorageValues("KenstanList");
        if (kenstanKey == true) {
            // alert("Kensktan key is already added to cart, only one key allow for one cart. Please go to cart to increase quantity");
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Kensktan key is already added to cart, only one key allow for one cart. Please go to cart to increase quantity'
            });
        }
        else if (CookieService.getLocalStorageValues("KenstanList").indexOf(Itemid) > -1) {
            //alert("This Kensktan lock is already in the cart. Please go to cart to increase quantity"); {/*NEW**CHANGED(11/8/2021)******/ }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('This Kensktan lock is already in the cart. Please go to cart to increase quantity')
            });
            return
        }
        //else if (CookieService.getLocalStorageValues("KenstanList").indexOf(Itemid) > -1) {
        //    alert("This Kensktan Item is already in the cart.Please go to cart to increase quantity")
        //} else if (KenstanItem != "") {
        //    if (KenstanItem.indexOf(Itemid) > -1) {
        //        alert("This Kensktan Item is already in the cart.Please go to cart to increase quantity")
        //    }
        //}
        else if (ItemManufacturerName.indexOf('KENSTAN') > -1) {

            if (form.trim().indexOf('KEY') > -1) {
                CookieService.updateLocalStorageValues("IsKenstanKey", true);
            }

            this.props.history.push({
                pathname: "/kenstanform",
                state: { item: AddToCartBO, form: form, origin: 'itemDetail', qty: quantity, WO: this.props.location.state.WO, pagename: 'ItemDetail', form: form }
            });
            /*[01/30/22, PC_EF_04, Priyanka.D]*/
        } else if (this.state.QtyDisable) {
            this.setState({ AddtoCartBO: AddToCartBO })
            /*[04/26/22,PC_A1QA-168_06], Priyanka D */
            if (CookieService.getLocalStorageValues("EnersysList") != null && CookieService.getLocalStorageValues("EnersysList") != undefined && CookieService.getLocalStorageValues("EnersysList") != "") {
                if (CookieService.getLocalStorageValues("EnersysList").indexOf(Itemid) > -1) {
                    //  alert("This Enersys Item is already added in the cart");
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('This Enersys Item is already added in the cart')
                    });
                    return; {/*NEW**CHANGED(11/8/2021)******/ }
                } else {
                    $('#EnersysEmployee').modal('show');
                }
            } else if (DoorItem.indexOf(Itemid) > -1) {
                // alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('This Door Item is already added in the cart. Please go to cart to increase quantity !')
                });
                return
            }
            else {

                $('#EnersysEmployee').modal('show');
            }
        }
        /*[04/01/22,PC_DF,WW-371],Check for cart contains Door item Priyanka D */
        else if (CookieService.getLocalStorageValues("DoorForm") == true) {
            /*[04/06/22,Bug ID:2017]Restricting the user to add the same Door item  to Shopping cart when Item is already available in the cart. Priyanka D */
            if (CookieService.getLocalStorageValues("Doorlist") != undefined) {
                let arr = CookieService.getLocalStorageValues("Doorlist")
                if ((CookieService.getLocalStorageValues("Doorlist").indexOf(Itemid)) > -1 || DoorItem.indexOf(Itemid) > -1) {
                    // alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('This Door Item is already added in the cart. Please go to cart to increase quantity !')
                    });
                    return
                } else if (DoorItem.indexOf(Itemid) > -1) {
                    // alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('This Door Item is already added in the cart. Please go to cart to increase quantity !')
                    });
                    return
                } else {
                    this.props.history.push({
                        pathname: "/DoorForm",
                        state: { item: AddToCartBO, qty: this.state.Quantityvalue, origin: 'itemDetail', pagename: 'ItemDetail', searchKey: this.state.SearchKeyWord, form: "DoorForm" }
                    });
                }
            } else if (DoorItem.indexOf(Itemid) > -1) {
                //alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('This Door Item is already added in the cart. Please go to cart to increase quantity !')
                });
                return
            } else {
                this.props.history.push({
                    pathname: "/DoorForm",
                    state: { item: AddToCartBO, qty: this.state.Quantityvalue, origin: 'itemDetail', pagename: 'ItemDetail', searchKey: this.state.SearchKeyWord, form: "DoorForm" }
                });
            }
            /*[04/18/22,PC_WW-359_01], Priyanka D */
        } else if (Itemid.length < 51) {
            if (quantity != 0 && quantityValid == 0) {


                ItemDetailNewAction.addToCartItems(AddToCartBO);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
            else {
                //  alert("Enter a valid Quantity");
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Enter a valid Quantity'
                });
                return;
            }
        }
        else {
            //****NEW*****ADDED(1/2/2021)****
            if (quantity != 0 && quantityValid == 0) {
                let it = this.state.ItemId
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: ' Item' + it + 'is not added to cart due to technical issue. Contact SDI customer care.'
                });
                // alert(" Item " + it + " is not added to cart due to technical issue. Contact SDI customer care.")
                return;
            }
            else {
                // alert("Enter a valid Quantity");
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: 'Enter a valid Quantity'
                });
                return;
            }

            //  alert("Techincal Issue Contact SDI Customer Care")****REMOVED

            //*****END************************
        }
    }
    AddToCartResponse = () => {

        let AddCartResponse = {}
        try {
            AddCartResponse = JSON.parse(SearchResultsStore.SuccessStatus);
        }
        catch (ex) {
            AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);

        }


        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Item added to cart successfully'
            });

            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            ///*[03/04/22, PC_01 WW-362], Priyanka D,  */
            //alert("Item Successfully added to cart");
            //WW-243_Refresh_PC_01 (3/28/2022)-Aparna
            /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
            //MenuAction.refreshMasterData();
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            // alert("Techincal Issue Contact SDI Customer Care");
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Techincal Issue Contact SDI Customer Care'
            });
        }
    }

    TabClick = (TabName) => {
        TabclickTitle = TabName;
        let TabClickBO = {
            Session_USERID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            ItemID: this.state.ItemId,
            TabName: TabName,
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Session_SDIEmp: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_DEPTIDN1: CookieService.getLocalStorageValues("Session_DeptIdN1"),
            CurrentPage_Url: "/SDIXZEUS/itemdetailnew"
        }
        ItemDetailNewAction.TabClick(TabClickBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    TabResponse = () => {
        let TabClickList = JSON.parse(ItemDetailNewStore.TabClickList);

        switch (TabclickTitle) {
            case "ITM": {
                let DetailreaderTable = [];
                DetailreaderTable = TabClickList.Detailreader;
                let BUItemsTable = [];
                BUItemsTable = TabClickList.BUItems;
                let LabelValueTable = [];
                LabelValueTable = TabClickList.LabelValue;
                let COlumnTilteTable = [];
                COlumnTilteTable = TabClickList.COlumnTilte;
                let IssueChargeCodeL = "";
                let FirstChargeCodeL = "";
                let HazardCodeL = "";
                let InspectionRequiredL = "";
                let EquipmentTagL = "";
                let RegrindL = "";
                let PurchasingDeptL = "";
                let MachineControlL = "";
                let DrawingCodeL = "";
                let MachineNumL = "";
                let StandardLaedTimeL = "";
                let CriticalSpareL = "";
                if (DetailreaderTable != null && DetailreaderTable != undefined) {
                    if (DetailreaderTable.length > 0) {
                        IssueChargeCodeL = DetailreaderTable[0].ISA_CUST_CHARGE_CD;
                        FirstChargeCodeL = DetailreaderTable[0].ISA_SET_CHARGE_CD;
                        HazardCodeL = DetailreaderTable[0].HAZ_CLASS_CD;
                        InspectionRequiredL = DetailreaderTable[0].INSPECT_CD == "Y" ? "Yes" : "No";
                        EquipmentTagL = DetailreaderTable[0].ISA_ETAG_CODE;
                        RegrindL = DetailreaderTable[0].INSPECT_CD == "Y" ? "Yes" : "No";
                        PurchasingDeptL = DetailreaderTable[0].ISA_PDS_CODE;
                        MachineControlL = DetailreaderTable[0].ISA_MACHINE_NO;
                        DrawingCodeL = DetailreaderTable[0].ISA_DRAWING_CODE;
                        StandardLaedTimeL = DetailreaderTable[0].STD_LEAD;
                    }

                }
                if (LabelValueTable) {
                    LabelValueTable.map((val, index) => {
                        MachineNumL = val['Machine Number'];
                        CriticalSpareL = val['Critical Spare'];
                    });
                }
                this.setState({
                    BUItemsState: BUItemsTable,
                    IssueChargeCode: IssueChargeCodeL,
                    FirstChargeCode: FirstChargeCodeL,
                    HazardCode: HazardCodeL,
                    InspectionRequired: InspectionRequiredL,
                    EquipmentTag: EquipmentTagL,
                    Regrind: RegrindL,
                    PurchasingDept: PurchasingDeptL,
                    MachineControl: MachineControlL,
                    DrawingCode: DrawingCodeL,
                    MachineNum: MachineNumL,
                    StandardLaedTime: StandardLaedTimeL,
                    CriticalSpare: CriticalSpareL,
                })
                break
            }
            case "USE": {
                let CurrentYear = TabClickList.Table1
                let PreviousYear = TabClickList.dtPrevious
                this.setState({ CurrentYearState: CurrentYear, PreviousYearState: PreviousYear })
                break
            }
            case "ISS": {
                let IssueTable = TabClickList.IssuesReader
                this.setState({ IssueState: IssueTable })
                break
            }
            case "BIN": {
                let LocDataSetTable = TabClickList.LocDataSet
                this.setState({ LocDataSetState: LocDataSetTable })
                break
            }
            case "SITE": {
                let MultiSiteDisplayTable = TabClickList.MultiSiteDisplay
                this.setState({ MultiSiteDisplayState: MultiSiteDisplayTable })
                break
            }
            case "CYCTRANS": {
                let TransTable = TabClickList.TransDetails
                let StoreRoomTable = TabClickList.StoreRoom
                this.setState({ TransTableState: TransTable, StoreRoomState: StoreRoomTable })
                break
            }
            case "CYCPURC": {
                let PurchaseTable = TabClickList.Table
                this.setState({ PurchaseState: PurchaseTable })
                break
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    BindBUItems = () => {
        let qty = CookieService.getCookieValue("ItemDetail_QTY");
        if (this.state.BUItemsState) {
            return this.state.BUItemsState.map((val, index) => {
                return (<tr>
                    <td>{val.BUSINESS_UNIT}</td>
                    <td>{val.BUSINESS_UNIT}</td>
                    <td>{val.BUSINESS_UNIT}</td>
                    <td>{val.NO_REPLENISH_FLG}</td>
                    <td>{val.REORDER_POINT}</td>
                    <td>{val.QTY_MAXIMUM}</td>
                    <td>{val.actual_qty}</td>
                </tr>)
            });
        }
    }
    //' PC_WW-641_07-Priyanka  D
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    bindEquParts = (type) => {
        debugger
        if (type === "equParts") {
            if (this.state.equParts != undefined && this.state.equParts != null) {
                return this.state.equParts.map((val, index) => {
                    return (
                        //pc-1136-05 removing the css class 10/07/2024 S.Sanjay
                        <span>
                            <a >
                                {val.ItemID}
                            </a>
                            {index != this.state.equParts.length - 1 ?
                                <label className=" itemHyperlink mr-1 equparts">,</label> : null}
                        </span>
                    )
                });
            }
        } else {
            if (this.state.equivalentParts != undefined && this.state.equivalentParts != null) {
                return this.state.equivalentParts.map((val, index) => {
                    return (
                        //pc-1136-05 removing the css class 10/07/2024 S.Sanjay
                        <span>
                            <a className={` ${index === 0 && SearchKeyWord === val.MFG_PART_NUM ? 'equivalent-highlight' : ''}`} >
                                {val.MFG_PART_NUM}
                            </a>
                            {index != this.state.equivalentParts.length - 1 ?
                                <label className=" itemHyperlink mr-1 equparts">,</label> : null}
                        </span>
                    )
                });
            }

        }
    }
    navigateItemdetails = (supplierPartNum, Manufacturer, ManufacturerPart, Vendor_Id, event) => {
        const queryParams = new URLSearchParams(window.location.search)
        const previtemid = queryParams.get('ItemId');
        const prevvendor = queryParams.get('SupplierID');
        const prevmfg = queryParams.get('ManufactureName');
        const prevmfgpart = queryParams.get('ManufacturePartNumber');
        if (event) {
            event.preventDefault();
        }
        let prevvalue = {
            ItemID: previtemid,
            MfgPartNum: prevmfgpart,
            MfgName: prevmfg,
            VendorID: prevvendor,
        }
        let value = {
            ItemID: supplierPartNum,
            MfgPartNum: ManufacturerPart,
            MfgName: Manufacturer,
            VendorID: Vendor_Id,
        }
        this.props.history.push({
            pathname: `\itemdetailnew`,
            search: `?ItemId=${supplierPartNum}&ManufacturePartNumber=${ManufacturerPart}&ManufactureName=${Manufacturer}&SupplierID=${Vendor_Id}&QTY=""&origin=itemDetail&LAST_ITEM_VENDOR_ID=${prevvendor}&LAST_ITEM_VENDOR_ITEM_ID=${previtemid}&prevmfg=${prevmfg}&prevmfgpart=${prevmfgpart}`,
            state: { WO: JSON.parse(localStorage.getItem("WONum")), origin: 'itemDetail', Suggesstions: false, ItemId: supplierPartNum, ManufacturePartNumber: ManufacturerPart, ManufactureName: Manufacturer, vendor_id: Vendor_Id, QTY: "1", LAST_ITEM_VENDOR_ID: prevvendor, LAST_ITEM_VENDOR_ITEM_ID: previtemid, ItemData: prevvalue, IsAltPart: true }
        });
        //  window.open('https://localhost:44317/itemdetailnew?ItemId=4UHA7&ManufacturePartNumber=4UHA7&ManufactureName=Dayton&SupplierID=W000000036', '_blank', 'noopener,noreferrer');
        console.log("history", this.props.history)
        // this.laodItemDetails()
        //document.location.reload()
        this.laodImageItemDetails("ItemDetails", value, true, previtemid, prevvendor); //WW-522_PC_08 (12/15/2022)-Aparna

    }
    //'[03/07/2023-PC_WW-643_16,Priyanka]
    bindAlsoFits = () => {

        if (this.state.alsoFits != undefined && this.state.alsoFits != null) {
            return this.state.alsoFits.map((val, index) => {
                return (<tr>
                    <td>{val.MANUFACTURER}</td>
                    <td>{val.MFG_PART_NUM}</td>
                    <td>{val.ISA_MAKE}</td>
                    <td>{val.ISA_MODEL}</td>
                </tr>)
            });
        }
    }
    UsageTabBind = () => {
        if (this.state.CurrentYearState && this.state.PreviousYearState) {
            let PreviousYear = this.state.PreviousYearState;
            return this.state.CurrentYearState.map((val, index) => {
                return (
                    <tr>
                        <td>{val['Current Year']}</td>
                        <td>{val.Quantity}</td>
                        <td>{PreviousYear[index]['Previous Year']}</td>
                        <td>{PreviousYear[index].Quantity}</td>
                    </tr>

                )

            });
        }
    }
    IssueTabBind = () => {
        if (this.state.IssueState) {
            return this.state.IssueState.map((val, index) => {
                return (<tr>
                    <td>{val.TranDate}</td>
                    <td>{val.Type}</td>
                    <td>{val.EmpID}</td>
                    <td>{val.Work_Order}</td>
                    <td>{val.Name}</td>
                    <td>{val.ChargeCode}</td>
                    <td />
                </tr>)
            });
        }
    }
    BinLocationBind = () => {
        if (this.state.LocDataSetState != undefined && this.state.LocDataSetState != null) {


            return this.state.LocDataSetState.map((val, index) => {
                let location = val.STORAGE_LOC
                if (location != undefined && location != null) {
                    parts = location.split(' ')
                }
                return (<tr>
                    {/* WW-534 Changed Inventory tab fields as in Mobile APP - [11/1/2022] Poornima S*/}
                    <td>{val.ISA_CRIB_IDENT != "" ? val.ISA_CRIB_IDENT : "-"}</td>
                    <td>{val.QTY_ONHAND != "" ? val.QTY_ONHAND : "-"}</td>
                    <td>{val.QTY_AVAILABLE != "" ? val.QTY_AVAILABLE : "-"}</td>
                    <td>{val.QTY_RESERVED_NOT_SHIPPED != "" ? val.QTY_RESERVED_NOT_SHIPPED : "-"}</td>
                    <td>{parts[0]}</td>
                    <td>{parts[1]}</td>
                    <td>{parts[2]}</td>
                    <td>{parts[3]}</td>
                    <td>{parts[4]}</td>
                    <td>{val.DEFAULT_LOC != "" ? val.DEFAULT_LOC : "-"}</td>
                    <td>{val.QTY_RESERVED_NOT_PICKED != "" ? val.QTY_RESERVED_NOT_PICKED : "-"}</td>
                </tr>)
            });
        }
    }
    MultiSiteBind = () => {
        if (this.state.MultiSiteDisplayState) {
            return this.state.MultiSiteDisplayState.map((val, index) => {
                return (<tr>
                    <td>{val.INVITEMID}</td>
                    <td>{val.Description}</td>
                    <td>{val.UOM}</td>
                    <td>{val.QOH}</td>
                    <td>{val.SiteName}</td>
                </tr>)
            });
        }
    }
    PurchaseTabBind = () => {
        if (this.state.PurchaseState) {
            return this.state.PurchaseState.map((val, index) => {
                return (<tr>
                    <td>{val.INV_ITEM_ID}</td>
                    <td>{val.PO_ID}</td>
                    <td>{val.LINE_NBR}</td>
                    <td>{val.CANCEL_STATUS}</td>
                    <td>{val.PO_DT.substring(0, 10)}</td>
                    <td>{val.QTY_PO}</td>
                    <td>{val.NET_RCVD_QTY}</td>
                </tr>)
            });
        }
    }
    TransTabBind = () => {
        if (this.state.TransTableState) {
            let StoreRoomStateL = []
            StoreRoomStateL = this.state.StoreRoomState
            return this.state.TransTableState.map((val, index) => {
                return (<tr>
                    <td>{val.TRANSACTION_DATE.substring(0, 10)}</td>
                    <td>{val.UNIT_MEASURE_STD}</td>
                    <td>{val.QTY}</td>
                    <td>{val.TRANSACTION_GROUP}</td>
                    <td>{val.ORDER_NO}</td>
                    <td>{val.ORDER_INT_LINE_NO}</td>
                    <td>{val.ORDER_NO}</td>
                    <td>{val.ISA_WORK_ORDER_NO}</td>
                    <td>{val.OPRID1}</td>
                    <td>{val.OPRID}</td>
                    <td>{this.state.StoreRoomState ? StoreRoomStateL[0].StoreRoom : ""}</td>
                    <td>{this.state.StoreRoomState ? StoreRoomStateL[0].StoreRoomDesc : ""}</td>
                    <td>{val.RECEIVER_ID}</td>
                    <td>{val.RECV_LN_NBR}</td>
                    <td>{val.ISA_CUST_PO_LINE}</td>
                </tr>)
            });
        }
    }
    sortingColumns = (Gridtype, Column, Sortingtype) => {

        if (Gridtype == 1) {
            let BuitemsValue = this.state.BUItemsState;
            let sorted = []
            if (Sortingtype == "down") {
                if (Column == "Owned") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.BUSINESS_UNIT - y.BUSINESS_UNIT;
                    });
                }
                else if (Column == "Store") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.BUSINESS_UNIT - y.BUSINESS_UNIT;
                    });
                }
                else if (Column == "StroeDescp") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.BUSINESS_UNIT - y.BUSINESS_UNIT;
                    });
                }
                else if (Column == "Replenish") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.NO_REPLENISH_FLG - y.NO_REPLENISH_FLG;
                    });
                }
                else if (Column == "Reorder") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.REORDER_POINT - y.REORDER_POINT;
                    });
                }
                else if (Column == "Maxi") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.QTY_MAXIMUM - y.QTY_MAXIMUM;
                    });
                }
                else if (Column == "Quantity") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return x.QTY_ONHAND - y.QTY_ONHAND;
                    });
                }
            }
            else {
                if (Column == "Owned") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.BUSINESS_UNIT - x.BUSINESS_UNIT;
                    });
                }
                else if (Column == "Store") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.BUSINESS_UNIT - x.BUSINESS_UNIT;
                    });
                }
                else if (Column == "StroeDescp") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.BUSINESS_UNIT - x.BUSINESS_UNIT;
                    });
                }
                else if (Column == "Replenish") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.NO_REPLENISH_FLG - x.NO_REPLENISH_FLG;
                    });
                }
                else if (Column == "Reorder") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.REORDER_POINT - x.REORDER_POINT;
                    });
                }
                else if (Column == "Maxi") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.QTY_MAXIMUM - x.QTY_MAXIMUM;
                    });
                }
                else if (Column == "Quantity") {
                    sorted = BuitemsValue.sort(function (x, y) {
                        return y.QTY_ONHAND - x.QTY_ONHAND;
                    });
                }
            }
            console.log("sorting", BuitemsValue);
            this.setState({
                BUItemsState: sorted
            })
        }
        else {
            let sorted = []
            if (Sortingtype == "down") {
                if (Column == "ItemId") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.INV_ITEM_ID - y.INV_ITEM_ID;
                    });
                }
                else if (Column == "POID") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.PO_ID - y.PO_ID;
                    });
                }
                else if (Column == "LineNBR") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.LINE_NBR - y.LINE_NBR;
                    });
                }
                else if (Column == "CancelStatus") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.CANCEL_STATUS - y.CANCEL_STATUS;
                    });
                }
                else if (Column == "PODate") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.PO_DT - y.PO_DT;
                    });
                }
                else if (Column == "Quantity") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.QTY_PO - y.QTY_PO;
                    });
                }
                else if (Column == "NetRec") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return x.NET_RCVD_QTY - y.NET_RCVD_QTY;
                    });
                }
            }
            else {
                if (Column == "ItemId") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.INV_ITEM_ID - x.INV_ITEM_ID;
                    });
                }
                else if (Column == "POID") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.PO_ID - x.PO_ID;
                    });
                }
                else if (Column == "LineNBR") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.LINE_NBR - x.LINE_NBR;
                    });
                }
                else if (Column == "CancelStatus") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.CANCEL_STATUS - x.CANCEL_STATUS;
                    });
                }
                else if (Column == "PODate") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.PO_DT - x.PO_DT;
                    });
                }
                else if (Column == "Quantity") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.QTY_PO - x.QTY_PO;
                    });
                }
                else if (Column == "NetRec") {
                    sorted = this.state.PurchaseState.sort(function (x, y) {
                        return y.NET_RCVD_QTY - x.NET_RCVD_QTY;
                    });
                }
            }
            console.log("sorting", sorted);
            this.setState({
                PurchaseState: sorted
            })
        }
    }
    BindFavForm = (favexist, popup) => {

        //let Itemtypevalue = CookieService.getLocalStorageValues("Search_lblproductidtext") == "" || CookieService.getLocalStorageValues("Search_lblproductidtext") == null ? "CAT" : "NONCAT"
        document.getElementById("lblerror").innerText = "";
        if (!favexist) {
            let kitcomponents = this.state.KIT_Details.replaceAll(",", "~").replaceAll(";", "|")

            let FavSDICatg = this.state.ItemSDICatagory == null || this.state.ItemSDICatagory == "" || this.state.ItemSDICatagory == "-" || this.state.ItemSDICatagory == " " ? "UnClassified" : this.state.ItemSDICatagory;
            this.setState({
                FavItemIdPopUp: this.state.ItemId, FavSDICatgPopUp: FavSDICatg,
                FavItemDescripPopUp: this.state.ItemDescription, FavMFGPopUp: this.state.ItemManufacturerName,
                FavMFGPartNUMPopUp: this.state.ItemMFGPartNumber, txtUOMHidePopUp: this.state.ItemUOM,
                txtMfgItemidHidePopUp: this.state.VendorItemid, FavSupplierPopUp: this.state.ItemSupplierName, FavKit_Components: kitcomponents,
                txtItemidHidePopUp: this.state.ItemId, txtMFGHidePopUp: this.state.VendorId, FavitemImage: this.state.ImageURL,
                FavYourCatg: popup == "Yes" ? this.state.FavYourCatg : "", FavSubCategory: popup == "Yes" ? this.state.FavSubCategory : "", attachmentPathArr: []
            })
            //WW-516
            if (popup != "Yes") {
                $('#FavYourDescrip').val('')
            }

            document.getElementById("txtUOMHide").hidden = true
            document.getElementById("txtMfgItemidHide").hidden = true
            document.getElementById("txtItemidHide").hidden = true
            document.getElementById("txtMFGHide").hidden = true
            document.getElementById("ItemType").hidden = true
            $('#add-fav-popup').modal('show');
            let autoCompleteDataRes = []
            let locsugg = []
            let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
            console.log("Fav_Item_Cat", suggestionsStr)
            if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
                suggestionsStr.forEach((sugg, index) => {
                    autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
                });
                autoCompleteDataRes = autoCompleteDataRes.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }
            let locSubCat = []
            let locSubCatSGG = []
            let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
            console.log("Fav_Item_SubCat", subcatsuggestion)
            if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
                subcatsuggestion.forEach((sugg, index) => {
                    //WW-516_PC_04  (9/30/2022)-Aparna
                    if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                        locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                    }

                });

            }
            if (locSubCat.length > 0) {
                locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
                locSubCatSGG = locSubCatSGG.sort((a, b) =>
                    a.value > b.value ? 1 : -1,
                );
            }
            this.setState({ autocompleteData: autoCompleteDataRes, CategoryErr: false, SubCategoryErr: false, subCategory: locSubCatSGG, subCategoryResults: [], autocompleteDataRstl: autoCompleteDataRes });

        }
        else {
            let deleteFavBO = {
                ItemId: this.state.ItemId,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                MFG: this.state.ItemManufacturerName,
                MFGpartnum: this.state.ItemMFGPartNumber,
                SupplierId: this.state.VendorId,
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ItemDetailNewAction.DeletFavItem(deleteFavBO);
            favexist = false
            this.setState({ attachmentPathArr: [] }); //, SelectedValueImg: SelectedValue.Image, eventFav: targetID, favexist: favexist, Itemtype: Itemtype
        }
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    AddfavItem = (ImgNo) => {

        let itemtypevalue = this.state.ItemTypeFav
        let ItemDescrip = $('#FavYourDescrip').val()
        let ItemCatagory = $('#FavYourCatg').val()
        ItemCatagory = this.state.FavYourCatg;
        //WW-516_PC_21 (9/30/2022) -Aparna
        let ItemSubCategory = this.state.FavSubCategory
        if (itemtypevalue == "CAT") {
            if (ItemCatagory != null && ItemCatagory != undefined && ItemSubCategory != null && ItemSubCategory != undefined) {
                if (ItemCatagory.trim() != "" && ItemSubCategory.trim() != "") {
                    if ((this.state.ItemImage.includes("noimage") && this.state.attachmentPathArr.length == 0 && ImgNo == false)) {
                        $('#add-fav-Img').modal('show');
                        $('#add-fav-popup').modal('hide');
                        return;
                    }
                    else {
                        let FavItemBo = {
                            Session_BUSUNIT: this.state.Login_UserBU,
                            Session_USERID: this.state.Login_UserId,
                            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                            ItemId: this.state.FavItemIdPopUp,
                            YourDesc: ItemDescrip != " " && ItemDescrip != "" ? ItemDescrip.toUpperCase() : "",
                            YourCat: ItemCatagory != " " && ItemCatagory != "" ? ItemCatagory.toUpperCase() : "",
                            YourSubCat: ItemSubCategory != " " && ItemSubCategory != "" ? ItemSubCategory.toUpperCase() : "",
                            SDI_Catagory: this.state.FavSDICatgPopUp,
                            txtItemidHide: this.state.txtItemidHidePopUp,
                            txtMFGHide: this.state.txtMFGHidePopUp,
                            txtUOMHide: this.state.txtUOMHidePopUp,
                            txtMfgItemidHide: this.state.FavMFGPartNUMPopUp,
                            SAP: this.state.FavSAP,
                            Manufacturer: this.state.FavMFGPopUp,
                            WorkOrder: $('#WONUM').val(),
                            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",// localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", sending home store as dafult value for the shipto id(for warhouse item qty check sp)WAL-767-Aparna
                            ImgByteCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                            IsWeb: true,
                            SupplierID: this.state.txtMFGHidePopUp,
                            FileNameCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-522
                            Kit_Components: this.state.FavKit_Components,
                            ISCoreCharge: this.state.ISCoreCharge
                        }/**NEW*(4/12/2021)*(txtMfgItemidHide: this.state.txtMfgItemidHidePopUp)-->txtMfgItemidHide: this.state.FavMFGPartNUMPopUp*/
                        ItemDetailNewAction.catfavItem(FavItemBo)
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        $('#add-fav-popup').modal('hide');
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        this.setState({ CategoryErr: false, SubCategoryErr: false });
                    }
                }
                else {
                    this.setState({ CategoryErr: ItemCatagory.trim() == "" ? true : false, SubCategoryErr: ItemSubCategory.trim() == "" ? true : false });
                }
            }
            else {

                this.setState({ CategoryErr: ItemCatagory == null || ItemCatagory == undefined ? true : false, SubCategoryErr: ItemSubCategory == null || ItemSubCategory == undefined ? true : false });
            }
        }
        else {
            if (ItemCatagory.trim() != "" && ItemCatagory != null && ItemCatagory != undefined) {

                let FavItemBo = {
                    ItemIdType: "NONCAT",
                    YourDesc: ItemDescrip,
                    YourCat: ItemCatagory,
                    Item_Description: this.state.FavItemDescripPopUp,
                    Item_MFG: this.state.FavMFGPopUp,
                    Session_BUSUNIT: this.state.Login_UserBU,
                    Session_USERID: this.state.Login_UserId,
                    MFG_PartNumber: this.state.FavMFGPartNUMPopUp,
                    img_name: this.state.FavitemImage,
                    UOM: this.state.txtUOMHidePopUp,
                    supplierId: this.state.txtMFGHidePopUp,
                    supplierPartNo: this.state.txtMfgItemidHidePopUp,
                    SAP: this.state.SAP_Article_Number == "-" ? " " : this.state.SAP_Article_Number
                }
                ItemDetailNewAction.NoncatfavItem(FavItemBo)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.setState({ CategoryErr: false });
            }
            else {
                this.setState({ CategoryErr: true, attachmentPathArr: [] });
            }
        }
    }
    FavSuccess = () => {
        const { t } = this.props
        let Status = JSON.parse(ItemDetailNewStore.FavitemAddList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("Status", Status)
        let Favstatus = Status.ErrorMsg
        if (Favstatus.length > 0) {
            if (Favstatus[0].Error_Msg == "Favorite item inserted sucessfully") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('Favorite item inserted sucessfully')
                });
                // alert("Favorite item inserted sucessfully")
                this.setState({ FavItem: true })
                MenuAction.refreshMasterData()
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('Technical Issue Try again')
                });
                // alert("Technical Issue Try again")
            }
        }
    }
    SetQuantity = (event) => {

        const re = SDIConstants.quantityRegEX;
        console.log("Quantity", event.target.value)
        if (event.target.value === '' || re.test(event.target.value)) {
            if (event.target.value != "0") {
                //Quantityvalidate = 0
                this.setState({ Quantityvalue: event.target.value });
            }
        }
    };
    handleProfileFormChange = (event, cheapitem) => {

        const re = SDIConstants.quantityRegEX;
        console.log("Quantity", event.target.value);
        let MinOrdQty = "" + this.state.MIN_ORD_QTY;
        let MaxOrdQty = "" + (parseInt(this.state.MIN_ORD_QTY) + parseInt(this.state.MIN_ORD_QTY));
        let IncDecVal;
        //2205 Minimum Order Quantity_ Quantity for minimum order quantity items increment is not proper in item details page -Pavithra R
        if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
            // alert('Quantity Entered Is Below The Minimum Order Quantity');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity Entered Is Below The Minimum Order Quantity'
            });
            return;
        }
        else if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Entered Quantity Does Not Match the Minimum Order Quantity Sequence'
            });
            // alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
            return;
        }

        //2205 Minimum Order Quantity_ Quantity for minimum order quantity items increment is not proper in item details page - Deepthi
        if ((parseInt($(`#QuantityTxt`).val()) < parseInt(MinOrdQty)) ||
            (parseInt($(`#QuantityTxt`).val()) % parseInt(MinOrdQty))) {
            event.preventDefault();
        }




        else if (event.target.value == "-") {
            if (cheapitem != "yes") {//*[12/13/21, PC_IDC_01, WW-275- Added Inc & decr for qty in cheaper item popup, Poornima S]
                IncDecVal = parseInt($(`#QuantityTxt`).val()) - parseInt(MinOrdQty);
                if (IncDecVal < MinOrdQty) {
                    IncDecVal = $(`#QuantityTxt`).val();
                }
            }
            else {
                IncDecVal = parseInt($(`#QuantityTxtCheap`).val()) - parseInt(MinOrdQty);
                if (IncDecVal < MinOrdQty) {
                    IncDecVal = $(`#QuantityTxtCheap`).val();
                }
            }

        }
        else {
            if (cheapitem != "yes") {
                IncDecVal = parseInt($(`#QuantityTxt`).val()) + parseInt(MinOrdQty);
                if (IncDecVal < MaxOrdQty && IncDecVal > MaxOrdQty) {
                    IncDecVal = $(`#QuantityTxt`).val();
                }
            }
            else {
                IncDecVal = parseInt($(`#QuantityTxtCheap`).val()) + parseInt(MinOrdQty);
                if (IncDecVal < MaxOrdQty && IncDecVal > MaxOrdQty) {
                    IncDecVal = $(`#QuantityTxtCheap`).val();
                }
            }
        }

        if (IncDecVal === '' || re.test(IncDecVal)) {
            if (IncDecVal != "0") {
                if (cheapitem != "yes") {
                    this.setState({ Quantityvalue: IncDecVal });
                }
                else {
                    this.setState({ CheaperItemQty: IncDecVal });
                }
            }
        }
    };
    //[1/3/21], PC_ID_15, WW-286, Dhevanesam R
    CoreChargePopUpclose = (e) => {

        $('#CoreChargePopUp').modal('hide');

    }
    /*[04/18/22,PC_WW-386_01], Priyanka D */
    EditImg = () => {

        $('#alertpopup').modal('show');
    }
    /*[04/18/22,PC_WW-386_04], Priyanka D */
    handleAttachment = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let files = event.target.files;
        console.log("event", files);
        ItemDetailNewAction.addAttachment(files);

    }
    //when we tried to add the same file for the second time its not inserting
    onInputClick = (event) => {
        event.target.value = ''
    }
    /*[04/18/22,PC_WW-386_08], Priyanka D */
    EditImageResponse = () => {
        const {t }=this.props
        let isValid = ItemDetailNewStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(ItemDetailNewStore.attachmentResponse);
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments = tempAttachments.concat(attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                // alert("You can choose only the Image files!!")
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('You can choose only the Image files!!')
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#alertpopup').modal('hide');
                return;
            }
            this.setState({ attachmentPathArrImg: attachmentResponse[0].FilePath });
            this.UpdateClick();
            //console.log("tempAttachments", tempAttachments);
        } else {

            alert("You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.")
            $('#alertpopup').modal('hide');
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;

        }
    }
    /*[04/18/22,PC_WW-386_08], Priyanka D */
    loadAttachments = () => {
        const { t } = this.props
        let isValid = ItemDetailNewStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(ItemDetailNewStore.attachmentResponse);
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments = tempAttachments.concat(attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                // alert("You can choose only the Image files!!")
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('You can choose only the Image files!!')
                });
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                $('#alertpopup').modal('hide');
                return;
            }
            this.setState({ attachmentPathArrImg: attachmentResponse[0].FilePath });
            //console.log("tempAttachments", tempAttachments);
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.'
            });
            //alert("You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.")
            $('#alertpopup').modal('hide');
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return;

        }
    }
    /*[04/18/22,PC_WW-386_09], Priyanka D */
    UpdateClick = () => {
        let FavOrder_UpdateImgBO = {
            Employee_ID: CookieService.getLocalStorageValues("Session_UserID"),
            Employee_Name: CookieService.getLocalStorageValues("Session_USERNAME"),
            Employee_Email: CookieService.getLocalStorageValues("Session_EMAIL"),
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            ImageBytes: this.state.attachmentPathArrImg,
            ImageName: this.state.attachmentPathArrImg,
            VNDR_ITM_ID: this.state.ItemId,
            Supplier_Name: this.state.ItemSupplierName,
            Supplier_PartNo: this.state.supplier_part_number,
            Manufacturer: this.state.ItemManufacturerName,
            MFG_VNDR_ITM_ID: this.state.ItemMFGPartNumber,
            IsWeb: true,
            Existing_Img_Url: this.state.ItemImage[this.state.currentImageIndex].original
        }
        ItemDetailNewAction.EditImageSubmit(FavOrder_UpdateImgBO);
    }
    //[2/28/22], PC_IC_07, WW-316, Dhevanesam R
    //BindImageGrid = () => {
    //    //[09/29/22, WAL-780_PC_IDSC_03, Dhevanesam R]
    //    console.log("ImgResponseVal", this.state.ImgResponseVal);
    //    this.state.ImgResponseVal.push(this.state.ImgResponseVal[0])
    //    this.state.ImgResponseVal.push(this.state.ImgResponseVal[0])
    //    return this.state.ImgResponseVal.map((val, index) => {
    //        return (
    //            <Carousel.Item>
    //                <div className="col-md-12 owl-carousel owl-theme owl-loaded owl-drag">
    //                    <div className="owl-stage-outer">
    //                        <div>
    //                            <a href="#"><img className="mb-2 img-width-height" src={val.ImgURL} onClick={(e) => this.ImageClick(val, e)} alt={val.ItemID} /></a>
    //                            <h5 className="card-title catalog-label-title ">{val.ItemID}</h5>
    //                            <p className="card-text">{val.ShortDesc}</p>
    //                        </div>
    //                    </div>
    //                </div>
    //            </Carousel.Item>
    //        );
    //    })
    //};
    BindImageGrid = () => {

        console.log("ImgResponseVal", this.state.ImgResponseVal);
        return this.state.ImgResponseVal.map((val, index) => {
            let IMGURL
            //console.log("GridArray2", this.state.GridArray);
            if (val.ImgURL == "\\N") {
                IMGURL = "Images/noimage_new.png"
            }
            else {
                IMGURL = val.ImgURL
            }
            return (
                <div className="owl-item cloned col-md-4 col-lg-2 mb-3">
                    <a href="#"><img className="mb-2 img-width-height" src={IMGURL} onClick={(e) => this.ImageClick(val, e, false)} alt={val.ItemID} /></a>
                    <h5 className="card-title catalog-label-title ">{val.MfgPartNum}</h5>
                    {/* <h5 className="card-title catalog-label-title ">{val.ItemID}</h5>*/}
                    <p className="card-text">{val.ShortDesc}</p>
                </div>
            );

        })
    };
    //WW-522_PC_05 (12/14/2022)-Aparna
    bindAlternatepart = () => {

        console.log("ImgResponseVal", this.state.AlternateParts);
        return this.state.AlternateParts.map((val, index) => {
            console.log("ImgURL", val.ImgURL);
            let IMGURL
            //console.log("GridArray2", this.state.GridArray);
            if (val.ImgURL == "\\N") {
                IMGURL = "Images/noimage_new.png"
            }
            else {
                IMGURL = val.ImgURL
            }
            return (
                <Carousel.Item>
                    <div className="col-md-12 owl-carousel owl-theme owl-loaded owl-drag category-search-image" style={{ height: "330px", cursor: "Pointer" }} onClick={(e) => this.ImageClick(val, e, true)} >
                        <div className="owl-stage-outer">
                            <div>
                                <a href="#">
                                    {/*WW-522 A1QA bug (12/27/2022)-Aparna**/}
                                    <img className="mb-2 img-width-height" style={{ height: "190px" }} src={val.ImgURL} onError={(e) => { e.target.src = "/Images/noimage_new.png" }} alt={val.ItemID} /></a>
                                <h5 className="card-title catalog-label-title ">{val.MfgPartNum}</h5>
                                <p className="card-text item-details-value">{val.MfgName}</p>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
            );

        })
    };
    /*[04/18/22,PC_WW-386_12], Priyanka D */
    EditImgSubmit = () => {
        const { t } = this.props
        let isValid = ItemDetailNewStore.EditImageSubmission.indexOf("Success") >= 0 ? true : false;
        if (isValid) {
            // alert("Image Uploaded Successfully!")
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Image Uploaded Successfully!')
            });
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Upload failed!')
            });
            //alert("Upload failed!")
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#alertpopup').modal('hide');
    }
    handleToggleChange = (checked) => {
        if (checked == true) {
            this.setState({ ItemDescription: this.state.Short_desc, Description: "Short description" })
        } else {
            this.setState({ ItemDescription: this.state.Long_Desc, Description: "Long description" })

        }
        this.setState({ toggleChecked: checked });
    }
    handleDotclick = () => {
        this.setState({ IsDotClick: true })
    }
    //[2/28/22], PC_IC_08, WW-316, Dhevanesam R
    //ImageClick = (value, e) => {

    //    e.preventDefault();
    //    const queryParams = new URLSearchParams(window.location.search)
    //    const QS_src = queryParams.get('ItemId');
    //    const SupplierID = queryParams.get('SupplierID');
    //    let previtemid = QS_src
    //    let prevvendor = SupplierID
    //    let ItemData = {
    //        vendor_id: value.VendorID,
    //        ItemPrice: value.ItemPrice,
    //        SuppPartNum: value.SuppPartNum,
    //        SupplierName: value.SupplierName,
    //        SupplierName: value.ItemUOM,
    //        txtDesc: value.ShortDesc
    //    }
    //    this.props.history.push({
    //        pathname: `\itemdetailnew`,
    //        search: `?ItemId=${value.ItemID}&ManufacturePartNumber=${value.MfgPartNum}&ManufactureName=${value.MfgName}&SupplierID=${value.VendorID}&QTY=""`,
    //        state: { WO: JSON.parse(localStorage.getItem("WONum")), Suggesstions: true, ItemId: value.ItemID, ManufacturePartNumber: value.MfgPartNum, ManufactureName: value.MfgName, vendor_id: value.VendorID, QTY: "1", LAST_ITEM_VENDOR_ID: previtemid, LAST_ITEM_VENDOR_ITEM_ID: prevvendor, ItemData: ItemData }
    //    });
    //    console.log("history", this.props.history)
    //    this.PageItemSuggestionLoad("ItemDetails", value)
    //    this.laodImageItemDetails("ItemDetails", value);

    //}
    ImageClick = (value, e, AlternatePartImageClick) => {

        e.preventDefault();
        const queryParams = new URLSearchParams(window.location.search)
        const QS_src = queryParams.get('ItemId');
        const SupplierID = queryParams.get('SupplierID');
        const prevmfgpart = queryParams.get('ManufacturePartNumber');
        const prevmfg = queryParams.get('ManufactureName');
        let previtemid = QS_src
        let prevvendor = SupplierID
        let ItemData = {
            vendor_id: value.VendorID,
            ItemPrice: value.ItemPrice,
            SuppPartNum: value.SuppPartNum,
            SupplierName: value.SupplierName,
            SupplierName: value.ItemUOM,
            txtDesc: value.ShortDesc
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ IsFromCart: false }); //WW-522 BUG (when user navigated from shoppingcart and then click on alternate part the cart button is showing "update cart") (12/15/2022)-Aparna
        this.props.history.push({
            pathname: `\itemdetailnew`,
            search: `?ItemId=${value.ItemID}&ManufacturePartNumber=${value.MfgPartNum}&ManufactureName=${value.MfgName}&SupplierID=${value.VendorID}&QTY=""&origin=itemDetail&LAST_ITEM_VENDOR_ID=${prevvendor}&LAST_ITEM_VENDOR_ITEM_ID=${previtemid}&prevmfgpart=${prevmfgpart}&prevmfg=${prevmfg}`,
            state: { WO: JSON.parse(localStorage.getItem("WONum")), origin: 'itemDetail', Suggesstions: false, ItemId: value.ItemID, ManufacturePartNumber: value.MfgPartNum, ManufactureName: value.MfgName, vendor_id: value.VendorID, QTY: "1", LAST_ITEM_VENDOR_ID: prevvendor, LAST_ITEM_VENDOR_ITEM_ID: previtemid, ItemData: ItemData, IsAltPart: true }
        });

        console.log("history", this.props.history)
        this.PageItemSuggestionLoad("ItemDetails", value)
        this.laodImageItemDetails("ItemDetails", value, AlternatePartImageClick, previtemid, prevvendor); //WW-522_PC_08 (12/15/2022)-Aparna

    }
    handleScreenChange = (fullScreenElement) => {

        this.setState({ showThumbnails: !this.state.showThumbnails, showBullets: !this.state.showBullets, isFullScreen: !this.state.isFullScreen })
    };
    bindImage = () => {

        const style = {
            image: {
                position: 'sticky !important',
                display: 'block',
                left: '0px !important',
                top: '0px !important',
            },
        }
        let imageurl = this.state.ItemImage
        if (imageurl != null && imageurl != "") {
            if (imageurl.includes("NoImageAvailable")) {
                imageurl = `/Images/noimage_new.png`;
            }
        }
        let showBullets = false;
        let showIndex = false;
        if (this.state.ItemImage.length > 1) {
            showBullets = true
            showIndex = true
        }
        console.log("imageurl", imageurl)
        return (
            <ImageGallery ref={this.imageGalleryRef} onScreenChange={this.handleScreenChange} items={this.state.ItemImage} onThumbnailError={"/Images/noimage_new.png"} onClick={() => this.onImageClick(this.state.ItemImage)} onSlide={this.handleSlide}
                showPlayButton={false} additionalClass="custom-fullscreen" showThumbnails={this.state.isFullScreen} showBullets={!this.state.isFullScreen && showBullets} showIndex={showIndex} onErrorImageURL={"/Images/noimage_new.png"} />
        )
    }
    //WW - 1216 Precart - Yuvarani K
    handleEditQuantity = (e) => {
        let QtyToBeChanged;
        let val = e.target.value;
        if (val.length > 5) {
            return;
        }


        let re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value == '0' || e.target.value == 0) {
                QtyToBeChanged = this.state.MIN_ORD_QTY;
            }
            else {
                QtyToBeChanged = e.target.value;
            }

            this.setState({ Quantityvalue: QtyToBeChanged });
        }
    }



    //[2/22/2023, Bug - 3127, Dhevanesam R]
    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e"];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };
    handleMinOrderQuantity = (e) => {

        let QtyToBeChanged = "";
        if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
                this.setState({ Quantityvalue: this.state.MIN_ORD_QTY });
            }
            else if (parseInt(this.state.Quantityvalue) > parseInt(this.state.MIN_ORD_QTY)) {
                if (e.target.value == "+") {

                    let IsValidqty = false
                    let MinQty = this.state.MIN_ORD_QTY;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(this.state.Quantityvalue)) {
                            MinQty = parseInt(MinQty) + parseInt(this.state.MIN_ORD_QTY);
                        }
                        else if (parseInt(MinQty) > parseInt(this.state.Quantityvalue)) {
                            let diff = parseInt(MinQty) - parseInt(this.state.Quantityvalue);
                            if (diff <= parseInt(this.state.MIN_ORD_QTY)) {
                                QtyToBeChanged = MinQty;
                                this.setState({ Quantityvalue: QtyToBeChanged });
                                IsValidqty = true;
                            }
                        }
                    }
                    //WW - 1216 Precart - Yuvarani K
                    if (this.state.Quantityvalue == "" || this.state.Quantityvalue == " ") {
                        this.setState({ Quantityvalue: MinQty })
                    }


                }
                else if (e.target.value == "-") {
                    let IsValidqty = false
                    let MinQty = this.state.MIN_ORD_QTY;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(this.state.Quantityvalue)) {
                            let diff = parseInt(this.state.Quantityvalue) - parseInt(MinQty);
                            if (diff <= this.state.MIN_ORD_QTY) {
                                QtyToBeChanged = MinQty;
                                this.setState({ Quantityvalue: QtyToBeChanged });
                                IsValidqty = true;
                            }
                            else {
                                MinQty = parseInt(MinQty) + parseInt(this.state.MIN_ORD_QTY);
                            }

                        }
                    }
                }
            }
        }
        else {
            if (e.target.value == "+") {
                QtyToBeChanged = parseInt(this.state.Quantityvalue) + parseInt(this.state.MIN_ORD_QTY);
                this.setState({ Quantityvalue: QtyToBeChanged });
            }
            else if (e.target.value == "-") {
                QtyToBeChanged = parseInt(this.state.Quantityvalue) - parseInt(this.state.MIN_ORD_QTY);
                this.setState({ Quantityvalue: QtyToBeChanged });

            }
            else if (QtyToBeChanged == 0 || QtyToBeChanged == "0") {
                e.preventDefault();
            }
            else {
                this.setState({ Quantityvalue: QtyToBeChanged });
            }
        }
    }
    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentYes = () => {
        $('#ItemDetailMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        // Equipment item add to cart issue fixing - Nandhini L
        if (mixcartfunction == true) {
            this.AddTocart(this.state.value, this.state.index, this.state.fromCorePopup, this.state.ReasonType, this.state.Comments);
        } else {
            this.TradeServiceAddClick("", this.state.value, this.state.IsFav, this.state.ISKitCore);
        }

    };

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentNo = () => {
        $('#ItemDetailMixedOrderConfirmPopup').modal('hide'); // Hide the equipment modal
        cartDelete = false;
    };

    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    TradeServiceAddClick = (e, IsFav, IsCart, corechargerPopup, IsKitCore) => {
        const {t}=this.props
        $('#Delivery_MethodItemDetail').modal('hide');
        debugger
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        let hasEquipmentItem = [];
        let hasQuoteItem = [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        }
        let qtyadj = this.state.Quantityvalue;
        let Mfg = this.state.ItemMFGPartNumber;
        let mfgName = this.state.ItemManufacturerName;
        let longDesc = this.state.ItemDescription;
        let FromFavClick = "No";
        let FromPage = "ItemDetail";
        let IsPickup = false;
        let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")
        let SupplierName = this.state.ItemSupplierName;
        let shipmentpickup = this.state.shipmentpickup
        let FromNonCat = ""; //[10/3/2023] - 4252 - PC_WW_826_03 - Vishwa S
        CookieService.updateLocalStorageValues("ChosenSupplier", SupplierName);
        CookieService.updateLocalStorageValues("ChosenMFGName", mfgName);
        CookieService.updateLocalStorageValues("ChosenItemId", this.state.ItemId);
        let vndr = JSON.parse(localStorage.getItem("PickupVendor"))
        if (this.state.VendorId != undefined && this.state.VendorId != null) {
            let VendorIndex = vndr.findIndex(x => x.VENDOR_ID == this.state.VendorId)
            if (VendorIndex != -1) {
                IsPickup = true

            }
        }
        //[10/3/2023] - 4252 - PC_WW_826_04 - Vishwa S
        if (this.props.location.state.Orgin === "noncat") {
            FromNonCat = "noncat";
        }

        if (this.state.IsFromFav) {
            FromPage = "ItemDetailFromFav";
        }
        else if (this.state.IsFromCart) {
            FromPage = "ItemDetailFromCart";
        }
        //[11/22/22], CR - 2935 - To alert the user when the user tries to add the item to cart with empty qty, Dhevanesam R
        if (parseInt(this.state.Quantityvalue) == "0" || parseInt(this.state.Quantityvalue) == 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Cannot Be Zero')
            });
            return;
        }
        else if (this.state.Quantityvalue == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Should Not Be Empty')
            });
            return;
        }
        else if (parseInt(this.state.Quantityvalue) < parseInt(this.state.MIN_ORD_QTY)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Entered Is Below The Minimum Order Quantity')
            });
            return;
        }
        else if ((parseInt(this.state.Quantityvalue) % parseInt(this.state.MIN_ORD_QTY)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity Does Not Match the Minimum Order Quantity Sequence')
            });
            return;
        }
        else if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
            $('#ItemDetailMixedOrderConfirmPopup').modal('show');
            this.setState({ IsFav: IsFav, corechargerPopup: corechargerPopup, IsCart: false, IsKitCore: IsKitCore, cartConfirmationPopupTxt: t("Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?") });
            return;
        }
        else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            $('#ItemDetailMixedOrderConfirmPopup').modal('show');
            this.setState({ IsFav: IsFav, corechargerPopup: corechargerPopup, IsCart: false, IsKitCore: IsKitCore, cartConfirmationPopupTxt: t("Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?") });
            return;
        }


        else if (this.state.IsKit == "True") {
            this.KitSearchAddClick(IsKitCore)

        }
        else if (IsCart) {
            //WAL-1040_PC_11 -Aparna
            if (this.state.ItemDetail.hasCoreCharge != false && corechargerPopup != false) {
                $('#CoreChargePopUp').modal('show');
                return;
            }
            if (!this.formcheck(IsCart)) {
                this.ItemAddToCart()
            }


        }





        else {
            //WAL-1145 Supplier suggestion  sorting Pavithra R
            if (Shipment_Method == false && IsPickup == true) {

                $('#Delivery_MethodItemDetail').modal('show');
                CookieService.updateLocalStorageValues("Shipment_Method", true)
            }

            else {
                if (this.state.pickUp == true || this.state.deliveryShipTo == true) {
                    if (shipmentpickup == false && IsPickup == true) {
                        IsPickup = false

                    }

                    //WW-1378_WW-1382- Update item detail url and IsAltPart to local storage - Nandhini L
                    let itemDetailUrl = window.location.href
                    CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);
                    CookieService.updateLocalStorageValues("IsAltPart", this.props.location.state.IsAltPart);


                    $('#Delivery_MethodItemDetail').modal('hide');
                    //Pass the Values in Props as we are getting Exception when we pass spl character in query string-Priyanka-INC0013356
                    console.log("VendorId SS", this.state.VendorId)
                    this.props.history.push({
                        pathname: `\suppliersuggestionpage`,
                        search: `?ManufacturePartNumber=${Mfg}&ManufactureName=${mfgName}&SearchKey=${this.state.SearchKeyWord}&IsFromFav=${FromFavClick}&FavItemPage=${FromPage}&WO=${this.state.WorkOrderNo}&qtyadj=${qtyadj}&Suppliername=${SupplierName}&origin=itemDetail`,
                        state: { IsAltPart: this.props.location.state.IsAltPart, ManufacturePartNumber: Mfg, origin: 'itemDetail', ManufactureName: mfgName, SearchKey: this.state.SearchKeyWord, WO: this.state.WorkOrderNo, IsPickup: IsPickup, IsFromFav: FromFavClick, FavItemPage: FromPage, Suppliername: SupplierName, qtyadj: qtyadj, AlternatePart: true, VendorId: this.state.VendorId, ItemId: this.state.ItemId, Itemdetail: this.state.Itemdetail, FromNonCat: FromNonCat, cartDelete: cartDelete }//[10/3/2023] - 4252 - PC_WW_826_05 - Vishwa S

                    });




                }
                else {
                    this.setState({ shipmentmethoderrorid: "Please select the Shipment Method" })
                }

            }


        }


    }
    KitSearchAddClick = (IsKitCore) => {

        let Kit_Component = this.state.KIT_Components //JSON.parse(this.state.KIT_Components)
        if (Kit_Component != "" && Kit_Component != undefined && Kit_Component != null) {
            if (IsKitCore == false) {
                let IsCore = false
                let Kit_Items = Kit_Component
                Kit_Items.map((value, index) => {
                    if (value.IsCore == true) {
                        IsCore = true
                    }

                })
                if (IsCore == true) {
                    $('#CoreChargePopUp').modal('show');
                }


            }

            let KitItems = []
            const queryParams = new URLSearchParams(window.location.search)
            //const QS_src = queryParams.get('key');
            //*******getting cookie value for the saerch key**
            let QS_srcs = queryParams.get('key');
            Kit_Component.forEach((value) => {

                KitItems.push(value.SupplierPartNumber);

            });
            let KitBO = {

                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                CurrentPage_URL: "/SDIXZEUS/searchResults",
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_SearchQuery: " ",
                Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                SearchValue: "",
                Query_SITE: "",
                Query_USERID: this.state.Login_UserId,
                Query_Key: QS_srcs,
                Query_Opt: "",
                chbCat: true,
                chbNonCat: true,
                Catagorylist: [],//CatagoryList,	
                Make: "",
                Model: "",
                AssetId: "",
                SupplierIdList: [],
                ManufacturerList: [],
                WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
                ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                FavYourCatg: "",
                Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                SOURCE: "WEB",
                IsSupplierSearch: true,
                KitQty: this.state.Quantityvalue,
                MachineNo: "",
                KitOrderLocation2: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                KitOrderType: "",
                KitItem: JSON.stringify(this.state.KIT_Components),
                IsKitSearch: true,
                IsAddtoCartWeb: true,
                ItemIdList: KitItems,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                EquipmentDelete: cartDelete,
                Interactive: false



            }
            SearchResultsAction.GetCheaperItem(KitBO);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');


        }

    }
    //WW - 1216 Precart - Yuvarani K
    CoreChargeProceedClick = (e) => {
        $('#CoreChargePopUp').modal('hide');
        let Index = this.state.AddIndex;
        let GridArray = ItemArray
        CookieService.updateLocalStorageValues("ItemAddedToCart", GridArray[Index]);
        this.setState({ FiltItemValue: GridArray[Index] });
        let AddToCartBO = this.FormCartBO();
        ItemDetailNewAction.ItemDetail_ByPass(AddToCartBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }


    ItemAddToCart = () => {
        let OrderNonCatalogItemL = [];
        let ItemDetails = {
            ItemId: this.state.ItemId,
            txtSupplier: this.state.ItemSupplierName,
            txtSupplierID: this.state.VendorId,
            txtSuppPartNum: this.state.ItemClientPartNum,
            txtEstPrice: this.state.ItmPrice,
            txtDesc: this.state.ItemDescription,
            txtMfgPartNum: this.state.ItemMFGPartNumber,
            txtMfgName: this.state.ItemManufacturerName,
            txtQty: this.state.Quantityvalue,
            image_url: this.state.ItemImage[0].original,
            DropUOM: this.state.ItemUOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: "",
            EMPCC: "",
            DUeDate: this.state.ShipWIthin.substring(13),
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: this.state.SAP_Article_Number,
            ItemCat: this.state.Item_cat,
            MIN_ORD_QTY: this.state.MIN_ORD_QTY,
            CORE_CHARGE: this.state.ItemDetail.CORE_CHARGE

        }
        OrderNonCatalogItemL.push(ItemDetails)
        let AddToCartBO = {
            ItemDetails: [],
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: this.state.ItemImage[0].original,
            Session_PUNCHIN: "",
            MobileAPICall: false,
            SESSION_ID: CookieService.getLocalStorageValues("Session_ID"),//Pass the value of session ID
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false
        }
        ItemDetailNewAction.addToCartItems(AddToCartBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    FormCartBO = () => {
        let GridArray = ItemArray;
        let OrderNonCatalogItemL = [];
        let suppllier_part_num = GridArray.clientPartNumber;
        //if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
        //    suppllier_part_num = GridArray[0].clientPartNumber;
        //};
        let ItemDetails = {
            ItemId: GridArray.clientPartNumber,
            txtSupplier: GridArray.supplierName,
            txtSupplierID: GridArray.vendor_id,
            txtSuppPartNum: suppllier_part_num,
            txtEstPrice: GridArray.ItemPrice,
            txtDesc: GridArray.Description + " " + "-InvItemIcon-" + GridArray.hasBenItemVal,
            txtMfgPartNum: GridArray.manfPartnumber,
            txtMfgName: GridArray.manufacturer,
            txtQty: this.state.Quantityvalue, //GridArray.QuantityOrdered,
            image_url: GridArray.ThumbnailImagefile,
            DropUOM: GridArray.UOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: null,
            EMPCC: "",
            DUeDate: GridArray.DeliverDate,
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: GridArray.customer_part_number_woprefix,
            ItemCat: GridArray.UNSPSC,
            MIN_ORD_QTY: GridArray.min_order_qty,
            CORE_CHARGE: GridArray.CORE_CHARGE
        };
        OrderNonCatalogItemL.push(ItemDetails);
        let AddToCartBO = {
            ItemDetails: [],
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: "",
            Session_PUNCHIN: "False",
            MobileAPICall: false,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false,
            SOURCE: "WEB",
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false,
            qty: this.state.Quantityvalue,
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
        }
        return AddToCartBO;
    }


    //WW - 1216 Precart - Yuvarani K
    CoreChargeResponseClick = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let AddCartResponse = {}
        try {
            AddCartResponse = JSON.parse(ItemDetailNewStore.ItemDetail_ByPass);
        }
        catch (ex) {
            AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);

        }


        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Item added to cart successfully'
            });

            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            ///*[03/04/22, PC_01 WW-362], Priyanka D,  */
            //alert("Item Successfully added to cart");
            //WW-243_Refresh_PC_01 (3/28/2022)-Aparna
            /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
            //MenuAction.refreshMasterData();
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            // alert("Techincal Issue Contact SDI Customer Care");
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Techincal Issue Contact SDI Customer Care'
            });
        }
    }

    formcheck = (IsCart) => {
        const {t}=this.props
        if (this.state.isNonCatSearch || IsCart) {
            let form = ""
            let Itemdetail = this.state.Itemdetail
            if (Itemdetail[0].AttributeName.includes('FORM')) {
                this.CheckFormExistsInCart(Itemdetail[0]);
                let AddToCartBO = this.FormCartBO();
                WorkOrder = localStorage.getItem("WONum") != null && localStorage.getItem("WONum") != undefined ? JSON.parse(localStorage.getItem("WONum")) : ""
                form = CookieService.getLocalStorageValues("EnersysForm");
                //[1/11/23, WW-552, Dhevanesam R]
                if (Itemdetail[0].AttributeValue.indexOf("BATTERY") > -1 || Itemdetail[0].AttributeValue.indexOf("CHARGER") > -1) {
                    let EnersysFormVaue = Itemdetail[0].AttributeValue;
                    if (EnersysItems.indexOf(Itemdetail[0].clientPartNumber) > -1) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: t("This Enersys Item is already added in the cart. Please go to cart to increase quantity !")
                        });
                        return true;;
                    }
                    this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + EnersysFormVaue.toLowerCase() });
                    CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                    CookieService.updateLocalStorageValues("EnersysForm", true)
                    if (CookieService.getLocalStorageValues("EnersysForm") == true) {
                        if (EnersysItems != undefined) {
                            if ((EnersysItems.indexOf(Itemdetail[0].clientPartNumber) == -1)) {

                                $('#EnersysEmployee').modal('show');
                                return true;;

                            }

                        }
                        else {
                            $('#EnersysEmployee').modal('show');
                            return true;;
                        }
                    }
                }
                else {
                    //[1/20/23, PC_WW-552_FE_41, Dhevanesam R]
                    if (FormItems != undefined && FormItems != null && FormFilePath != undefined && FormFilePath != null && Itemdetail[0].form != undefined && Itemdetail[0].form != null) {

                        if (Itemdetail[0].form.trim() == "KENSTAN-KEY" && FormFilePath.includes("KENSTAN-KEY")) {

                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: t("KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity")
                            });
                            FormItems = "";
                            FormFilePath = "";
                            return true;;
                        }
                        else {
                            let CartStorage = JSON.parse(localStorage.getItem("CartStorage")) || [];
                            let itemInCart = CartStorage.filter(item => item.Itemid === this.state.ItemId && item.SupplierPartNumber === this.state.supplier_part_number && item.Manufacturerpartnumber === this.state.ItemMFGPartNumber && item.Manufacturer === this.state.ItemManufacturerName);
                            if (itemInCart.length == 0) {
                                FormItems = "";
                                FormFilePath = "";
                                if (this.state.FormData.length > 0) {
                                    //WW-1378_WW-1382- Update item detail url to local storage - Nandhini L
                                    let itemDetailUrl = window.location.href
                                    CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);

                                    this.props.history.push({
                                        pathname: "/forms",
                                        state: { item: AddToCartBO, qty: AddToCartBO.qty, WO: WorkOrder, pagename: 'ItemDetail', searchKey: "", form: form, FormData: this.state.FormData, FormOptionsData: this.state.FormOptionsData, FormName: Itemdetail[0].form.trim() }
                                    });
                                    return true;
                                }
                                else {
                                    return false
                                }
                            }
                            else if (itemInCart.length > 0 && itemInCart[0].FilePath.length == 10) {
                                swal({
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false,
                                    text: "This item is already in the cart and has reached the maximum number of 10 forms"
                                });
                                FormItems = "";
                                FormFilePath = "";
                                return true;
                            }
                            else {
                                return false
                            }
                        }

                    } else {
                        if (this.state.FormData.length > 0) {
                            //WW-1378_WW-1382- Update item detail url to local storage - Nandhini L
                            let itemDetailUrl = window.location.href
                            CookieService.updateLocalStorageValues("itemDetailUrl", itemDetailUrl);

                            this.props.history.push({
                                pathname: "/forms",
                                state: { item: AddToCartBO, qty: AddToCartBO.qty, WO: WorkOrder, pagename: 'ItemDetail', searchKey: "", form: form, FormData: this.state.FormData, FormOptionsData: this.state.FormOptionsData, FormName: Itemdetail[0].form.trim() }
                            });
                            return true;
                        } else {
                            return false;
                        }
                    }



                }

            }
        } else {
            return true;
        }
    }
    CheckFormExistsInCart = (value) => {
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        CartStorage.forEach((val) => {
            if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                if (val.FilePath[0].toLowerCase().includes('enersys')) {
                    EnersysItems = EnersysItems.concat(val.Itemid);
                }
                else if (val.FilePath != null && val.FilePath[0].toUpperCase().includes(value.form.trim())) {
                    FormItems = FormItems.concat(val.Itemid);
                    FormFilePath = FormFilePath.concat(val.FilePath[0]);
                }

            }
        });
    }
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            document.getElementById("lblerror").innerText = "";
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: [] });
            rmvAttachindex = -1;
        }
    };
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            console.log("attachmentPathArr", this.state.attachmentPathArr);
            return (
                <div className="attachment-file-name mt-2 p-0" key={index}>
                    <a data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </div>
            );
        });
    };
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    FavItemhandleAttachment = (event) => {

        let files = event.target.files;
        console.log("event", files);
        if (this.state.attachmentPathArr != undefined) {

            if (this.state.attachmentPathArr.length < 1) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                NonCatalogAction.addAttachment(files);
            } else {

                let lblerror = "You can choose only one Image"
                document.getElementById("lblerror").innerText = lblerror;
            }

        } else {
            document.getElementById("lblerror").innerText = "";
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }
    };
    onSelect(val, name) {
        let result = [];
        if (name == "Cat") {
            if (val != "") {
                this.state.subCategory.forEach((x, i) => {
                    if (val.toUpperCase() == x.category) {
                        result.push({ label: x.value, value: x.value })
                    }
                }
                )
            }
            this.setState({
                FavYourCatg: val, subCategoryResults: result, CategoryErr: false
            });
        }
        else {
            this.setState({
                FavSubCategory: val, SubCategoryErr: false
            });
        }

    }

    //WW - 1216 Precart - Yuvarani K
    RatingPopup = () => {
        this.resetRatingColor();
        $('#RatingPopup').modal('show');
    }

    //WW - 1216 Precart - Yuvarani K
    CloseRatingPopup = () => {
        $('#RatingPopup').modal('hide');
        this.setState({ Review: "", StarRating: 0 })
        // window.location.reload();
    }
    onChange = (e, name) => {
        let val = e.target.value.toUpperCase()
        let len = e.target.value
        let result = [];
        let subcatresult = [];
        //[1/25/23, WW-542_PC_26, Dhevanesam R]
        let re = /^[a-zA-Z0-9_-\s\x20 &, :;=?@#|'<>.{}"*()%!`%^$+~[/\]\\]+$/;
        if (val === '' || re.test(val)) {
            if (name == "Cat") {
                if (e.target.value == "") {
                    //let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                    this.setState({
                        FavYourCatg: e.target.value, autocompleteDataRstl: this.state.autocompleteData, subCategoryResults: []
                    });
                }
                else if (len.length <= 40) {
                    if (this.state.autocompleteData != undefined && this.state.autocompleteData != null) {
                        if (this.state.autocompleteData.length != 0) {
                            result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))

                        }
                    }
                    if (e.target.value != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (e.target.value.toUpperCase() == x.category) {
                                subcatresult.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    this.setState({
                        FavYourCatg: e.target.value, autocompleteDataRstl: result, subCategoryResults: subcatresult, CategoryErr: false
                    });
                }
            }
            else {
                if (e.target.value == "") {
                    //let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
                    if (this.state.FavYourCatg != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (this.state.FavYourCatg.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result
                    });
                }
                else if (len.length <= 40) {
                    //if (this.state.subCategory != undefined && this.state.subCategory != null) {
                    //    if (this.state.subCategory.length != 0) {
                    //        result = this.state.subCategory.filter(name => name.label.toUpperCase().includes(val))

                    //    }
                    //}
                    if (this.state.FavYourCatg != "") {
                        this.state.subCategory.forEach((x, i) => {
                            if (this.state.FavYourCatg.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result, SubCategoryErr: false
                    });
                }
            }
        }


        /**
         * Handle the remote request with the current text !
         */

    }
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    Sorting = (sortVariable, sort, name) => {

        let data = [];
        if (sort == "ASC") {
            switch (name) {
                case "Manufacturer": {
                    data = this.sort(sortVariable, "Arr[i].MANUFACTURER", "Arr[j].MANUFACTURER", "ASC")
                    break;
                } case "Manufacturer_Part": {
                    data = this.sort(sortVariable, "Arr[i].MFG_PART_NUM", "Arr[j].MFG_PART_NUM", "ASC")
                    break;
                } case "Make": {
                    data = this.sort(sortVariable, "Arr[i].ISA_MAKE", "Arr[j].ISA_MAKE", "ASC")
                    break;
                } case "Model": {
                    data = this.sort(sortVariable, "Arr[i].ISA_MODEL", "Arr[j].ISA_MODEL", "ASC")
                    break;
                }
            }
        } else {
            switch (name) {
                case "Manufacturer": {
                    data = this.sort(sortVariable, "Arr[i].MANUFACTURER", "Arr[j].MANUFACTURER", "DESC")
                    break;
                } case "Manufacturer_Part": {
                    data = this.sort(sortVariable, "Arr[i].MFG_PART_NUM", "Arr[j].MFG_PART_NUM", "DESC")
                    break;
                }
                case "Make": {
                    data = this.sort(sortVariable, "Arr[i].ISA_MAKE", "Arr[j].ISA_MAKE", "DESC")
                    break;
                } case "Model": {
                    data = this.sort(sortVariable, "Arr[i].ISA_MODEL", "Arr[j].ISA_MODEL", "DESC")
                    break;
                }
            }
        }
        this.setState({ equParts: data })
    }
    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    let test = eval(indexval)
                    let test2 = eval(nextindexval)
                    if (test > test2) {

                    }
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }

    //WW - 1216 Precart - Yuvarani K
    RatingSubmission = (e) => {
        this.setState({ Review: "", StarRating: 0 })
        //  localStorage.setItem("VendorId", this.props.location.state.ItemData.vendor_id)
        //  localStorage.setItem("ItemId", this.state.ItemId)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        let RatingBO = {
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //Precart SIT-1 bug fix - Yuvarani K
            Vendor_id: this.props.location.state.ItemData.vendor_id,
            Item_id: this.state.ItemId,
            Employee_id: CookieService.getLocalStorageValues("Session_UserID"),
            Rating: this.state.StarRating,
            Comments: this.state.Review

        };
        ItemDetailNewAction.RatingSubmission(RatingBO);



    }

    zoomClick(event) {
        if (this.imageGalleryRef.current) {
            this.imageGalleryRef.current.fullScreen();
        }
    }
    onClickBackArrow = () => {
        //WW-1378-Item details back icon issue - Nandhini L
        let origin = CookieService.getLocalStorageValues("PrevPage") ? CookieService.getLocalStorageValues("PrevPage") : this.props.location.state.Orgin
        let SearchUrl = CookieService.getLocalStorageValues("SearchUrl") ? CookieService.getLocalStorageValues("SearchUrl") : "";
        let SearchParam = SearchUrl.split("searchresults?")[1]
        CookieService.updateLocalStorageValues("PrevPage", "");


        if (origin == 'noncat') {
            this.props.history.push({
                pathname: `\RFQEntry`,
                search: `?Orgin=itemdetail`
            });
        }
        else if (origin == 'Search') {
            this.props.history.push({
                pathname: `/searchresults`,
                search: SearchParam
            });
        }
        else if (origin == 'ShoppingCart') {
            this.props.history.push({
                pathname: `/shoppingcart`
            });
        }
    }
    //WW - 1216 Precart - Yuvarani K

    getStarImage = (Rating) => {

        const roundedRating = Math.round(Rating * 2) / 2;
        const clampedRating = Math.min(Math.max(roundedRating, 0), 5);
        const ratingString = clampedRating.toFixed(1);
        const imageMap = {
            '0.0': 'Images/0-star.svg',
            '0.5': 'Images/0.5-star.svg',
            '1.0': 'Images/1-star.svg',
            '1.5': 'Images/1.5-star.svg',
            '2.0': 'Images/2-star.svg',
            '2.5': 'Images/2.5-star.svg',
            '3.0': 'Images/3-star.svg',
            '3.5': 'Images/3.5-star.svg',
            '4.0': 'Images/4-star.svg',
            '4.5': 'Images/4.5-star.svg',
            '5.0': 'Images/5-star.svg'
        };

        return imageMap[ratingString];
    }

    EnersysyEmp = (EnersysEmp) => {

        if (EnersysEmp == "No") {
            $('#NotanEnersysEmp').modal('show');
        } else if (EnersysEmp == "Yes") {
            $('#EnersysEmployee').modal('hide');
            // let index = this.state.AddIndex;
            let AddToCartBO = this.FormCartBO();
            let GridArray = this.state.ItemDetail;
            WorkOrder = localStorage.getItem("WONum") != null && localStorage.getItem("WONum") != undefined ? JSON.parse(localStorage.getItem("WONum")) : ""
            this.props.history.push({
                pathname: "/EnersysForm",
                state: { item: AddToCartBO, qty: this.state.Quantityvalue, product: CookieService.getLocalStorageValues("EnersysFormVaue"), WO: WorkOrder, pagename: "ItemDetail", searchKey: this.state.SearchKeyWord, form: CookieService.getLocalStorageValues("EnersysForm") }
            });

        }
    }
    NotAnEnersysyEmp = () => {
        $('#NotanEnersysEmp').modal('hide');
    }
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    pickupchange = (Type) => {
        let pickUp = false
        let deliveryShipTo = false
        let shipmentpickup = false

        if (Type != 1) {

            pickUp = true
            deliveryShipTo = false
            shipmentpickup = true
            localStorage.setItem("pickupcheck", true);
            itemDetailPickup = true

        }
        else {
            pickUp = false
            deliveryShipTo = true
            shipmentpickup = false

            localStorage.setItem("pickupcheck", false);
            itemDetailPickup = false
        }
        CookieService.updateLocalStorageValues("Shipment_Method", true)
        this.setState({
            pickUp: pickUp, deliveryShipTo: deliveryShipTo, shipmentpickup: shipmentpickup
        })


    }
    shpCloseClk = () => {
        $('#Delivery_MethodItemDetail').modal('hide');
        this.setState({ shipmentmethoderrorid: "" })
        CookieService.updateLocalStorageValues("Shipment_Method", false);
        localStorage.setItem("pickupcheck", false);
        this.setState({ pickUp: false, deliveryShipTo: true });
    }
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    searchKeyPress = (e) => {
        if (e.keyCode == 13) {

            this.TradeServiceAddClick(e, this.state.FavItem, false, true, false)

        };
    };
    // 5611 - Walmart-Item details-Rating popup- highlighting  [4/11/2025] Nachiappan C
    resetRatingColor = () => {
        const stars = document.querySelectorAll('.MuiSvgIcon-root');
        stars.forEach(star => {
            star.style.color = '#e0e0e0';
        });
    }

    render() {
        const {t} = this.props
        console.log("ItemImageValue", ItemImageValue)
        console.log("ImgResponseVallog", this.state.ImgResponseVal)
        let MinOrdQty = "" + this.state.MIN_ORD_QTY;
        let origin = CookieService.getLocalStorageValues("PrevPage") ? CookieService.getLocalStorageValues("PrevPage") : this.props.location.state.Orgin
        let MaxOrdQty = "" + (parseInt(this.state.MIN_ORD_QTY) + parseInt(this.state.MIN_ORD_QTY));
        let attributeName = this.state.AttributeName != null && this.state.AttributeName != undefined ? this.state.AttributeName.toUpperCase().includes('FORM') ? false : true : true
        //let IsKitCore = false
        return (
            <div className="container-fluid content-margin Top-margin">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3 title-margin">

                        <h5 className="page-title">{(origin == 'noncat' || origin == 'Search' || origin == 'ShoppingCart') ? <a ><img className="mr-2 back-icon" title="Back" src="images/back-arrow.svg" onClick={(e) => this.onClickBackArrow(e)} /></a> : null}<Trans>{this.state.ItemTypeFav == "CAT" ? "Catalog Item Details" : "Non Catalog Item Details"}</Trans></h5>                    </div>
                    <div className="col-md-5 px-0">
                        <div className="item-image-size">
                            {/*<img src={this.state.ItemImage} alt="Catalog Image" className="w-100 img-fluid catalog-img-border" />
                        <Image
                            src={ItemImageValue}
                            width={540}
                            height={573}
                            noImageSrc="/Images/noimage_new.png"
                        />*/}
                            {this.bindImage()}
                            {/*[04/18/22,PC_WW-386_01], Priyanka D */}
                            <div className="Edit-icon-style" onClick={(e) => this.EditImg()}>
                                <span className="Edit-icon-size"><img src="Images/edit-img-icon.png" onClick={(e) => this.EditImg()} /></span>
                            </div>
                        </div>

                    </div>

                    <div className="col-md-7 Catalog-Items">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <span className="catalog-title-id">{this.state.ItemMFGPartNumber}</span>
                                        {/*[2/16/22], WW-330, Dhevanesam R*/}
                                        {this.state.BenItemIcon == "C" ? <span style={icircleItemBen}>C</span> : this.state.BenItemIcon == "T" ? <span style={icircleItemTruck}>T</span> : this.state.VendorId == "W999999999" ? < span style={icircleItemDet}>w</span> : null}

                                        { /* {this.state.BenItemIcon == "C" ? < span >C</span> : this.state.VendorId == "W999999999" ? < span >w</span> : null}*/}
                                        {/*CPW-167_PC_02*/}
                                        {attributeName || this.state.BenItemIcon == "T" ? <>{this.state.AttributeValue.indexOf('KENSTAN') > -1 || this.state.AttributeValue.indexOf('BATTERY') > -1 || this.state.AttributeValue.indexOf('CHARGER') > -1 || this.state.AttributeValue.indexOf('DOORS INTERIORNON-FIRERATE') > -1 || this.state.BenItemIcon == "T" ? null :
                                            <div className="fav-item-maintenance-icon d-inline-block">
                                                <input type="checkbox" className="checknow" id="checknow-11" checked={this.state.FavItem} onChange={() => this.BindFavForm(this.state.FavItem, "No")} data-backdrop="static" data-keyboard="false" />
                                                <label htmlFor="checknow-11">
                                                    <svg className="heart-svg heart-icon-view" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </label>
                                            </div>


                                        }</> : null}
                                    </div>

                                    {/* //WW - 1216 Precart - Yuvarani K */}
                                    <div>
                                        <button className="btn custom-btn-primary custom-image-btn px-3" onClick={(e) => this.RatingPopup(e)}><img src="Images/star-icon.svg" alt="star-icon" className="star-icon me-2" style={{ "paddingRight": "7px", "paddingBottom": "2px" }}></img><Trans>Add Review</Trans></button>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="row mb-3">
                            {/*[WW-458]Using Toggle button, switch bw Short and long desc-Priyanka D*/}
                            <div className="col-md-12 col-lg-2 mt-2 catalog-label"><Trans>{this.state.Description}</Trans></div>
                            <span id="toggle" style={{}}><label>
                                <Switch
                                    onChange={() => this.handleToggleChange(!this.state.toggleChecked)}
                                    checked={this.state.toggleChecked}
                                    color="primary"
                                />
                            </label></span>
                            {this.state.ItemDescription.length > 356 && !this.state.IsDotClick ?
                                <div className="col-md-12 col-lg-10 col-auto col-sm-5 catalog-value catalog-id">
                                    <span>{`${this.state.ItemDescription.substring(0, 356)}`}</span>
                                    <span style={{ "cursor": "pointer" }} onClick={(e) => this.handleDotclick()} >...</span>
                                </div>
                                :
                                <div className="col-md-12 col-lg-10 catalog-value " style={{ "marginTop": "5px" }}>{this.state.ItemDescription}</div>}
                        </div>

                        {/* <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Noun</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemNoun}</div>
                        </div>*/}
                        <div className="row mb-3">
                            {/* //WW - 1216 Precart - Yuvarani K */}
                            <div className="col-md-12 col-lg-2 catalog-label" style={{ "marginTop": "8px" }}><Trans>Rating</Trans></div>
                            {this.state.ProductRating == "\\N" || this.state.ProductRating == "\N" ? null :
                                <span className="catalog-value" style={{ "marginLeft": "13px" }}>{this.state.ProductRating}</span>
                            }
                            <span style={{ "marginLeft": "6px", "marginRight": "6px" }}><img style={{ "marginBottom": "8px" }} src={this.getStarImage(this.state.ProductRating)}>
                            </img></span>
                            {this.state.RatingCount == "\\N" || this.state.RatingCount == "\N" ?
                                <label style={{ "marginLeft": "6px", "marginTop": "6px" }} className="catalog-value"><Trans>No reviews yet</Trans></label>:
                                <span className="catalog-value">({this.state.RatingCount})</span>
                            }

                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Manufacturer</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemManufacturerName}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Supplier</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemSupplierName}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Supplier Part#</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value ">{this.state.ItemId}</div>
                        </div>
                        {/* <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Description</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemfeatureDesc}</div>
                        </div>*/}
                        {/*<div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Client</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemClient}</div>
                        </div>*/}
                        {/*<div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>ItemKey</Trans><span> </span><Trans>Group</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemGroup}</div>
                        </div>*/}
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Catalog</Trans><span> </span><Trans>Path</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemCatalogPath}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label">UOM</div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemUOM}</div>
                        </div>
                        {/* <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Category</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemCategory}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Modifiers</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemModifiers}</div>
                        </div>*/}

                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label">UNSPSC</div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ItemUNSPSC}</div>
                        </div>


                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Package</Trans><span> </span><Trans>Quantity</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.PackageQuantity}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><span>SAP </span><Trans>Article Number</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.SAP_Article_Number}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Minimum Order Quantity</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.MIN_ORD_QTY}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 col-lg-2 catalog-label"><Trans>Delivers By</Trans></div>
                            <div className="col-md-12 col-lg-10 catalog-value">{this.state.ShipWIthin.substring(13)}</div>
                        </div>
                        {/*//pc-1136-12 adding the necessary css class 10/07/2024 S.Sanjay*/}
                        {this.state.equParts.length > 0 ?
                            <div className="row mb-3">
                                <div className="col-md-12 col-lg-2 catalog-label"><Trans>Equivalent Parts</Trans></div>
                                <div className="col-md-12 col-lg-8 col-12 col-sm-12 custom-equivalent-parts-list">{this.bindEquParts("equivalentParts")}
                                </div>
                            </div> : null}
                        {this.state.carticonFlag ?
                            <div className="row mb-3">
                                <div className="col-md-12 col-lg-2 catalog-label"><Trans>Total Order Quantity</Trans></div>
                                <div className="col-md-12 col-lg-10 catalog-value">
                                    <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%" }} >
                                        {/*[02/09/22, PC_01,WW-318], Priyanka D,Disabling QTY for Enersys Product */}
                                        <input type="button" disabled={this.state.QtyDisable || this.state.Quantityvalue == this.state.MIN_ORD_QTY || (this.state.IsFromCart && fromCarthasQuoteItem != undefined && fromCarthasQuoteItem != null && fromCarthasQuoteItem.length > 0) || this.props.history.location.state.origin === "shoppingcart" && this.state.AttributeName.includes("FORM")} value="-" class="minus" onClick={(e) => this.handleMinOrderQuantity(e)} style={{ "backgroundColor": "white" }} />
                                        {/*[2/22/2023, Bug - 3127, Dhevanesam R]*/}
                                        <input type="number" disabled={this.state.QtyDisable || (this.state.IsFromCart && fromCarthasQuoteItem != undefined && fromCarthasQuoteItem != null && fromCarthasQuoteItem.length > 0) || this.props.history.location.state.origin === "shoppingcart" && this.state.AttributeName.includes("FORM")} step={` ${MinOrdQty}`} class="minus" min={` ${MinOrdQty}`} max={` ${MaxOrdQty}`} name="quantity" name="Quantityvalue" id="QuantityTxt" onChange={(e) => this.handleEditQuantity(e)} onKeyDown={(e) => this.keyPressQTY(e)} value={this.state.Quantityvalue} title="Qty" maxLength={5} pattern="" inputmode="" style={{ "width": "45%", "borderLeft": "0" }} />
                                        <input type="button" disabled={this.state.QtyDisable || this.state.Quantityvalue == 99999 || (this.state.IsFromCart && fromCarthasQuoteItem != undefined && fromCarthasQuoteItem != null && fromCarthasQuoteItem.length > 0) || this.props.history.location.state.origin === "shoppingcart" && this.state.AttributeName.includes("FORM")} value="+" class="plus" onClick={(e) => this.handleMinOrderQuantity(e)} style={{ "backgroundColor": "white" }} />  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}
                                    </div>
                                    {/*<input type="text" className="form-control catalog-details-qty" maxLength="8" name="Quantityvalue" id="QuantityTxt" value={this.state.Quantityvalue} onChange={this.handleProfileFormChange} />*/}
                                    {/*//[1/11/23, WW-552, Dhevanesam R]*/}{/**CPW-167_PC_03*/}
                                    {this.state.IsFromCart || this.state.isNonCatSearch ?
                                        <button className={`btn btn-primary custom-btn-primary primary-btn px-4  ${this.state.BenItemIcon == "T" || (this.state.IsFromCart && (this.state.AttributeValue.includes("BATTERY") || this.state.AttributeValue.includes("CHARGER")) || this.props.history.location.state.origin === "shoppingcart" && this.state.AttributeName.includes("FORM")) ? 'disabled' : ''}`} disabled={(this.state.IsFromCart && fromCarthasQuoteItem != undefined && fromCarthasQuoteItem != null && fromCarthasQuoteItem.length > 0) || this.props.history.location.state.origin === "shoppingcart" && this.state.AttributeName.includes("FORM")} onClick={(e) => this.TradeServiceAddClick(e, this.state.FavItem, true, true, false)}><img src="Images/cart-icon-black.svg" style={{ "marginRight": "3px" }}></img>{/*//WW-362 (CLONE - Remove Cheaper Item Pop Up) - Deepthi*/}

                                            {/* <span className="item-cart mr-2" />*/}


                                            {this.state.isNonCatSearch ?
                                                <Trans > Add to cart</Trans> : <Trans>Update Cart</Trans>}

                                        </button>
                                        : <button className={`btn btn-primary custom-btn-primary primary-btn px-4  ${this.state.BenItemIcon == "T" ? 'disabled' : ''}`}

                                            onClick={(e) => {
                                                if (itemDetailPickup == true || localStorage.getItem("pickupcheck") == true || pickUp == true || this.state.cart_bypass == "Y") {
                                                    this.AddToCartOrFavClick("Add To Cart", ItemDetailsValue, 0, false, this.state.ReasonType, this.state.Comments)
                                                }
                                                else {
                                                    this.TradeServiceAddClick(e, this.state.FavItem, false, true, false)
                                                }
                                            }}><img src="Images/cart-icon-black.svg" ></img>{/*//WW-362 (CLONE - Remove Cheaper Item Pop Up) - Deepthi*/}
                                            {/* <span className="item-cart mr-2" />*/}

                                        </button>}
                                </div>
                            </div> : null}
                        <div className="row mb-3">
                            <div className="col-md-auto col-lg-12 col-sm-auto col-auto text-right mt-2">
                                {this.state.ShowExtentDespPopUp == 1 ?
                                    <a className="float-right helptext-link attachment-file-name" href="#" data-toggle="modal" data-target="#extended-client">Show Extended Description</a> : null}
                            </div>
                        </div>

                    </div>
                </div>

                <ul className="nav nav-tabs catalog-tabs-mobile catalog-tabs mt-4" id="myTab" role="tablist">
                    {/*'[03/07/2023-PC_WW-643_14,Priyanka]*/}
                    <li className="nav-item">
                        <a className="nav-link active" id="also-fits" data-toggle="tab" href="#alsofits" role="tab" aria-controls="also-fits" aria-selected="true"><img src="Images/fits.svg" className="equIcons pr-1"></img><img className="equIcons pr-1" src="Images/fits-active.svg"></img><Trans>Also Fits</Trans></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="Attributes-tab" data-toggle="tab" href="#catalog-details" role="tab" aria-controls="catalog-details" aria-selected="false"> <img className="equIcons pr-1" src="Images/attributes.svg"></img><img className="equIcons pr-1" src="Images/attributes-active.svg"></img><Trans>Attributes</Trans></a>
                    </li>
                    {/*<li className="nav-item">
                        <a className="nav-link active" id="catalog-details-tab" data-toggle="tab" href="#catalog-details" role="tab" aria-controls="catalog-details" aria-selected="true"><Trans>{this.state.ItemTypeFav == "CAT" ? "Catalog Details" : "Non Catalog Details"}</Trans></a>
                    </li>*/}
                    <li className="nav-item">
                        <a className="nav-link" id="Links-tab" data-toggle="tab" href="#item-detail" role="tab" aria-controls="item-detail" aria-selected="false" ><img className="equIcons pr-1" src="Images/link.svg"></img><img className="equIcons pr-1" src="Images/links-active.svg"></img><Trans>Links</Trans></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="bin-location-tab" data-toggle="tab" href="#bin-location" role="tab" aria-controls="bin-location" aria-selected="false" onClick={() => this.TabClick("BIN")}><img className="equIcons pr-1" src="Images/inventory-line.svg"></img><img className="equIcons pr-1" src="Images/inventory-fill.svg"></img><Trans>Inventory</Trans></a>
                    </li>
                    {/*' PC_WW-641_06-Priyanka  D*/}

                    <li className="nav-item d-none">
                        <a className="nav-link" id="Equ-Parts-tab" data-toggle="tab" href="#Equ-Parts" role="tab" aria-controls="Equ-Parts d-none" aria-selected="false"><img className="equIcons pr-1" src="Images/eq-parts.svg"></img><img className="equIcons pr-1" src="Images/eq-parts-active.svg"></img><Trans>Equivalent Parts</Trans></a>
                    </li>

                    {/*<li className="nav-item">
                        <a className="nav-link" id="item-details-tab" data-toggle="tab" href="#item-detail" role="tab" aria-controls="item-detail" aria-selected="false" onClick={() => this.TabClick("ITM")}>Item Details</a>
                    </li>
                        <li className="nav-item">
                            <a className="nav-link" id="usage-tab" data-toggle="tab" href="#usage" role="tab" aria-controls="usage" aria-selected="false" onClick={() => this.TabClick("USE")}>Usage</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="issues-tab" data-toggle="tab" href="#issues" role="tab" aria-controls="usage" aria-selected="false" onClick={() => this.TabClick("ISS")}>Issues</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="bin-location-tab" data-toggle="tab" href="#bin-location" role="tab" aria-controls="bin-location" aria-selected="false" onClick={() => this.TabClick("BIN")}>Bin Location</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="search-sites-tab" data-toggle="tab" href="#search-sites" role="tab" aria-controls="search-sites" aria-selected="false" onClick={() => this.TabClick("SITE")}>Search Other Sites</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="purchase-history-tab" data-toggle="tab" href="#purchase-history" role="tab" aria-controls="purchase-history" aria-selected="false" onClick={() => this.TabClick("CYCPURC")}>Purchase History</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="transactions-tab" data-toggle="tab" href="#transactions" role="tab" aria-controls="transactions" aria-selected="false" onClick={() => this.TabClick("CYCTRANS")}>Transactions</a>
                        </li>*/}
                </ul>
                {/* '[03/07/2023-PC_WW-643_14,Priyanka]*/}
                <div className="tab-content catalog-tab-content Catalog-Items" id="myTabContent">
                    <div className="tab-pane p-3 fade show active" id="alsofits" role="tabpanel" aria-labelledby="alsofits">
                        {this.state.alsoFits.length > 0 ? <div className="row">
                            <div className="table-responsive">
                                <table className="table ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            <th scope="col"><Trans>Manufacturer</Trans><span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "ASC", "Manufacturer")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "DESC", "Manufacturer")}><img src="Images/sort1.svg" /></span></th>
                                            <th scope="col"><Trans>Manufacturer Part#</Trans><span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "ASC", "Manufacturer_Part")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "DESC", "Manufacturer_Part")}><img src="Images/sort1.svg" /></span></th>
                                            <th scope="col"><Trans>Make</Trans><span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "ASC", "Make")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "DESC", "Make")}><img src="Images/sort1.svg" /></span></th>
                                            <th scope="col"><Trans>Model</Trans><span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "ASC", "Model")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.alsoFits, "DESC", "Model")}><img src="Images/sort1.svg" /></span></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.bindAlsoFits()}
                                    </tbody>
                                </table>
                            </div>
                        </div> : <div className="row mb-3">
                                <div className="col-md-12 col-lg-10 catalog-value"><Trans>No records found</Trans></div>
                            </div>}
                    </div>
                    <div className="tab-pane p-3 fade" id="catalog-details" role="tabpanel" aria-labelledby="catalog-details-tab">
                        <div className="row">
                            <div className="col-md-12">
                                {/*[WW-458]Binding Inventory tab for showing Bin location-Priyanka D*/}
                                {this.state.AttributeName != "-" && this.state.AttributeName != " " && this.state.AttributeValue != " " && this.state.AttributeName != null && this.state.AttributeValue != null && this.state.AttributeName != undefined && this.state.AttributeValue != undefined && this.state.AttributeName != "" && this.state.AttributeValue != "" ?
                                    this.BindAttribute() : <div className="row mb-3">

                                        <div className="col-md-12 col-lg-10 catalog-value"><Trans>No attributes available</Trans></div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                    <div className="tab-content tab-pane fade" id="item-detail" role="tabpanel" aria-labelledby="item-details-tab">
                        <div className="row">
                            {this.state.spec_sheet != "-" || this.state.doc_data_sheet != "-" || this.state.doc_install_operator != "-" || this.state.msds_sds != "-" || this.state.doc_parts != "-" || this.state.cad_drawing != "-" ?
                                this.BindLink() : <div className="row mb-3">
                                    <div className="col-md-12 col-lg-2 catalog-label"></div>
                                    <div className="col-md-12 col-lg-10 catalog-value"><Trans>No links available</Trans></div>
                                </div>}
                        </div>
                    </div>
                    {/*' PC_WW-641_06-Priyanka  D*/}
                    <div className="tab-pane p-3 fade d-none" id="Equ-Parts" role="tabpanel" aria-labelledby="Equ-Parts">
                        {this.state.equParts.length > 0 ? <div className="row">
                            <div className="table-responsive">
                                <table className="table ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            <th scope="col">Manufacturer<span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.equParts, "ASC", "Manufacturer")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.equParts, "equparts", "DESC", "Manufacturer")}><img src="Images/sort1.svg" /></span></th>
                                            <th scope="col">Manufacturer Part#<span className="sort-up-equ ml-1" onClick={(e) => this.Sorting(this.state.equParts, "ASC", "Manufacturer_Part")}><img src="Images/sort2.svg" /></span><span className="sort-down-equ ml-1" onClick={(e) => this.Sorting(this.state.equParts, "DESC", "Manufacturer_Part")}><img src="Images/sort1.svg" /></span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.bindEquParts("equParts")}
                                    </tbody>
                                </table>
                            </div>
                        </div> : <div className="row mb-3">
                                <div className="col-md-12 col-lg-10 catalog-value"><Trans>No equivalent parts available</Trans></div>
                            </div>}
                    </div>

                    <div className="tab-pane p-3 fade" id="item-detail" role="tabpanel" aria-labelledby="item-details-tab">
                        <div className="row">
                            <div className="table-responsive">
                                <table className="table table-hover ZEUS_Grid">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="position-sort-icon"><Trans>Owned By</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Owned", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Owned", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Store Room</Trans> <span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Store", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Store", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Store Room</Trans><span> </span><Trans>Description</Trans> <span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "StroeDescp", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "StroeDescp", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Replenish</Trans> <span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Replenish", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Replenish", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Reorder Paint</Trans> <span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Reorder", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Reorder", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Maximum</Trans> <span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Maxi", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Maxi", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"> <Trans>Quantity</Trans><span> </span><Trans>Available</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("1", "Quantity", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("1", "Quantity", "down")} /></span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.BindBUItems()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <h4 className="item-title"><Trans>Item</Trans><span> </span><Trans>more_key</Trans><span> </span><Trans>Details</Trans></h4>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Issue</Trans><span> </span><Trans>Charge</Trans><span> </span><Trans>Code</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.IssueChargeCode}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>First</Trans><span> </span><Trans>Charge</Trans><span> </span><Trans>Code</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.FirstChargeCode}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Hazard</Trans><span> </span><Trans>Code</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.HazardCode}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Inspection Required</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.InspectionRequired}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Equipment Tag</Trans><span>(ETAG) :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.EquipmentTag}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Regrind</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.Regrind}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Purchasing Dept Spec</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.PurchasingDept}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Machine Control Num</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.MachineControl}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Drawing</Trans><span> </span><Trans>Code</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.DrawingCode}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Machine Number</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.MachineNum}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Standard Leadtime</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.StandardLaedTime}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4 catalog-label"><Trans>Critical Spare</Trans><span> :</span></div>
                                    <div className="col-md-8 catalog-value">{this.state.CriticalSpare}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="usage" role="tabpanel" aria-labelledby="usage-tab">
                        <div className="row">
                            <div className="table-responsive">
                                <table className="table table-hover ZEUS_Grid usage-grid last-row-total">
                                    <thead>
                                        <tr>
                                            <th scope="col">Current Year</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Previous Year</th>
                                            <th scope="col">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.UsageTabBind()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="issues" role="tabpanel" aria-labelledby="issues-tab">
                        <div className="row">
                            <div className="table-responsive">
                                {this.state.IssueState.length != 0 ?
                                    <table className="table table-hover ZEUS_Grid">
                                        <thead>
                                            <tr>
                                                <th scope="col">Transaction Date</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Qty</th>
                                                <th scope="col">Emp ID</th>
                                                <th scope="col">Work Order</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Charge Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.IssueTabBind()}
                                        </tbody>
                                    </table> : <span><Trans>No records to display</Trans></span>}
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="bin-location" role="tabpanel" aria-labelledby="bin-location-tab">
                        <div className="row">
                            <div className="table-responsive">
                                {this.state.LocDataSetState.length > 0 ? <table className="table ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            {/* WW-534 Changed Inventory tab fields as in Mobile APP - [11/1/2022] Poornima S*/}
                                            <th scope="col"><Trans>Owner</Trans></th>
                                            <th scope="col"><Trans>Qty On Hand</Trans></th>
                                            <th scope="col"><Trans>Qty Available</Trans></th>
                                            <th scope="col"><Trans>Total Qty Reserved/Not Shipped</Trans></th>
                                            <th scope="col"><Trans>Area</Trans></th>
                                            <th scope="col"><Trans>Aisle</Trans></th>
                                            <th scope="col"><Trans>Row</Trans></th>
                                            <th scope="col"><Trans>Shelf</Trans></th>
                                            <th scope="col"><Trans>Bin</Trans></th>
                                            <th scope="col"><Trans>Defect Loc</Trans></th>
                                            <th scope="col"><Trans>Qty</Trans></th>
                                            <th scope="col"><Trans>Qty Reserved/Not Picked</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.BinLocationBind()}
                                    </tbody>
                                </table> : <div className="col-md-12 col-lg-10 catalog-value"><Trans>No records found</Trans></div>}
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="search-sites" role="tabpanel" aria-labelledby="search-sites-tab">
                        <div className="row">
                            <div className="table-responsive">
                                {this.state.MultiSiteDisplayState ? <table className="table table-hover ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            <th scope="col"><Trans>Item ID</Trans></th>
                                            <th scope="col"><Trans>Description</Trans></th>
                                            <th scope="col">UOM</th>
                                            <th scope="col">Qty Avail.</th>
                                            <th scope="col"><Trans>Site</Trans><span> </span><Trans>Name</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.MultiSiteBind()}
                                    </tbody>
                                </table> : <span><Trans>Related site data not available at this time.</Trans></span>}
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="purchase-history" role="tabpanel" aria-labelledby="purchase-history-tab">
                        <div className="row">
                            {this.state.PurchaseState ? <div className="table-responsive">
                                {this.state.PurchaseState.length > 0 ? <table className="table table-hover ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="position-sort-icon"><Trans>Item ID</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "ItemId", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "ItemId", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon">PO ID<span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "POID", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "POID", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"><Trans>Line</Trans><span> NBR</span><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "LineNBR", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "LineNBR")} /></span></th>
                                            <th scope="col" className="position-sort-icon"><Trans>Cancel</Trans><span> </span><Trans>Status</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "CancelStatus", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "CancelStatus", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"><span>PO</span><Trans>Date</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "PODate", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "PODate", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"><Trans>Quantity</Trans><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "Quantity", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "Quantity", "down")} /></span></th>
                                            <th scope="col" className="position-sort-icon"><Trans>Net Received</Trans><span> Qty</span><span className="sort-up ml-1"><img src="Images/sort2.svg" onClick={() => this.sortingColumns("2", "NetRec", "up")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={() => this.sortingColumns("2", "NetRec", "down")} /></span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.PurchaseTabBind()}
                                    </tbody>
                                </table> : <span><Trans>Related site data not available at this time.</Trans></span>}
                            </div> : null}
                        </div>
                    </div>
                    <div className="tab-pane p-3 fade" id="transactions" role="tabpanel" aria-labelledby="transactions-tab">
                        <div className="row">
                            {this.state.TransTableState ? <div className="table-responsive">
                                {this.state.TransTableState.length > 0 ? <table className="table table-hover ZEUS_Grid usage-grid">
                                    <thead>
                                        <tr>
                                            <th scope="col"><Trans>Transaction</Trans><span> </span><Trans>Date</Trans></th>
                                            <th scope="col">UOM</th>
                                            <th scope="col">Qty</th>
                                            <th scope="col"><Trans>Group</Trans></th>
                                            <th scope="col"><Trans>order_key</Trans><span> #</span></th>
                                            <th scope="col"><Trans>Line</Trans><span>  #</span></th>
                                            <th scope="col">PO #</th>
                                            <th scope="col"><Trans>workorder_key</Trans></th>
                                            <th scope="col"><Trans>Operator Entered By</Trans></th>
                                            <th scope="col">Trans OperID</th>
                                            <th scope="col"><Trans>Store Room</Trans></th>
                                            <th scope="col"><Trans>Store Room</Trans><span> Desc</span></th>
                                            <th scope="col"><Trans>Receiver</Trans><span> </span><Trans>ID</Trans></th>
                                            <th scope="col"><Trans>Receiver</Trans><span> </span><Trans>Line</Trans></th>
                                            <th scope="col"><span>PO </span><Trans>Line</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.TransTabBind()}
                                    </tbody>
                                </table> : <span><Trans>Related site data not available at this time.</Trans></span>}
                            </div> : null}
                        </div>
                    </div>
                </div>
                {/*[2/28/22], PC_IC_07, WW-316, Dhevanesam R*/}
                {/*//[09/29/22, WAL-780_PC_IDSC_03, Dhevanesam R]*/}
                {/*{this.state.ImgResponseVal.length > 0 ?
                    <div className="CarouselIpadMiniView">
                        <div>
                            <h5 className="catalog-label-title mb-3 mt-3">Related Items</h5>
                        </div>
                        <Carousel cols={this.state.ColumnsCarousel} rows={1} loop hideArrow={this.state.HideCarouseArrow}>
                            {this.BindImageGrid()}
                        </Carousel>
                    </div> : null}*/}
                {this.state.ImgResponseVal.length > 0 ? <div>
                    <div>
                        <h5 className="catalog-label-title mb-3 mt-3"><Trans>User also bought</Trans></h5>
                    </div>
                    <div className="col-md-12 owl-carousel owl-theme owl-loaded owl-drag">
                        <div className="owl-stage-outer">
                            <div className={this.state.ImgCssVal}>
                                {this.BindImageGrid()}
                            </div>
                        </div>
                        {/*<div className="owl-nav"><button type="button" role="presentation" className="owl-prev"><span aria-label="Previous"><img src="Images/Prev-arrow.svg" alt="Previous" /></span></button><button type="button" role="presentation" className="owl-next"><span aria-label="Next"><img src="Images/next-arrow.svg" alt="Next" /></span></button></div>*/}
                        <div className="owl-dots disabled" /></div>
                    {/*end of image card*/}
                </div> : null}
                {/** WW-522_PC_06 (12/14/2022)-Aparna*/}
                {this.state.AlternateParts.length > 0 ? <div>
                    <div className="CarouselIpadMiniView">
                        <div>
                            <h5 className="catalog-label-title mb-3 mt-3"><Trans>Alternate Parts</Trans></h5>
                        </div>
                        <Carousel cols={this.state.ColumnsCarousel} rows={1} loop hideArrow={this.state.AlternateParts.length > 5 ? false : true}>
                            {this.bindAlternatepart()}
                        </Carousel>
                    </div>
                </div> : null}
                <div className="modal" id="extended-client">
                    <div className="modal-dialog custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Extended Client Description</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <label className="extended-label d-block"></label>
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="extended-content d-block">
                                            {this.state.ExtentDescription}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* //WW - 1216 Precart - Yuvarani K */}

                { /*[11/21/2024 Rating popup */}
                <div className="modal" id="RatingPopup">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="">
                                        <p style={{ "fontSize": "large" }}><b><Trans>Please rate this item</Trans></b></p>
                                        <div className="text-center" style={{ "marginBottom": "8px" }}>
                                            <Rating
                                                value={this.state.StarRating}
                                                max={5}
                                                onChange={(value) => this.Rating(value)}
                                            />

                                        </div>



                                        {/*[10/11/22,WW-521-Implementation of Character counter], Priyanka D */}

                                    </div>
                                    <div className="col-md-12">
                                        <textarea className="col-md-12 form-control custom-textarea " id="decreasoncmt" maxLength="254" placeholder={t("Write a review")} style={{ "height": "80px" }} onChange={(e) => this.HandleReview(e)} value={this.state.Review}></textarea>

                                    </div>
                                </div>

                                <div className="col-md-12 text-center mb-2 mt-2">

                                    <span><button className={`btn btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} onClick={(e) => this.CloseRatingPopup(e)} style={{ "marginRight": "7px", "borderColor": "gray", "backgroundColor": "gray", "color": "white" }} ><Trans>Cancel</Trans></button></span>

                                    <span> <button className={`btn btn-primary custom-btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} disabled={this.state.StarRating == 0} onClick={(e) => this.RatingSubmission(e)}><Trans>Submit</Trans></button></span>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { /*[11/21/2024 Rating popup ends*/}





                {/*Favourite Item Pop up*/}
                <div className="modal" id="add-fav-popup" data-backdrop="static" data-keyboard="false">

                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Add</Trans><span> </span><Trans>to favorite item</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 edit-desc-field mb-3">
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Item ID</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavItemId" >{this.state.FavMFGPartNUMPopUp}</label>
                                        </div>
                                        {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Manufacturer</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavMFG" >{this.state.FavMFGPopUp}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label indicate-alert"><Trans>Category</Trans></label>
                                            {/*<div className="col-md-7">
                                            <textarea className="form-control custom-textarea" id="FavYourCatg" maxLength="40" rows={3} defaultValue={''} />
                                        </div>*/}
                                            {/**WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna*/}
                                            <div className="float-left search-autocomplete col-md-7 home-search" style={{ zIndex: "9999" }}>
                                                {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.autocompleteDataRstl}
                                                    renderItem={this.renderItem}
                                                    value={this.state.FavYourCatg}
                                                    onChange={e => this.onChange(e, "Cat")}
                                                    onSelect={e => this.onSelect(e, "Cat")}
                                                    inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                    maxLength="40"
                                                />
                                                <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />

                                                {this.state.CategoryErr ? <span className=" W-100 errorspan text-left " style={{ fontSize: '15px' }}>Enter Category</span> : null}
                                            </div>


                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label indicate-alert"><Trans>Sub Category</Trans></label>
                                            {/*<div className="col-md-7">
                                            <textarea className="form-control custom-textarea" id="FavYourCatg" maxLength="40" rows={3} defaultValue={''} />
                                        </div>*/}
                                            {/**WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna*/}
                                            <div className="float-left search-autocomplete col-md-7 home-search">
                                                {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.subCategoryResults}
                                                    renderItem={this.renderItem}
                                                    value={this.state.FavSubCategory}
                                                    onChange={e => this.onChange(e, "Subcat")}
                                                    onSelect={e => this.onSelect(e, "Subcat")}
                                                    inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                    maxLength="40"
                                                />
                                                <span className="errorspan1" style={{ fontSize: '10px' }} id="favordsubcatid" />
                                                {this.state.SubCategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}><Trans>Enter Sub Category</Trans></span> : null}
                                            </div>


                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavItemDescrip" >{this.state.FavItemDescripPopUp}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                                            <div className="col-md-7">
                                                <textarea className="form-control custom-textarea" id="FavYourDescrip" maxLength="100" rows={5} defaultValue={''} />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Supplier</label>
                                            <label className="col-md-7 quick-value" id="FavMFG" >{this.state.FavSupplierPopUp}</label>
                                        </div>
                                        <div className="row mb-3">
                                            {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                            <label className="col-md-5 quick-label"><Trans>Supplier part#</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavMFGPartNUM" >{this.state.FavItemIdPopUp}</label>
                                        </div>

                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><span><Trans>Choose Your Own image</Trans></span></label>
                                            <div className="col-md-7 input-group">
                                                <input type="file" title=" " accept="image/jpeg, image/png" style={{ "font-size": "10px" }} id="customFile" name="filename" onChange={this.FavItemhandleAttachment} onClick={(event) => { event.target.value = null }} />
                                                <label className="custom-file-label mx-3 sdi-font-12" htmlFor="customFile"><Trans>Choose File</Trans></label>
                                                {this.bindAttachments()}
                                                <label className="priority-alert mt-3" id="lblerror">{this.state.lblerror}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" id="FavSaveBtn" onClick={() => this.AddfavItem(false)}><Trans>save_key</Trans></button>
                                    </div>
                                    <div>
                                        <label id="txtUOMHide" >{this.state.txtUOMHidePopUp}</label>
                                        <label id="txtMfgItemidHide" >{this.state.txtMfgItemidHidePopUp}</label>
                                        <label id="txtItemidHide" >{this.state.txtItemidHidePopUp}</label>
                                        <label id="txtMFGHide" >{this.state.txtMFGHidePopUp}</label>
                                        <label id="ItemType" >{this.state.ItemTypeFav}</label>
                                    </div>
                                </div>
                            </div>
                            {/*Cheaper Item*/}

                        </div>
                    </div>
                </div>
                {/*[1/3/21], PC_ID_15, WW-286, Dhevanesam R*/}
                {/*Core Charge Pop Up*/}
                <div className="modal" id="image_modal">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Item Image Detail</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                               </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <ImageGallery ref={this.imageGalleryRef} items={this.state.ItemImage} onClick={this.zoomClick} startIndex={this.state.currentImageIndex}
                                    showPlayButton={false} fullscreen={true} additionalClass="custom-fullscreen" showIndex={this.state.showIndex} onThumbnailError={"/Images/noimage_new.png"} onErrorImageURL={"/Images/noimage_new.png"} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="CoreChargePopUp" tabIndex={-1}
                    role="dialog"
                    ari=""
                    overflow-autoa-hidden="true">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}><Trans>Cancel</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => {
                                            {/* //WW - 1216 Precart - Yuvarani K */ }

                                            if (localStorage.getItem("pickupcheck") == true || pickUp == true) {
                                                this.CoreChargeProceedClick()
                                            }
                                            else {
                                                this.TradeServiceAddClick(e, this.state.FavItem, true, false, true);
                                            }
                                        }
                                        }><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/*cheaper items*/}
                <div className="modal" id="CheaperItemPopup" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.cheaperpopupclose}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className=" modB">
                                <div className="row">
                                    <div className="col-md-6 ">
                                        <label className="" style={{ marginLeft: '3rem', fontWeight: '600' }}><Trans>Cheaper Item</Trans></label>
                                        <div className="row mb-1 py-2 ml-4 " >
                                            <div className="order-summary-image category-search-image mx-4" style={{ width: '200px', height: 'fit-content', maxHeight: '290px' }}>
                                                <button className="border image-background px-0 " style={{ height: '100px' }}>

                                                    <Image
                                                        src={this.state.CheaperItem.ThumbnailImagefile}
                                                        width={90}
                                                        height={85}
                                                        style={style.image}
                                                        id="ex-img"
                                                        noImageSrc="/Images/noimage_new.png"
                                                    />
                                                </button>
                                            </div>
                                            <div className="col-md-12  mobile-catalog mobile-catalog-search " style={hei}>
                                                <div className="row" style={{ marginLeft: '-10px' }}>
                                                    <div className="col-lg-12 mx-1 p-0 search-content">
                                                        <div className="col-md-12 float-left content-spacing">
                                                            <span className="fav-item-title"><a href="#" className="float-left mt-2 category-id category-search-id" onClick={(e) => this.showitemdetails(e)}>{this.state.CheaperItem.customerPartnumber_CatalogZero}</a>
                                                            </span>
                                                        </div>
                                                        <label className="col-md-12 item-details-value content-width float-left">
                                                            {this.state.DescriptionType == "1" ? this.state.CheaperItem.longdescriptionone != "\N" || this.state.CheaperItem.longdescriptionone != null ? this.state.CheaperItem.longdescriptionone : "NA" : "NA"}

                                                        </label>
                                                        <div className="col-md-12 float-left">
                                                            <div className="row" style={{ marginLeft: '-15px' }}>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label">MFG:</label>
                                                                    <label className="item-details-value">{this.state.CheaperItem.manufacturer}</label>
                                                                </div>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label"><span>MFG </span><Trans>part number</Trans><span>:</span></label>
                                                                    <label className="item-details-value">{this.state.CheaperItem.manfPartNumber}</label>
                                                                </div>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label">UOM:</label>
                                                                    <label className="item-details-value">{this.state.CheaperItem.UOM}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 float-left">
                                                            <span className="catalog-label"><Trans>Supplier</Trans><span>:</span><span className="mx-1">{this.state.CheaperItem.supplierName}</span>
                                                            </span>

                                                        </div>
                                                        <div className="col-md-12 float-left">
                                                            <div className="mt-2">
                                                                <span className="float-left mt-2 price-calc">Qty:</span>
                                                                {/*[12/13/21, PC_IDC_02, WW-275- Added Inc & decr for qty in cheaper item popup, Poornima S]*/}
                                                                <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                                    <input type="button" value="-" class="minus" onClick={(e) => this.handleProfileFormChange(e, "yes")} style={{ "backgroundColor": "white" }} />
                                                                    <input type="number" step={this.state.CheapItemMinQty} class="minus" min={this.state.CheapItemMinQty} max={this.state.CheapItemMaxQty} name="quantity" name="Quantityvalue" id="QuantityTxtCheap" value={this.state.CheaperItemQty} onChange={(e) => this.CheaperItemQtyChange(e)} title="Qty" size="4" pattern="" inputmode="" style={{ "width": "45%", "borderLeft": "0" }} />
                                                                    <input type="button" value="+" class="plus" onClick={(e) => this.handleProfileFormChange(e, "yes")} style={{ "backgroundColor": "white" }} />

                                                                    .</div>
                                                                {/*input type="text" value={this.state.CheaperItemQty == null || this.state.CheaperItemQty == "" ? "" : this.state.CheaperItemQty} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.CheaperItemQtyChange(e)} />*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-right mb-2 mt-2" style={{ bottom: "0px" }}>
                                            <div className="float-left  ml-4 mr-5">
                                                {/*[1/3/21], PC_ID_15, WW-286, Dhevanesam R*/}
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-4 ml-2 float-left" onClick={(e) => this.AddToCart(true, "CoreCharge", "Addtocart")}><Trans>Add To Cart</Trans></button>

                                            </div>
                                        </div>

                                    </div>
                                    {/* <div className="col-md-6">
                                <div className="col-md-12 text-right mb-2 mt-2">
                                   
                                    
                                </div>
                                   </div>
                                {/****expensive item****/}
                                    <div className="col-md-6 ">
                                        <label className="" style={{ marginLeft: '3rem', fontWeight: '600' }} >Item you choose</label>
                                        <div className="row mb-1 py-2 ml-4 "  >
                                            <div className=" order-summary-image category-search-image mx-4" style={{ width: '200px', height: 'fit-content', maxHeight: '290px' }}>
                                                <button className="border image-background px-0 " style={{ height: '100px' }}>

                                                    <Image
                                                        src={this.state.ImageURL}
                                                        width={90}
                                                        height={85}
                                                        style={style.image}
                                                        id="cheaper-img"
                                                        noImageSrc="/Images/noimage_new.png"
                                                    />
                                                </button>
                                            </div>
                                            <div className="col-md-12   mobile-catalog mobile-catalog-search " style={hei}>
                                                <div className="row" style={{ marginLeft: '-10px' }}>
                                                    <div className="col-lg-12 mx-1 p-0 search-content">
                                                        <div className="col-md-12 float-left content-spacing">
                                                            <span className="fav-item-title">{this.state.ItemId}
                                                            </span>
                                                        </div>
                                                        <label className="col-md-12 item-details-value content-width float-left">
                                                            {this.state.DescriptionType == "1" ? this.state.ItemDescription != "\N" || this.state.ItemDescription != null ? this.state.ItemDescription : "NA" : "NA"}
                                                        </label>
                                                        <div className="col-md-12 float-left">
                                                            <div className="row" style={{ marginLeft: '-15px' }}>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label">MFG:</label>
                                                                    <label className="item-details-value">{this.state.ItemManufacturerName}</label>
                                                                </div>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label"><span>MFG </span><Trans>part number</Trans><span>:</span></label>
                                                                    <label className="item-details-value">{this.state.ItemMFGPartNumber}</label>
                                                                </div>
                                                                <div className="col-md-12 search-category-field">
                                                                    <label className="catalog-label">UOM:</label>
                                                                    <label className="item-details-value">{this.state.ItemUOM}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 float-left">
                                                            <span className="catalog-label"><Trans>Supplier</Trans><span>:</span><span className="mx-1">{this.state.ItemSupplierName}</span>
                                                            </span>

                                                        </div>
                                                        <div className="col-md-12 float-left">
                                                            <div className="mt-2">
                                                                <span className="float-left mt-2 price-calc">Qty:</span>
                                                                <span className="float-left mt-2 price-calc">{this.state.Quantityvalue}</span>
                                                                {/* <input type="text" value={this.state.SelectedItemForCheaper.QuantityOrdered == null || this.state.SelectedItemForCheaper.QuantityOrdered == "" ? "" : this.state.SelectedItemForCheaper.QuantityOrdered} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.AddOrder(e, this.state.cheaperIndex, this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.manfPartNumber, this.state.SelectedItemForCheaper.manufacturer, this.state.cheaperItem.ItemPrice, "yes")} />*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-right mb-2 mt-2" style={{ bottom: "0px" }}>

                                            <div className="float-left  ml-4">
                                                {/*[1/3/21], PC_ID_15, WW-286, Dhevanesam R*/}
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 float-left ml-2" data-dismiss="modal" onClick={(e) => this.AddToCart(false, "CoreCharge", "")}><Trans>Proceed with this item</Trans></button>

                                            </div>
                                        </div>

                                    </div>
                                    {/***END**/}

                                    {/* <div className="col-md-12 text-right mb-2 mt-2">
                                        <div className="float-left col-md-5 ml-4 mr-5">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-4 float-left" onClick={(e) => this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1", "cheap-yes")}>Add To Cart</button>

                                        </div>
                                    <div className="float-left col-md-5 ml-4">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 float-left" data-dismiss="modal" onClick={(e) => { this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, "no"); this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1"); }}>Proceed with this item</button>

                                        </div>
                                    </div>*/}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="EnersysEmployee" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content" style={{ "marginLeft": "78px" }}>
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}

                            <div className="text-center my-4">
                                <span className="info-label">{this.state.EnersysEmp}</span>
                            </div>


                            <div className="col-md-12 text-right mb-4">
                                <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn px-4 mr-2" data-dismiss="modal" onClick={e => this.EnersysyEmp("No")}>No</button>{/*[01/30/22, PC_EF_05, Priyanka.D]*/}
                                <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={e => this.EnersysyEmp("Yes")}>Yes</button>{/*[01/30/22, PC_EF_05, Priyanka.D]*/}
                            </div>
                        </div>
                    </div>
                </div>
                {/*[04/18/22,PC_WW-386_03], Priyanka D */}
                <div className="modal" id="alertpopup" >
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <button type="button" className="btn close-btn bg-white" style={{ "marginTop": "7px", "float": "right", "marginLeft": "437px" }} data-dismiss="modal">
                                X
                                 </button>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <div className="text-center my-4">
                                            <span className="info-label"><Trans>Things to be noted while uploading an Image</Trans></span>
                                            <div>
                                                <div className="info-label edit-label"><Trans>1.Size should be large</Trans></div>
                                                <div className="info-label edit-label"><Trans>2.Background must be black/white</Trans></div>
                                                <div className="info-label edit-label"><Trans>3.Should not contains any watermarks</Trans></div>
                                                <div className="info-label edit-label"><Trans>4.Should contains only one part per image</Trans></div>
                                                <div className="info-label edit-label"><Trans>5.Should not be a hand held picture</Trans></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*[04/06/22WW-370] Reorder popup should come after the Multiple supplier popup Priyanka D */}
                                <div className="col-md-12 text-center mb-2">
                                    {/*<input type="file" multiple className="custom-file-input" title=" " accept="image/jpeg, image/png" id="nAttachments" name="filename" onChange={this.handleAttachment} 
                                         */}
                                    <label class="custom-file-upload">
                                        <input type="file" title=" " accept="image/jpeg, image/png" id="customFile" name="filename" style={{ "display": "none" }} onClick={this.onInputClick} onChange={this.handleAttachment} />
                                        <Trans>Proceed</Trans>
                                          </label>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="NotanEnersysEmp" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content" style={{ "marginLeft": "78px" }}>
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}

                            <div className="text-center my-4">
                                <span className="info-label"><Trans>Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause</Trans></span>
                            </div>


                            <div className="col-md-12 text-center mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={e => this.NotAnEnersysyEmp()}>Ok</button>{/*[01/30/22, PC_EF_07, Priyanka.D]*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="add-fav-Img">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to add Image for this item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddfavItem(true)} ><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.BindFavForm(this.state.favexist, "Yes")}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className=" modal modal-shipment-method" id="Delivery_MethodItemDetail" data-backdrop="static" data-keyboard="false" aria-modal="true">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content" style={{ width: "74%" }}>
                            {/* Modal Header */}
                            <div className=" modal-title mt-3 modal-shippingmethod-header">

                                <h4 className="modal-title shipmehtod-title mt-1 ml-2" style={{ display: "inline" }}><Trans>Shipment Method</Trans></h4>
                                <button type="button" className="btn close-btn background-ship mr-2" data-dismiss="modal" style={{ float: "right" }} onClick={() => this.shpCloseClk()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}

                            <div className="modal-body  pt-0">
                                <div className="col-12 p-0 mt-2">
                                    <label className="custom-radiobtn pb-3 mb-0"><Trans>Pickup</Trans>

                                        <input type="radio" id="pickupitemdetail" checked={this.state.pickUp} name="ship2" onChange={() => this.pickupchange(0)} />
                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                    </label>
                                    <label className="custom-radiobtn"><Trans>Ship To</Trans>
                                        <input type="radio" id="deliveryshiptoitemdetail" checked={this.state.deliveryShipTo} name="pick2" onChange={() => this.pickupchange(1)} />

                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "3px" }} />

                                    </label>
                                    <div>
                                        <img className="mr-2 " src="Images/info-icon.png" />
                                        <label className="confirm-content shipment-font">{`Search results will be based on your selection`}</label>
                                    </div>

                                    {/*<label className="confirm-label d-block">{this.state.Pick}</label>*/}


                                </div>
                                <span id="shipmentmethoderrorid" className="DropDown-Font-Size errorcolour"><Trans>{this.state.shipmentmethoderrorid}</Trans></span>
                                <div className="col-md-12 mt-2 text-right p-0">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3 mt-3" data-dismiss="modal" onClick={() => this.shpCloseClk()}><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 mt-3" id="subdecbtn"

                                        onClick={(e) => {
                                            if (itemDetailPickup == true || pickUp == true || this.state.cart_bypass == "Y") {
                                                this.AddToCartOrFavClick("Add To Cart", ItemDetailsValue, 0, false, this.state.ReasonType, this.state.Comments)
                                            }
                                            else {
                                                this.TradeServiceAddClick(e, this.state.FavItem, false, true, false)
                                            }
                                        }} onKeyDown={this.searchKeyPress} ><Trans>Apply</Trans></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/**********NEW*****************/}

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="ItemDetailMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    <Trans>Confirmation</Trans>
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

            </div>
        );
    };
};
export default withTranslation()(ItemDetailNew);
